/**
 *
 * @type {typeof import("./zh_TW")}
 *
 */
module.exports = {
	'global.normal': {
		'add': 'Add',
		'modify': 'Modify',
		'update': 'Update',
		'cancel': 'Cancel',
		'view': 'View',
		'config': 'Set',
		'edit': 'Edit',
		'delete': 'Delete',
		'refresh': 'Refresh',
		'export': 'Export',
		'exportInfo': 'Export data',
		'sendOut': 'Submit',
		'pleaseSelect': 'Select',
		'startTime': 'Start time',
		'endTime': 'End time',
		'sure': 'Confirm',
		'close': 'Close',
		'show': 'Display',
		'informal': 'Not specified',
		'normal': 'Normal',
		'abnormal': 'Anomalous',
		'remove': 'Remove',
		'today': 'Today',
		'disable': 'Deactivate',
		'enable': 'Activate',
		'error': 'Error',
		'noInfo': 'No data available',
		'finish': 'Complete',
		'correct': 'Correct',
		'yes': 'Yes',
		'no': 'No',
		'departmentName': 'Department',
		'staff': 'Staff ID',
		'name': 'Name',
		'employeeNumber': 'Staff ID',
		'addANewStroke': 'Add an entry',
		'all': 'All',
		'dept': 'Dept.',
		'viewBtn': 'View',
		'selectAll': 'Select all',
		'january': 'January',
		'february': 'February',
		'march': 'March',
		'april': 'April',
		'may': 'May',
		'june': 'June',
		'july': 'July',
		'august': 'August',
		'september': 'September',
		'october': 'October',
		'november': 'November',
		'december': 'December',
		'weekToNum1': 'Mon.',
		'weekToNum2': 'Tue.',
		'weekToNum3': 'Wed.',
		'weekToNum4': 'Thur.',
		'weekToNum5': 'Fri.',
		'weekToNum6': 'Sat.',
		'weekToNum7': 'Sun.',
	},
	'components.grids': {
		'fetchErrMsg': 'Data reading error',
		'emptyWarning': 'No data meets the search criteria. Please search again with looser search criteria.',
		'sureDeleteIt': 'Are you sure you want to delete?',
		'deleteCountMsg': 'Are you sure you want to delete <%=count%> records?',
		'successCount': ' (<%= success %> entry successful',
		'successCounts': ' (<%= success %> entries successful',
		'failCount': '，<%= fail %> entry failed',
		'failCounts': '，<%= fail %> entries failed',
		'usedCount': '，<%= used %> entry in use',
		'usedCounts': '，<%= used %> entries in use',
		'errorCount': '，<%= unexpected %> entry with error',
		'errorCounts': '，<%= unexpected %> entries with error',
		'simpleSearch': 'Simple search',
		'advancedSearch': 'Advanced search',
		'advancedSearchConfig': 'Setting advanced search criteria',
		'counditionCount': '<%= count %> criteria',
		'allCount': '<%= count %> entry in total',
		'allCounts': '<%= count %> entries in total',
		'matchFewCount': '<%= count %> entry meets the criteria',
		'matchFewCounts': '<%= count %> entries meet the criteria',
	},
	'components.utils': {
		'today': 'Today',
		'to': 'to',
		'noInfo': 'No information available',
		'seeMore': 'View more',
	},
	'hp.home': {
		'hello': ' Hello',
		'noAnnouncementYet': 'No announcement',
		'noNotifictionItemYet': 'No notification',
		'gettingpaid': 'Getting Paid!',
		'notice': 'Due to the regulations of protection of personal data, the usage of employee data can not be leaked or authorized illegally to third parties.',
		'know': 'Noted',
	},
	'hp.m5.m510010.form': {
		'programError': 'Bug',
		'noApplicationPermission': 'You no longer have request permission. Please reconfirm.',
		'youNeedToUploadAtLeast': 'At least one attachment should be uploaded',
		'theSignoffProcess': 'As no approval process is generated, the form cannot be activated.',
		'failedToWriteToForm': 'Form writing failed.',
		'attachmentUpdateFailed': 'Attachment update failed.',
		'enterAReasonUpToWords': 'Enter the reason, up to <%=max%> words.',
		'attachmentLabel': 'Attachment',
		'youDoNotCurrentlyHaveAnyDataToChangeYourTimeOfDuty': 'You currently have no changeable leave data.',
		'atPresentTheSystemAllows': 'No leave data is available within the period when changes are allowed by the system.',
		'allAppliedLeaveInformationMustWait': 'All submitted leave data may be changed only after approval completion.',
		'clickTheButtonBelowToSee': 'Click the following button to check the approval progress.',
		'understandSignoffProgress': 'Check the approval progress.',
		'lastMonth': 'Last month',
		'thisYear': 'This year',
		'originalApplicationTime': 'Originally requested time is from <%=start%> to <%=end%>.',
		'actualResults': 'Actual result:',
		'noNeedToJudge': 'No determination is required.',
		'judgingCardInformation': 'Determine clock-in/out data.',
		'remindYou': 'Reminder',
		'pleaseHelpMeAdjust': 'I am sure I want to make the adjustment.',
		'effectiveDate': 'Effective date',
		'clearReselection': 'Remove and reselect',
		'failedToLoadDataBeforeThe': 'Loading of data before change failed.',
		'project': 'Item',
		'beforeTheChange': 'Before change',
		'afterTheChange': 'After change',
		'changeTheProject': 'Changed item',
		'totalItems': '<%=temp1%> item<%=temp2%> in total',
		'changePersonnel': 'Changed by',
		'pleaseEnterANumericType': 'Please enter a numeric type.',
		'mustBeLessThan': 'Less than <%=num%>',
		'mustBeGreaterThan': 'More than <%=num%>',
		'pleaseEnterANumber': 'Please enter a number.',
		'required': 'Required',
		'pleaseSelectOvertimeFirst': 'Please select the time of overtime.',
		'otherOvertimeRulesLoadedIncorrectly': 'Error in loading other overtime rules.',
		'overtimeHoursIs0PleaseReselectOvertime': 'The total overtime hours are 0. Please reselect the time of overtime.',
		'pleaseEnterAStartAndEndTime': 'Please enter the start and end time.',
		'actualAndHoursResultsThatComplyWithCompanyOvertimeRules': 'The time of overtime you requested will be adjusted to generate the actual time and hours that meet the company’s overtime rules after being compared with your attendance data by the system.',
		'pleaseReselectOvertime': 'Please reselect the time of overtime.',
		'overtimeCheckError': 'Overtime error detected',
		'actualResultsAdjustedToComplyWithCompanyHoursOfOvertimeRules': 'The hours you requested have been adjusted to meet the company’s overtime rules. Originally requested time is from <%=otStart%> to <%=otEnd%>. ',
		'companyOvertimeCategoryRules': 'The system classifies the time of overtime you entered according to the company’s overtime classification rules as follows.',
		'simultaneousRelease': 'Simultaneous distribution',
		'overtimePay': 'Overtime pay',
		'compensatoryLeave': 'Compensatory time',
		'costCenterItem': '(Cost center <%=name%> Overtime pay <%=otName%> Compensatory time  <%=calName%>)',
		'noCostCenterItem': '<%=name%> Overtime pay <%=otName%> Compensatory time  <%=calName%>',
		'attachmentWriteError': 'Attachment writing error.',
		'serverError': 'Server error.',
		'totalHours': 'Total hours',
		'costCenter': 'Cost center',
		'typeNoLongerOpen': 'Such request type is unopened of ',
		'deduction': 'be deducted',
		'notDeduction': 'not be deducted.',
	},
	'hp.m5.m510010.wf030': {
		'cannotRepeatTime': 'No request time conflict is allowed.',
		'applicant': 'Applicant',
		'forgetTheSwipeTime': 'Missed clock-in/out time',
		'forgotToBrushTheReason': 'Reason for missed clock-in/out',
	},
	'hp.m5.m510010.wf050': {
		'theLeaveCheckHasNotBeenPassed': 'Leave resumption check failed.',
		'failedToWriteToTheFakeMasterFile': 'Master leave resumption file writing failed.',
		'theApplicationForAFakeSlipFailed': 'Leave resumption form submission failed.',
		'theProjectLoadingErrorCanBeChanged': 'Changeable leave item loading error.',
		'obtainingFalseAttendanceErrors': 'Leave retrieval error.',
		'noneMessage': 'None <%=temp1%> <%=temp2%> <%=temp3%>',
		'falseAttendanceDataError': 'Leave data error: <%=temp1%>',
		'theStartDateOfTheLeave': 'Leave start date',
		'endOfLeaveDay': 'Leave end date',
		'leaveProject': 'Leave item',
		'cancelType': 'Cancel type',
		'leaveCancelTime': 'Leave resumption',
	},
	'hp.m5.m510010.wf010': {
		'theLeaveSlipApplicationFailed': 'Leave request form submission failed.',
		'theLeaveCheckHasNotBeen': 'Leave check failed',
		'failedToWriteToTheFake': 'Master leave file writing failed.',
		'pleaseSelectTheTimeOfAbsence': 'Please select leave time first.',
		'fakeProjectLoadingError': 'Leave item loading error.',
		'pleaseEnterAStartAndEnd': 'Please enter the start and end time.',
		'getTheErrorOfTheDay': 'Event date retrieval error.',
		'falseAttendanceCalculationError': 'Leave calculation error.',
		'pleaseSelectTheLeaveItemFirst': 'Please select leave item first.',
		'cancelTheDateOnWhichThe': 'Cancel the adding of an event date.',
		'theNewEventOccurredOnA': 'Add an event date.',
		'selectTheDateOnWhichThe': 'Select request event date.',
		'servedAsAgentForOtherColleagues': 'Has been a substitute for another employee during the leave time, in part or in whole.',
		'issueHint': 'Must be a multiple of <%=X%> <%=Y%>. After submission, the attendance hours will be automatically adjusted.',
		'startDateMustBeforeEndDate': 'Start date should be earlier than end date.',
	},
	'components.Dialog': {
		'correctInformation': 'Correct data',
		'confirmTheImport': 'Confirm the import',
		'fileErrorTheFileFormatMust': 'File error: The file format is required to be Excel(.xlsx). Maximum file size: 10 MB.',
		'fileNameNotContainSpecialChar': 'File name should not contain special characters, such as \\ / : * ? " < > | # % &.',
		'errorMsg': 'Error message',
		'exceptionDescription': 'Exception description',
		'dateFormatError': 'The date format does not match.',
		'importDataError': 'Incorrect data import',
		'importSuccess': 'Export completed.',
		'verificationResult': '(Verification result)',
		'correct': 'Correct',
		'fieldCountError': 'A total of <%= count %> fields with error',
		'anomalousData': 'Anomalous data',
		'downloadErrorData': 'Download error data',
		'importResult': '(Import result)',
		'importCompleted': 'Import Completed',
		'importCount': 'Number of data successfully imported',
		'importCompletedCloseWindow': 'Import completed. Close the window.',
		'exportCompleted': 'Export completed.',
		'exportFailed': 'Export failed',
		'note': 'Note',
		'fileUploadFailed': 'File upload failed, please try again.',
		'invalidFileFormat': 'Invalid file format, please upload again.',
		'uploadFailed': 'Uploading failed',
		'importFailed': 'Import failed',
		'fieldReminders': 'There are <%= count %> field reminders',
	},
	'components.Dialogs': {
		'identifyAdditions': 'Confirm',
		'newInProgress': 'Adding',
		'theWindowDoesNotCloseAfter': 'The window remains opened after adding.',
		'identifyModifications': 'Confirm',
		'underModification': 'Modifying',
		'notEntered': '(Not entered)',
		'thisInformationCannotBeViewed': 'This data entry cannot be viewed.',
		'editTheProfile': 'Edit data',
		'modifyTheJourney': 'Modify history',
		'previousStep': 'Last step',
		'next': 'Next step',
		'unableToLoadLongJobInformation': 'Information of long operations cannot be loaded.',
		'pleaseClickToSelectTheImport': 'Please “click” “Select the file to import” or “drag” the file here for import.',
		'theFileFormatIsIncorrect': 'File format error or size more than 10 MB.',
		'nonExistentFormat': 'Format does not exist: <%=temp1%>',
		'fileNamesCannotContainSpecialCharacters': 'File name should not contain special characters \\/*?"<>|#%&. ',
		'theAssignmentHasEndedPlease': 'The operation has ended. Please refresh and try again.',
		'importTheResults': 'Import result',
		'numberOfSuccesses': 'Number of files successfully imported:',
		'numberOfFailures': 'Number of files failing to import:',
		'closeTheWindow': 'Close the window',
		'downloadFailedData': 'Download failure data',
		'thatSRight': 'Correct',
		'totalFieldErrors': 'A total of <%=temp1%> fields with error.',
		'verifyTheStatus': 'Verification status',
		'correctData': 'Correct data:',
		'processing': 'Processing',
		'theDownloadIsComplete': 'Download completed',
		'confirmTheDownload': 'Confirm download',
		'confirmTheDownloadUS': 'Confirm',
		'downloading': 'Downloading...',
		'errorFreeDataIsAvailableFor': 'No failure data available for download.',
		'fail': 'Failed',
		'succeed': 'Successful',
		'noData': 'No data available:<%=temp1%>',
		'partialImport': 'Partial import',
		'importAll': 'Full import',
		'cancelTheImport': 'Cancel import',
		'abnormalData': 'Anomalous data: <%=temp1%>',
		'downloadErrorData': 'Download error data',
		'ifThereIsNoDataIn': 'There is no data in the file you uploaded. Please select and upload other files.',
		'afterPreviewingTheFirst': 'The above is a preview of the first 10 data entries (excluding headings) in the file you uploaded. After they are verified, click “Start to check data,” and the system will start to execute the import operation. <%=temp1%><%=temp2%> Note that if there are null values in the first 10 data entry fields, the first 10 null data entries are still displayed in the system preview and automatically skipped during the import operation.',
		'nonExistentFormat2': 'Format does not exist!',
		'ImportResult': '<%=temp1%> (Import result)',
		'ValidationResult': '<%=temp1%> (Verification result)',
		'ImportFilePreview': '<%=temp1%> (Preview of imported file)',
		'theImportIsComplete': 'Import completed',
		'startCheckingTheMaterials': 'Start to check data',
		'reUploadTheArchive': 'Re-upload the file',
		'cropThePicture': 'Crop image',
		'theUploadedImageIsInThe': 'Uploaded image format error or size more than 3MB.',
		'areYouSureYouWantTo': 'Are you sure you want to remove the image?',
		'removeTheImage': 'Remove image',
		'DragAndDropAn': '+ Drag image here or click and select the image to upload.',
		'sending': 'Submitting',
		'downloadTheImportSample': 'Download import sample',
		'pleaseDownloadAndImportInTraditional': 'Please download and import using Traditional Chinese language.',
	},
	'components.Input': {
		'upToWords': 'Up to <%=max%> words.',
		'requiredField': 'Required field.',
		'minimumWords': 'At least <%=min%> words.',
		'theFormatDoesNotConform': 'Non-compliant format',
		'pleaseEnterTheCorrectEmailFormat': 'Please enter correct format.',
		'pleaseEnterDateFormatYYYYMMDD': 'Please enter date in YYYY/MM/DD format.',
		'pleaseEnterTimeFormathhmm': 'Please enter time in HH:MM format.',
		'pleaseEnterADFormatYYYY': 'Please enter A.D. year in YYYY format.',
		'pleaseEnterTheFormatOfAD': 'Please enter A.D. year and month in YYYY/MM format.',
		'pleaseEnterTheFormatOfThe': 'Please enter month and date in MM/DD format.',
		'pleaseEnterTheDateTimeFormat': 'Please enter date and time in YYYY/MM/DD hh:mm format.',
		'pleaseEnterTheDateRangeYYYYMMDD': 'Please enter date range in YYYY/MM/DD~YYYY/MM/DD format.',
		'pleaseEnterTheMobilePhoneNumber': 'Please enter mobile phone number, e.g., 0988888888.',
		'pleaseEnterTheCorrectPhoneNumber': 'Please enter correct phone number, e.g., \\028888888802-88888888(02)88888888.',
		'pleaseEnterTheExtensionFormatFor': 'Please enter extension number, e.g., 99, 888, 1234.',
		'pleaseEnterAPhoneOrMobile': 'Please enter phone number or mobile phone number, e.g., 0288888888 or 0988888888.',
		'pleaseEnterTheCorrectUniformNumbering': 'Please enter correct corporate tax ID number.',
		'pleaseEnterTheCorrectIPvFormat': 'Please enter correct IPv4 format.',
		'pleaseEnterTheCorrectIPv6Format': 'Please enter correct IPv6 format.',
		'rise': 'Initial',
		'apocalypse': 'End',
		'aStartingValueIsRequired': 'Initial value is required.',
		'anEndValueIsRequired': 'End value is required.',
		'theStartingValueCannotBeLess': 'Initial value should not be less than <%=min%>.',
		'theStartingValueCannotBeGreater': 'Initial value should not be more than <%=max%>.',
		'theEndValueCannotBeLess': 'End value should not be less than <%=min%>.',
		'theEndValueCannotBeGreater': 'End value should not be more than <%=max%>.',
		'theStartValueCannotBeGreater': 'Initial value should not be more than end value.',
		'pleaseEnterTheCorrectIDNumber': 'Please enter correct ID number.',
		'pleaseEnterAPassword': 'Please enter password.',
		'thePasswordLengthIsUpTo': 'Maximum password length is <%=max%>.',
		'passwordLengthIsAtLeast': 'Minimum password length is <%=min%>.',
		'total': '<%=temp1%> day(s) in total.',
		'pleaseEnterTheDateFormat': 'Please enter date in YYYY/MM/DD format, e,g., 2020/05/13.',
		'pleaseEnterTheADFormat': 'Please enter A.D. year in YYYY format, e.g., 2020.',
		'pleaseEnterTheYearAndMonth': 'Please enter A.D. year and month in YYYY/MM format, e.g., 2020/05.',
		'pleaseEnterTheMonthFormat': 'Please enter month in MM forma, e.g., 08.',
		'pleaseEnterMonthAndDayFormat': 'Please enter month and date in MM/DD format, e.g., 08/25.',
		'pleaseEnterTheTimeFormat': 'Please enter time in hh:mm format, e.g., 23:15.',
		'pleaseEnterTheHourFormat': 'Please enter in units of hours (hh:mm) , e.g., 23:00.',
		'pleaseEnterTheDatetimeFormat': 'Please enter date and time in YYYY/MM/DD hh:mm format, e.g., 2020/05/13 23:15.',
		'pleaseEnterANumericType': 'Please enter a numeric type.',
		'mustBeLessThan': 'Less than <%=max%>',
		'mustBeGreaterThan': 'More than <%=min%>',
		'mustBeAMultiple': 'Must be a multiple of <%=unit%>.',
		'startDate': 'Start date',
		'endDate': 'End date',
		'aStartOrEndDateIs': 'Start date or end date is required.',
		'aStartDateIsRequired': 'Start date is required.',
		'anEndDateIsRequired': 'End date is required.',
		'theStartDateMustBeEarlier': 'Start date should be earlier than end date.',
		'theTimeRangeMustBeLess': 'Time range should be shorter than <%=rangeMax%>.',
		'theTimeRangeMustBeGreater': 'Time range should be longer than <%=rangeMin%>.',
		'theDayBeforeYesterday': 'Previous day',
		'day': 'Current day',
		'next': 'Following day',
		'pleaseSelectTheDepartment': 'Please select the department.',
		'searchDepartment': 'Search departments',
		'theOrganizationChart': 'Organizational chart (<%=temp1%>) not activated or no departmental data available.',
		'countiesCitiesAndTownships': 'County/city, village, township',
		'youCanSelectUpTo': 'A maximum of <%=max%> items may be selected.',
		'atLeastMin': 'A minimum of <%=min%> items should be selected.',
		'easyFiltering': 'Simple filter',
		'advancedFiltering': 'Advanced filter',
		'advancedFilterSettings': 'Setting advanced filter criteria.',
		'selected': 'Selected',
		'search': 'Searching',
		'translate error': 'number',
		'deactivated': 'Deactivated',
		'selectedItemIsInactive': 'Selected item(s) include deactivated option(s). Please re-select.',
		'noMatchingInformation': 'No data meets the criteria.',
		'join': 'Add',
		'unitYear': 'year',
		'unitMonth': 'month',
		'unitDay': 'day',
	},
	'hp.m4.m410020': {
		'salaryMonth': 'Salary month',
		'salaryCate': 'Salary type',
		'payroll': 'Payroll',
		'return': 'Go back',
		'nonEmpAccessDenied': 'Non-employees do not have search permission.',
		'payrollLogin': 'Payroll login',
		'pwChangeOK': 'Password changed successfully.',
		'pwForgotten': 'Forgot password',
		'loginOK': 'Logged in successfully.',
		'notice': 'Message',
		'pwMustChange': 'Password should be changed.',
		'loginError': 'Login failed.',
		'noApplication': 'Application does no exist.',
		'pwGone': 'Staff payroll password data does not exist.',
		'pwBroken': 'Payroll password status error.',
		'pwInactive': 'Payroll password waiting for activation.',
		'pwLocked': 'Payroll password locked.',
		'pwClosed': 'Payroll password deactivated.',
		'waitLocked': 'Password has been locked. Please log in after <%= accountLockoutTime %> minute<%=n%>.',
		'notifiedAdmin': 'System administrator has been notified. Please wait for processing. Thank you.',
		'forgetExceeded': 'The maximum number of times for clicking Forgot password has been exceeded! To protect your password security, your password will be deactivated and the system administrator has been notified for processing. Thank you.',
		'resetMailSent': 'The system has sent a payroll password reset email to your e-mail address. Please reset the password within 30 minutes, otherwise the email will become invalid. Thank you.',
		'sendFatal': 'Sending failed',
		'pwPayroll': 'Payroll password',
		'pwHintLogin': 'To ensure salary data security, please enter the electronic payroll password (rather than the login password).',
		'pwHintClose': 'The password has been deactivated. For any questions, please contact the system administrator.',
		'tellAdmin': 'Notify administrator',
		'tokenFault': 'Tokeb error',
		'charRuleFailed': 'Text/numeric error detected.',
		'spCharRequired': 'Error detected: Password does not contain special characters.',
		'sameAsPrevious': 'New and old passwords should not be the same.',
		'pwConfirmFailed': 'New passwords do not match.',
		'pwModify': 'Change Password',
		'pwCurrent': 'Old password',
		'pwResetNoted': 'Payroll password reset notification sent.',
		'remindedAdmin': 'Forgot password has been reported for processing.',
		'ajaxFatal': 'Reading failed.',
		'payrollUnset': 'Employee does not set payroll format.',
		'payrollOutRange': 'Only payroll data within <%= qryLimitMonth %> months can be searched. Please search again.',
		'operationTimedOut': 'Validation invalid or operation timed out. Please log in again.',
		'taxBonusHint': 'Total taxable amount = Taxable bonus additions - Taxable bonus deductions',
		'taxSalayHint': 'Total taxable amount = Taxable salary structure + Taxable salary additions - Taxable salary deductions',
		'attendAmtHint': 'There may be an X difference in the “addition amount in the current month/deduction amount in the current month” due to amount changes or decimal points. <%= br %> Please use the “salary additions/salary deductions” in practice.',
		'bonus1st': '1st entry',
		'bonus2nd': '2nd entry',
		'bonus3rd': '3rd entry',
		'bonus4th': '4th entry',
		'bonus5th': '5th entry',
		'bonus6th': '6th entry',
		'bonus7th': '7th entry',
		'bonus8th': '8th entry',
		'failExceeded': 'There have been <%= cnts %> incorrect password login attempts. Please log in after <%= mins %> minutes.',
		'payrollNoFmt': 'Payroll format is not set.',
		'noSpeed': 'Quick login is not created.',
		'pubKeyFail': 'Key verification failed.',
		'pubKeyBroken': 'Key operation anomaly.',
		'authFatal': 'Identification failed.',
		'pwLocking': 'Password being locked.',
		'pwClosing': 'Anomalous password status. Please contact the system administrator.',
		'pwResetFatal': 'Password reset failed.',
		'pwLostFatal': 'Forgot password request failed.',
		'pwMaxClosed': 'Your password has been deactivated due to exceeding the limit for failed login attempts, and the account administrator has been notified.',
		'noAnyPayData': 'No salary data is available.',
		'opFatal': 'Operation failed',
		'noPayData': 'No salary data is available.',
		'waitSalary': 'Please search after there is available salary data.',
		'noMail': 'No password notification email can be sent. Please contact the system administrator. Thank you.',
		'noMailForAPP': 'No password notification email can be sent. Please contact the system administrator.',
		'headerForAPP': 'Password reset request failed.',
	},
	'hp.m4.m410040': {
		'queryInterval': 'Search range',
		'ifNoQueryIntervalIsSet': 'If a search range is not set, data between <%=temp1%>~<%=temp2%> will be searched as default.',
		'selectAStartDate': 'Start date',
		'selectAnEndDate': 'End date',
		'kabie': 'Card type',
		'theOvertimeAttendanceReasonWasUpdated': 'Reason for excess attendance hours updated successfully.',
		'multipleOvertimeAttendanceReasonsAreUpdated': 'Reason for multiple entries of excess attendance hours updated successfully.',
		'noInformationTryToSearchAgain': 'No information available. Try to search again.',
		'failedToCountTheNumberOf': 'Calculation of the number of leave request forms and missed clock-in/out forms failed.',
		'serialNumber': 'No.',
		'dateOfWork': 'Work date',
		'banBing': 'Shift',
		'timeOfAttendance': 'Attendance time',
		'clockinTime': 'Clock-in/out time',
		'systemOperation': 'System operation',
		'overtimeAttendance': 'Excess attendance hours',
		'multipleFills': 'Multiple entries',
		'bodyTemperature': 'Body temperature',
		'remark': 'Note',
		'oopsIHaventFilledIn': 'Oops! Not completed yet.',
		'cause': 'Reason:',
		'leave': 'Leave',
		'forgetToBrush': 'Missed clock-in/out',
		'editTheReasonForOvertimeAttendance': 'Edit the reason for excess attendance hours.',
		'pleaseFillInTheReason': 'Please provide the reason.',
		'incorrectOnboardingJourneyTime': 'Clock-in/out time history loading error',
		'thereIsNoRecordOfAny': 'There is no clock-in/out record!',
		'overtimeAttendanceReason': 'Reason for excess attendance hours',
		'theDescriptionMustBeLessThan': 'Description must be within 100 words.',
		'sendingOut': 'Submitting',
		'onboardingTimeoutAttendanceReasonError': 'Error in loading the reason for excess attendance hours.',
		'updateDate': 'Update date',
		'selectAll': 'Select all',
		'expectedHoursOfAttendance': 'Attendance time:',
		'dateOfWork2': 'Work date:',
		'clockInJourneyTime': 'Clock-in/out time history',
		'clockInTime': 'Clock-in/out time',
		'timeoutDescription': 'Description',
		'reason': 'Reason',
		'state': 'Status',
		'genTestData': 'Generate random check-in data',
	},
	'hp.Header': {
		'theSwitchoverFailed': 'Switch failed.',
		'successfullySwitchedTo': 'Switched to <%=temp1%> successfully.',
		'individual': 'Personal',
		'announcement': 'Announcement',
		'form': 'Form',
		'classSchedule': 'Shift schedule',
		'logOffTheSystem': 'Log out of the system',
		'areYouSureYouWantTo': 'Are you sure you want to log out?',
		'failedToLogOffTheSystem': 'System logout failed.',
		'announcementQueryError': 'Announcement searching error.',
		'daysago': '<%=temp1%> day(s) ago',
		'hoursago': '<%=temp1%> hour(s) ago',
		'tempminutesago': '<%=temp1%> minute(s) ago',
		'minutesago': '0 minute ago',
		'latestNotices': 'Latest notifications',
		'readall': 'Read all',
		'removeall': 'Remove all',
		'youdonthavethelatestnotice': 'There are no latest notifications!',
		'agentidentity': 'Substitute',
		'basicinformation': 'Profile',
		'listofrelatives': 'List of Family Members',
		'accountsecurity': 'Account Security',
		'switchidentities': 'Switch identity',
		'language': 'Language: ',
		'logout': 'Log out',
		'selectIdentity': 'Select identity',
		'selectalanguage': 'Select language',
		'headFor': 'Go to',
		'NonEmployees': '(Non-employees)',
		'personalSettings': 'Personal settings',
	},
	'components.EmpUtils': {
		'department': 'Department',
		'headOfDepartment': 'Department head',
		'incumbentStatus': 'Employment status',
		'dateRelated': 'Date-related',
		'withholdingUnit': 'Withholding entity',
		'laborProtectionCompilation': 'Labor insurance ID.',
		'healthInsuranceCompilation': 'Health insurance ID.',
		'posts': 'Position',
		'grade': 'Job grade',
		'rank': 'Job level',
		'jobCategory': 'Job type',
		'occupation': 'Job category',
		'identityCategory': 'Identity type',
		'directAndIndirect': 'Direct/indirect',
		'separationOfResponsibilities': 'Responsibilities',
		'preparationStatus': 'Staff status',
		'workArea': 'Work area',
		'placeOfWork': 'Work location',
		'factoryBy': 'Factory',
		'classAttributes': 'Shift nature',
		'salaryMethod': 'Salary calculation method',
		'probationaryExpirationStatus': 'Probation period completion',
		'basicData': 'Profile',
		'householdRegistrationAddressArea': 'Region of permanent address',
		'mailingAddressArea': 'Region of mailing address',
		'employee': 'Employee',
		'firm': 'Company',
		'partTimeStatus': 'Part time/Full time',
		'thisEmployeeViewPermissionIsNot': 'You have no permission to view the employee’s data.',
		'noInformationOnThisEmployeeWas': 'Employee data not found.',
		'readError': 'Reading error.',
		'reloadTheData': 'Reload data.',
		'pickEmployees': 'Select',
		'searchForNameEditors': 'Searching name and staff ID.',
		'moreSearchCriteria': 'More search criteria',
		'companyAffiliation': 'Company',
		'wordStatus': 'Employment status',
		'employeeNumberOnwards': 'Starting staff ID',
		'employeeNumber': 'Ending staff ID',
		'searcherNameExtension': 'Searching staff ID, name, extension, e-mail address.',
		'selectCompany': 'Company',
		'setFilters': 'Set filter criteria',
		'excludeSpecificPeople': 'Exclude certain employees',
		'previewOfTheResults': 'Result preview',
		'youCanOnlyRules': 'Up to <%=max%> rules.',
		'aMinimumOfRules': 'At least <%=min%> rules.',
		'condition': 'Criteria:',
		'exclude': 'Exclude:',
		'firmEmp': 'Company:',
		'establishFilters': 'Create Filter Criteria',
		'memberCheck': 'Member check',
		'reviewTheFilters': 'View Filter Criteria',
		'editTheFilterCriteria': 'Edit filter criteria',
		'thereAreCurrentlyNoOtherCompanies': 'Failed to continue the operation as there are no other companies.',
		'dateOfArrival': 'Report-to-duty date',
		'dateOfDeparture': 'Resignation date',
		'leaveWithoutPayDate': 'Leave-without-pay date',
		'gender': 'Gender',
		'ageRange': 'Age range',
		'seniorityRange': 'Year of service range',
		'staffingRange': 'Staff ID range',
		'employeeCardNumberRange': 'Staff card number range',
		'nationality': 'Nationality',
		'organizationChart': 'Organizational Chart',
		'level': 'Level',
		'noPermissions': 'No permission',
		'numberOfExcluded': 'Number of excluded employees:',
		'ifThereAreNoEligibleEmployees': 'Employees not conforming to the criteria cannot be excluded.',
		'accordingToTheFilterCriteria': 'There are no employees meeting the filter criteria.',
		'organizationChartCategories': 'Organizational chart type',
		'numberOfSelectedPeople': '<%=temp1%> employees selected.',
		'reviewMembers': 'Check Members',
		'thereAreCurrentlyNoEligibleEmployees': 'There are no employees meeting the criteria',
		'sector': 'Department',
		'positionTitle': 'Position (title)',
		'gradeGrade': 'Job grade/level',
		'dateOfBirth': 'Date of birth',
		'maritalStatus': 'Marital status',
		'highestEducation': 'Highest educational attainment',
		'recentExperience': 'Latest experience',
		'companyPhone': 'Company tel.',
		'companyEMail': 'Company e-mail',
		'mobilePhone': 'Mobile phone',
		'personalEMail': 'Personla e-mail',
		'familyRegistrationTelephone': 'Permanent tel.',
		'registeredAddress': 'Permanent address',
		'homePhone': 'Home tel.',
		'mailingAddress': 'Mailing address',
		'foreignAddress': 'Overseas address',
		'socialAccount': 'Social media account 1',
		'socialAccount2': 'Social media account 2',
		'emergencyContact': 'Emergency contact (1)',
		'emergencyContactRelationship1': 'Relationship with emergency contact (1)',
		'phone': 'Tel. (1)',
		'mobilePhone1': 'Mobile phone (1)',
		'emergencyContacts2': 'Emergency contact (2)',
		'emergencyContactRelationships2': 'Relationship with emergency contact (2)',
		'phone2': 'Tel. (2)',
		'mobilePhone2': 'Mobile phone (2)',
		'noInformationOnThisNonEmployee': 'Non-employee data not found.',
		'staffEditor': 'Staff ID:',
		'arrivalDate': 'Report-to-duty date:',
		'pickNonEmployees': 'Select non-employee',
		'failedToReadNonEmployeeData': 'Non-employee data reading failed.',
		'search': 'Searching',
		'fromTheCodeNameOfThe': 'Starting taxpayer code',
		'theRecipientCodeName': 'Ending taxpayer code',
		'nameOfTheRecipient': 'Taxpayer name',
		'iDNumberCompanyCompilation': 'Starting ID no./corporate tax ID no.',
		'iDorCompanyCompilation': 'Ending ID no./corporate tax ID no.',
		'categoryOfEarner': 'Taxpayer type',
		'clickToPickOtherNonEmployees': 'Click to select other non-employees',
		'employeeName': 'Staff name',
		'directIndirect': 'Direct/indirect',
		'workAreaLocation': 'Work area/location',
		'workRules': 'Working hour rules',
		'scheduledHours': 'Hours scheduled',
		'elapsedHoursOn': 'Hours scheduled (starting)',
		'scheduledHoursToDate': 'Hours scheduled (ending)',
		'failedToReadEmployeeData': 'Employee data reading error.',
		'unselect': 'Unselect',
		'selected': 'Selected',
		'keywords': 'Keywords',
		'empNumberStart': 'Start',
		'empNumberEnd': 'End',
	},
	'hp.m5.m510010.wf080': {
		'unit': 'doc(s)',
		'headerItem': 'Document item',
		'headerNum': 'Number',
		'applicationDocument': 'Request document',
		'reasonForApplying': 'Reason for applying',
	},
	'hp.m5.m5Picker': {
		'wfForm': 'Form',
		'amOtType': 'Overtime type',
		'pbRccc': 'Cost center',
		'pbVarsCause': 'Reason for salary approval',
		'pbSalaryItem': 'Salary account',
		'pbCurrency': 'Currency',
		'edVarsCause': 'Reason for change',
		'osSNO': 'Withholding entity',
		'osSNOCompilation': 'Corporate tax ID no.',
		'osOrgType': 'Organization type',
		'edJob': 'Position',
		'edGrade': 'Job grade',
		'edLevel': 'Job level',
		'edJobCat': 'Job type',
		'edJobDesct': 'Job instruction',
		'edJobStyle': 'Job category',
		'edJobBiz': 'Business card title',
		'edIdentity': 'Identity type',
		'edArea': 'Work area',
		'edSite': 'Work location',
		'edFactory': 'Factory',
		'amTemplate': 'Attendance rule template',
		'amShift': 'Shift',
		'amCalendar': 'Calendar',
		'amAnnual': 'Annual leave rules',
		'amFlexible': 'Flexible leave rules',
		'amOtRule': 'Overtime rules',
		'amOtWorkHour': 'Working hour rules',
		'amSectionRule': 'Staff scheduling rules',
		'amAttendRule': 'Attendance hour rules',
		'wfDocType': 'Document type',
		'osCompany': 'Company',
		'edQuitCause': 'Resignation reason',
		'edBizProperty': 'Business trip type',
		'edBizArea': 'Business trip location',
		'edBizTrans': 'Transportation',
		'edBizTodo': 'Appointment',
	},
	'hp.m5.m510010.wf064': {
		'quitDateTip': 'The resignation effective date is the last day at work on which the employee is still considered employed.',
		'selectDate': 'Select date',
		'quitCauseDescPla': 'Please enter text',
		'homeTelPla': 'E.g. 0222881256',
		'mobileTelPla': 'E.g. 0912345678',
		'personalEmailPla': 'E.g. 104@gmail.com',
		'postCodePla': 'Please select the county/city and region',
		'contactAddressPla': 'Please enter the mailing address',
		'handoverContentPla': 'Enter job description, up to 1000 words.',
		'resignMoreStay': 'Resignation effective date should be later than the leave without pay effective date.',
		'hasResignation': 'There is already resignation data after the effective date.',
		'resignMoreDueDate': 'Resignation effective date should be later than or equal to the report-to-duty date.',
		'handoverUpdateFailed': 'Handover document writing error.',
		'typeOfResignation': 'Resignation type',
		'resignationNumber': 'Resignation no.',
		'effectiveDateOfSeparation': 'Resignation effective date',
		'reasonForLeaving': 'Resignation reason',
		'reasonForResignation': 'Resignation reason description',
		'contactAfterLeaving': 'Post-resignation contact information',
		'homeTelLabel': 'Tel.',
		'mobileTelLabel': 'Mobile phone',
		'addressLabel': 'Address',
		'handoverLabel': 'Handover data',
		'handoverContentLabel': 'Handover content',
		'handoverPersonLabel': 'Successor',
		'handoverDocumentsLabel': 'Handover document',
		'interviewRecordLabel': 'Interview records',
		'hrInterviewRecordLabel': 'HR Interview records',
		'reviewHrPla': 'Please enter interview records, up to 1000 words.',
		'supervisorInterviewRecordLabel': 'Executive interview records',
		'reviewLeaderPla': 'Please enter interview records, up to 1000 words.',
		'includeTurnoverRateLabel': 'Include the turnover rate for calculation',
		'neverHireLabel': 'Never hire',
		'neverHireReasonLabel': 'Reason for never hiring',
		'neverHiredReasonPla': 'Please enter the reason, up to 1000 words.',
		'effectiveSetting': 'Validation settings',
		'resignationDateIsSalaryEffLabel': 'Salary calculation takes effect before the resignation date',
		'reasonForLeavingHasBeenDisabled': 'Resignation reason has been deactivated',
		'resignationIsNotEffectiveJobAlreadyExists': 'Resignation operation not in effect already exists.',
		'reasonForLeavingHasBeenRemoved': 'Resignation reason has been deleted.',
		'handoverPersonEmploymentStatus': 'Successor is unemployed on the date.',
		'interviewDocuments':'Interview documents',
		'infoTel':'Contact info. - Tel.',
		'infoPhone':'Contact info. - Mobile phone',
		'infoEMail':'Contact info. - Email',
		'infoAddress':'Contact info. - Address',
	},
	'hp.m5.m510010.wf065': {
		'handoverPersonEmploymentStatus': 'Successor is unemployed on the date.',
		'stayReasonRemoved': 'Reason for leave without pay has been deleted.',
		'theReinstatementDateIsGreaterThanStayDate': 'Expected return-to-work date should after leave without pay effective date.',
		'effectiveDateOfStayAndTypeIsNotRepeatable': 'No leave without pay effective date + leave without pay type conflict is allowed.',
		'effectiveSateOfStayEqualToReinstatementDate': 'Leave without pay effective date should be later than or equal to the previous return-to-work date.',
		'dwellReasonDisabled': 'Reason for leave without pay has been deactivated.',
		'thereArePendingStayOperations': 'There are leave without pay operations not in effect.',
		'thereArePendingReinstatementOperations': 'There are reinstatement operations not in effect.',
		'noReinstatementOperations': 'There are no reinstatement operations.',
		'stayMoreDueDate': 'Leave without pay effective date should be later than or equal to the report-to-duty date.',
		'handoverUpdateFailed': 'Handover document writing error.',
		'reasonForStay': 'Reason for leave without pay',
		'stopCauseDescPla': 'Please enter text',
		'stopDateTip': 'The leave without pay effective date is the last day at work on which the employee is still considered employed.',
		'selectDate': 'Select date',
		'homeTelPla': 'E.g. 0228980098',
		'mobileTelPla': 'E.g. 0912345678',
		'personalEmailPla': 'E.g. 104@gmail.com',
		'postCodePla': 'Please select the county/city and region.',
		'contactAddressPla': 'Please enter the mailing address.',
		'handoverContentPla': 'Enter job description, up to 1000 words.',
		'addHandoverWorkContent': 'Add handover content',
		'stayTypeLabel': 'Leave without pay type',
		'stayTNumberLabel': 'Leave without pay no.',
		'reasonForStayLabel': 'Description of the reason for leave without pay',
		'effectiveDateOfStayLabel': 'Leave without pay effective date',
		'estimatedReturnDateLabel': 'Expected return-to-work date',
		'stayDateIsSalaryEffLabel': 'Salary calculation takes effect before the leave-without-pay date',
		'contactAfterLeaving': 'Contact information during leave without pay',
		'homeTelLabel': 'Tel.',
		'mobileTelLabel': 'Mobile phone',
		'addressLabel': 'Address',
		'handoverLabel': 'Handover data',
		'handoverContentLabel': 'Handover content',
		'handoverPersonLabel': 'Successor',
		'handoverDocumentsLabel': 'Handover document',
		'insuranceInformationLabel': 'Insurance coverage',
		'healthStatusLabel': 'National health insurance',
		'laborInsuranceStatusLabel': 'Labor insurance',
		'thereIsNoEffectiveReinstatementDate': 'There is no effective return-to-work date.',
		'parentalLeaveInfo': 'Parental leave info.',
		'ageNone': 'Age: --',
		'ageInfo': 'Age: <%=n%> year<%=s%> old.',
		'otherChild': 'Other application records for this child',
		'times': 'Times',
		'parentalLeaveSeniority': 'Parental leave seniority',
		'timesFormat': ' <%=Y%> year<%=YS%> <%=M%> month<%=MS%> <%=D%> day<%=DS%>',
		'childRequired': 'Child\'s name is required.',
		'childCareTypeRequired': 'Type of parental leave is required.',
		'notExistChild': '<%=n%> does not exist.',
		'notChildApplicant': '<%=n%> is not the child of the applicant.',
		'warningStayDate': 'Child is 3 years old or older during leave of absence.',
		'warningReinstatementDate': 'Child is over 3 years old on the expected return-to-work date.',
		'warningSeniority': 'Seniority less than 6 months.',
		'perviewChild': '<%=n%> (Age: <%=y%> year<%=s%> old)',
		'nameOfChild': 'Name of child',
		'typeOfParentalLeave': 'Type of parental leave',
		'downloadChild': '<%=t%>, <%=c%> time<%=cs%>, parental leave seniority ',
	},
	'sp.wf065.ed.emp.stop.Check': {
		'code11': 'There is no such employee in the company.',
		'code12': '<%=n%> does not exist.',
		'code13': 'The type of parental leave does not meet the requirements.',
		'code14': 'The parental leave situation does not meet the required conditions.',
		'code15': '<%=n%> is not the child of the applicant.',
		'code21': 'Submission limit reached.',
		'code22': 'The period of leave without pay does not meet the seniority requirement for the application.',
		'code23': 'Submission deadline passed.',
		'code31': 'Child is 3 years old or older during leave of absence.',
		'code32': 'Child is 3 years old or older during leave of absence.',
		'code33': 'Child is over 3 years old on the expected return-to-work date.',
		'code34': 'Child is over 3 years old on the expected return-to-work date.',
		'code41': 'Seniority less than 6 months.',
		'code42': 'Seniority less than 6 months.',
		'code51': 'Reinstatement records already exist with a start date on or after the effective date of the leave or its extension.',
		'code52': 'The application period does not match the child\'s birth date.',
	},
	'hp.RouteWrapper': {
		'loginFailedTheAccountStatus': 'Log out automatically. Please log in again.',
		'verifyOfYourAccount': 'You do not have permission to use this feature. Please verify the permissions of your account.',
	},
	'hp.Signin': {
		'pleaseSelectYourCompany': 'Please select your company:',
		'passwordSettingFailed': 'Password setting failed.',
		'theAccountDoesNotExist': 'Account does not exist.',
		'theAccountStatusIsAbnormalAnd': 'Password cannot be changed due to anomalous account status.',
		'ifThePasswordDoesNotMeet': 'Password does not meet the length or complexity requirements of login rules. Please reset it.',
		'ifYouLogInTooMany': 'Due to too many incorrect login attempts, the account will be locked for <%=temp1%> minutes.',
		'youVeLoggedInYou': 'You have logged in. The screen will be automatically refreshed later.',
		'loginFailed': 'Login failed',
		'theAccountNumberOrPasswordIs': 'Incorrect account or password.',
		'aDVerificationFailed': 'AD verification failed.',
		'youAreCurrentlyUsingADevice': 'The device you are using (is not allowed) has no permission to access this system.',
		'ifTheAccountStatusIsAbnormal': 'Anomalous account status (locked, closed, unverified...). Please contact the system administrator.',
		'accountPermissionsAreUnusualOrHave': 'Account permission anomaly or no permission.',
		'enableTheAccount': 'Activate account',
		'firstTimeUsingTheSystem': 'First time using the system',
		'youMustEnableYourAccountFirst': 'Be sure to activate the account first',
		'steps': 'Process:',
		'Verification': '1. Verify ',
		'account': 'the account',
		'Settings': '2. Set ',
		'password': ' a password',
		'EnableFinish': '3. Activation completed.',
		'logIn': 'Login',
		'forgotPassword': 'Forgot password',
		'thePasswordModificationIsComplete': 'Password change completed.',
		'hello': '<%=temp1%> Hello,',
		'yourPassword': 'Your password',
		'yourPasswordHasBeen': 'Your password <%=temp1%> has been changed!',
		'canBeDirectly': 'You can <%=temp1%> directly. Thank you!',
		'logInToTheSystem': 'Log in to the system',
		'setAPassword': 'Set a password',
		'passwordPlaceholder': 'Password',
		'confirmThePassword': 'Confirm the password',
		'yourPasswordMustMeetTheFollowing': 'Your password must conform to the following requirements.',
		'theMinimumPasswordLengthIs': 'Minimum password length is <%=temp1%> characters.',
		'thePasswordIsACombinationOf': 'Password consists of English letters and digits.',
		'thePasswordMustHaveASpecial': 'Password should contain special characters.',
		'thePasswordContainsAtLeastOne': 'Password contains at least one capital English letter.',
		'thePasswordIsEnteredTheSame': 'Two passwords entered are the same.',
		'account2': 'Account:',
		'inTheSetting': 'Setting',
		'logInToYourAccount': 'Login account',
		'rememberTheAccountNumber': 'Remember the account',
		'loginPassword': 'Login password',
		'theRequestToResetThePassword': 'Password reset request failed.',
		'youEnteredTheWrongAccountNumber': 'The account you entered is incorrect.',
		'youAreUsingAnADAccount': 'The account you are using is  . To reset the account or password, please contact company staff. Thank you!',
		'yourAccountIsNotEnabled': 'Your account has not been activated. Please contact the account administrator to request another account verification email.',
		'yourAccountHasBeenClosed': 'Your account has been closed. Please contact the account administrator. Thank you!',
		'failedToGenerateToken': 'Token generation failed.',
		'failedToSendNotificationLetterWithout': 'Notification email sending failed as there is no email template.',
		'userAccount': 'User account',
		'applying': 'Requesting',
		'requestAPasswordReset': 'Request a password reset',
		'yourHasBeenSent': 'Your <%=temp1%> has been sent to <%=temp2%>. Please check the email as soon as possible and click the link to reset the password. The link is valid within <%=temp3%> minutes. Thank you!',
		'PasswordResetLetter': '“Password Reset Email”',
		'weHaveNotifiedYourCompanyResponsible': 'We have notified the person in change in your company to assist you in resetting the password.',
		'ifYouNeedToUseThe': 'If there is an urgent need to use the system, please actively contact the person in charge in your company. Thank you!',
		'logBackIn': 'Login again',
		'yourAccountIsLockedPlease': 'Your account is being locked. Please contact the account administrator. Thank you.',
		'yourAccountHasBeenClosedThx': 'Your account has been closed. Please contact the account administrator. Thank you.',
		'yourAccountIsNotVerified': 'Your account is unverified.',
		'theInputIsWrongTooMany': 'Due to too many incorrect account login attempts, the account has been locked.',
		'noAccountInformation': 'No account information available.',
		'theUserAccountDoesNotExist': 'User account does not exist.',
		'passwordMinimumLengthCheckError': 'Minimum password length error detected.',
		'thePasswordDoesNotMeetThe': 'Password does not meet password setting requirements. Please reset it.',
		'theAccountStatusIsWrong': 'Account status error.',
		'theTimeHasNotYetCome': 'Time has not passed.',
		'duplicateLastPassword': 'Same as the previous password.',
		'yourAccountIsAnIntegratedAD': 'Since your account is an integrated AD account, the password cannot be changed.',
		'authenticationModeError': 'Verification mode error.',
		'thePasswordWasEnteredIncorrectly': 'Incorrect password entered.',
		'theLinkToTheLetterIs': 'The link in the email has become invalid. Please confirm if the account is opened or another account verification email has been sent.',
		'passwordCannotBeChanged': 'Password cannot be changed.',
		'thePasswordDoesNotMatch': 'Passwords do not match. Please confirm.',
		'blankInputIsNotAllowed': 'Entering blanks is not permitted.',
		'passwordRulesAreNotMet': 'Not conform to password rules.',
		'theFirstTimeYouUseThe': 'To use the system for the first time <%=temp1%>, account activation is required <%=temp2%><%=temp3%>. Process: <%=temp4%>1. Verify <%=temp5%> and <%=temp6%><%=temp7%>, 2. Set <%=temp8%><%=temp9%>, 3. Activation completed.',
		'authenticationCode': 'Verification code',
		'theAccountIsEnabled': 'Account activation completed.',
		'yourAccountHasBeen': 'Your account <%=temp1%> has been activated! ',
		'pleaseWithTheNew': 'Please use the new password <%=temp1%> you just set. Thank you!',
		'hello2': ' Hello,',
		'ClickOnThe': '1. Click the email <%=temp1%>.',
		'EnableComplete': '2. Activation completed.',
		'link': 'link',
		'VerifyThat': '1. Verify <%=temp1%> and <%=temp2%>.',
		'Set': '2.Set <%=temp1%>.',
		'VerifyThat1': '1. Verification <%=temp1%>.',
		'failedToEnableAccount': 'Account activation failed.',
		'accountError': 'Incorrect account',
		'linkValidationFailed': 'Link verification failed',
		'invalidLink': 'Invalid link',
		'thisLinkHasExpiredPlease': 'This link has expired. Please request a new one!',
		'yourCurrentDeviceIPIs': 'The device you are using (is not allowed) has no permission to access this system. Please use a device with this permission instead or contact the account administrator. Thank you!',
		'anUnspecifiedErrorOccurred': 'An unknown error occurred.',
		'verify': 'Verifying',
		'theLinkHasAlreadyCompletedThe': 'A new password has been set via this link or there is a newer request. In case of the latter, please use the link in the latest email received. Thank you! ',
		'youHaveSuccessfullyChangedThePassword': 'You have changed the password successfully. Please use the system with the new password <%=temp1%>.',
		'hello3': 'Hello,',
		'newPassword': 'New password',
		'user': 'User',
		'eMail': 'E-mail',
		'confirmTheNewPasswordAgain': 'Confirm the new password again',
		'confirmTheReset': 'Confirm the resetting',
		'resetThePassword': 'Reset password',
		'reset': 'Resetting',
		'invalidLinks': 'Invalid link',
		'resetPasswordFailedThisLink': 'Password reset failed as this link has expired. Please request a new one!',
		'yourCurrentDeviceIPNot': 'The device you are using (is not allowed) has no permission to access this system. Please use a device with this permission instead or contact the account administrator.',
		'theLinkHasAlreadyCompletedThePassword': 'A new password has been set via this link or there is a newer request. In case of the latter, please use the link in the latest email received.',
		'ifYouDoNotHaveAn': 'No password notification email can be sent. Please contact the system administrator.',
		'ifTheSystemIsAbnormalContact': 'System anomaly. Please contact the system administrator.',
		'requireSignInWithAadRuleMsg': 'Require sign-in with Microsoft account.',
		'resetPasswordAadRuleMsg': 'This account is not applicable. Please log in with a Microsoft account.',
		'theAccountDoesNotExistOrNotAadRule': 'Account not found, or not applicable for Microsoft account login.',
		'azureADVerificationFailed': 'Azure Active Directory Authentication Failed',
		'companyNoAzureADLoginRules': 'The company does not have Azure AD login rules.',
		'oneTimePass': 'OTP Password',
		'fatalOtp': 'Incorrect OTP password. Please input again.',
	},
	'hp.m5.m510020': {
		'startToEnd': '<%=temp1%> to <%=temp2%>',
		'yes': 'Yes',
		'not': 'No',
		'incomeTaxCalculationRules': 'Income tax calculation rules',
		'summary': 'Summary',
		'downtimeTelephone': 'Tel. during leave without pay',
		'duringTheStayPeriodMobilePhone': 'Mobile phone during leave without pay',
		'stayEmail': 'Email during leave without pay',
		'periodOfStayAddress': 'Address during leave without pay',
		'youCanSeeTheFullInformation': 'You may check all information in the form.',
		'principal': 'The primary and other responsible persons',
		'resubmittingFailed': 'Resubmitting failed.',
		'notHavePermission ': 'You do not have permission to resubmit the <%=name%>.',
		'approverFormNo': 'Approver/Staff be changed/Form no.',
		'changeApproverByBatch': 'Change Approver by batch',
		'ｗithdrawByBatch': 'Withdraw by Batch',
		'unableToWithdraw': 'Unable to withdraw.',
		'resubmit': 'Resubmit',
		'withdrawnCompleted': 'Withdrawn completed.',
		'withdrawnFailed': 'Withdrawn failed.',
		'beenWithdrawn': 'The form has already been withdrawn, deleted, approved, or settled by someone else, so it cannot be withdrawn again.',
		'changedSuccessfully': 'Changed approver by batch successfully.',
		'ChangedFailed': 'Changed approver by batch failed.',
		'fromTheOriginalSigner': 'Oops! There are no pending forms awaiting approval from the original signer.',
		'notPossibleToChange': 'Oops! It is not possible to change the approver for any of them.',
		'skipAndProceed': 'Skip and proceed with changing the approver.',
		'importSheetError': 'The sheet names in the Excel file still duplicate even after being shortened to 30 characters. We recommend downloading the forms individually or adjusting the sheet names.',
	},
	'hp.SigninMobile': {
		'hello': '<%=temp1%>Hello,',
		'yourAccountHasBeenLockedPlease': 'Your account has been locked. Please log in to the system again after the lockout effective period passes or contact the account administrator. Thank you!',
		'failedToVerifyTheAccount': 'Account verification failed.',
		'youEnteredTheWrongVerificationCode': 'The verification code you entered is incorrect.',
		'validating': 'Verifying',
		'verifyTheAccount': 'Verify the account',
	},
	'hp.Home': {
		'iMTheBest': 'I am the best!',
		'specialBreak': 'Annual leave',
		'compensatoryLeave': 'Compensatory time',
	},
	'hp.m5.m510010.wf040': {
		'theleaveCheckHasNotPassed': 'Leave change check failed.',
		'failedToAApplyForALeaveOfAbsenceTransactionOPrderk': 'Leave change form submission failed.',
		'failedToWriteToLeaveMasterFile': 'Master leave file writing failed.',
		'theTotalNumberOfLeavesOfAbsenceCannotBe0': 'Total leave hours should not be 0.',
		'pleaseSelectTheTimeOfAbsence': 'Please select leave time first.',
		'loadingErrorsForChangeableLeaveItems': 'Changeable leave item loading error.',
		'obtainingLeaveDataError': 'Leave data retrieval error.',
		'theOriginalApplicationLeaveTimeIsTheSame': 'Adding of <%=formsetBasicName%> failed as the time after change should not be the same as the originally requested leave time.',
		'pleaseReselectTheLeaveTime': 'Please reselect leave time.',
		'falseAttendanceCalculationError': 'Leave calculation error.',
		'pleaseSelectTheShiftLeaveItemFirst': 'Please select the leave item to change first.',
		'noneMessage': 'None <%=temp1%> <%=temp2%> <%=temp3%>',
		'noneMessageHour': 'None <%=temp1%> <%=temp2%>',
		'falseAttendanceDataError': 'Leave data error: <%=temp1%>',
		'theStartDateOfTheLeave': 'Leave start date',
		'endOfLeaveDay': 'Leave end date',
		'leaveProject': 'Leave item',
		'leaveDay': 'Leave data',
		'schedulingEmployeesAreNotAllowedToAskForLeave': 'Adding of <%=formsetBasicName%> failed as non-shift employees are not allowed to take leave.',
		'leaveHoursCannotBe0Error': 'Adding of <%=formsetBasicName%> failed as the total leave hours should not be 0.',
		'attachError': 'Add <%=formsetBasicName%> Fail <%=message%>',
		'originalApplicationLeaveTime': 'Originally requested leave time.',
		'totalHoursOfLeave': 'Total leave hours.',
		'leaveTimeAfterTheChange': 'Leave time after change.',
		'changeReason': 'Reason for change.',
		'noThisLeaveData': 'The company has no such leave data.',
		'oldTotalLeaveDate': 'Total leave hours before change.',
		'newLeaveDate': 'Total leave hours after change.',
		'theTimeOfLeaveAfterThe': 'The time after change should not exceed the period which the originally requested leave time.',
		'changeType': 'Change type',
		'changeableLeaveItem': 'Changeable leave item',
	},
	'hp.m5.m510010.wf090': {
		'attendanceSheetApplicationFailed': 'Attendance form submission failed.',
		'attendanceHoursCheckFailed': 'Attendance hour check failed.',
		'failedToWriteToAttendanceMasterFile': 'Master attendance file writing failed.',
		'pleaseSelectTheAttendanceTimeFirst': 'Please select attendance time first.',
		'otherTimeRequirementLoadingError': 'Error in loading other attendance hour rules.',
		'pleaseReselectTheAttendanceTime': 'Please reselect attendance time.',
		'theActualTimeAndHoursResultOfTheAttendanceHoursRule': 'The attendance time you requested will be adjusted to generate the actual time and hours that meet the company’s attendance hour rules after being compared with your attendance data by the system.',
		'hourCheckError': 'Hour error detected',
		'errorReadingAttendanceRules': 'Attendance rule reading error.',
		'attendancePeriod': 'Attendance period',
		'attendanceHours': 'Attendance hours',
		'actualResultsAdjustedToComplyWithCompanyTimeOfDayRules': 'The hours you requested are not the final result and will be adjusted to meet the company’s attendance hour rules after being compared with your attendance data by the system.',
		'actualResultsAdjustedToComplyWithCompanyHoursOfAttendanceRules': 'The hours you requested have been adjusted to meet the company’s attendance hour rules. Originally requested time is from <%=attendStart%> to <%=attendEnd%>.',
		'attendanceTotalHoursLoadingError': 'Total attendance hour loading error.',
		'totalHoursOfAttendance': 'Total attendance hours',
		'attendanceHoursStatistics': 'Attendance hour statistics',
		'costCenterItem': 'Cost center: <%=name%>, Attendance hours: <%=hours%>',
		'applicationType': 'Request type',
		'attendanceTime': 'Attendance time',
		'attendanceAttributionDate': 'Attendance vesting date',
		'totalAttendanceHours': 'Total attendance hours',
		'reasonForAttendance': 'Attendance reason',
		'typeNoLongerOpen': 'Such request type is unopened.',
	},
	'hp.m5.m510010.wf020': {
		'overtimeApplicationFailed': 'Overtime request form submission failed.',
		'overtimeCheckHasNotPassed': 'Overtime request form check failed.',
		'failedToWriteOvertimeMasterFile': 'Master overtime file writing failed.',
		'advanceOvertimeHoursLoadingError': 'Error in loading the scheduled time of overtime.',
		'errorGettingAdvanceOvertimeHours': 'Error in retrieving the scheduled time of overtime.',
		'withPreAppliedOvertime': 'Overtime pre-approval form is applied',
		'actualResultsAdjustedToComplyWithCompanyOvertimeRules': 'The hours you requested are not the final result and will be adjusted to meet the company’s overtime rules after being compared with your attendance data by the system.',
		'totalOvertimeHoursLoadedIncorrectly': 'Total overtime hour loading error.',
		'totalOvertimeHours': 'Total overtime hours',
		'overtimeStatistics': 'Overtime statistics',
		'actualOvertime': 'Actual time of overtime',
		'totalActualOvertimeHours': 'Total actual overtime hours',
		'advanceOvertime': 'Scheduled time of overtime',
		'totalNumberOfOvertimeHoursWorkedInAdvance': 'Total scheduled overtime hours',
		'theSelectedAdvanceOvertimePayHas': 'Overtime pre-approval form does not exist.',
		'costCenterItem': 'Cost center <%=name%> Overtime pay <%=otName%> Compensatory time  <%=calName%>',
		'clockInOut': 'Clock-in/out',
		'totalOverTimeApplication': 'Total overtime (excluding this application)',
		'mailClock': 'Clock-in/out ',
	},
	'hp.m5.m510010.wf022': {
		'exchangeMethod': 'redemption method',
		'overtimeCheckHasNotPassed': 'Overtime request form check failed',
		'failedToApplyForPreOvertimeWorkOrder': 'Overtime pre-approval form submission failed.',
		'failedToWritePreOvertimeMasterFile': 'Overtime pre-approval form submission failed.',
		'appliedHoursWithTheAttendanceDataAgain': 'The hours you requested are not the final result and will be compared with your attendance data by the system when an overtime request form is submitted.',
		'overtime': 'Time of overtime',
		'totalOvertimeHours': 'Total overtime hours',
		'failedToWriteToMasterFileOfPreOvertimeWorkSheet': 'Master overtime pre-approval form file writing failed.',
		'deductRestTimeOldInitial': 'Deciding whether to deduct break time according to company regulations.',
		'deductRestTime': 'Deduct rest time',
	},
	'hp.m5.m510010.wf060': {
		'theReasonForTheChangeIsDisabled': 'Reason for change has been deactivated.',
		'theReasonForTheChangeHasBeenDeleted': 'Reason for change has been deledted.',
		'clockingInAndWorkingOvertimeOn': 'Conversion of clock-in/out entries on workdays to overtime',
		'asAReminderIfYouAdjust': 'As a reminder, adjusting the job grade requires simultaneous adjustment of the job level to avoid leaving the job level blank.',
		'remindYouThatIfYouAdjust': 'As a reminder, adjusting the job area requires simultaneous adjustment of the job location to avoid leaving the job location blank.',
		'atLeastOneProjectChange': 'At least one item should be changed.',
		'employeesOnTheDayOfChange': 'The employee must be employed on the date of change.',
		'theChangeProjectHasNotYet': 'The item to change has changes not in effect.',
		'thereAreRelativelyNewChangesIn': 'The item to change has newer changes that have taken effect.',
		'ifThereIsALeaveRequest': 'There is already leave data after the effective date, and the shift nature cannot be changed and is “shift scheduling is not required”.',
		'thePreChangeShiftAndThe': 'The working hours before and after a shift change that conflict cannot be stored.',
		'ifTheCardComparisonFieldNeeds': 'If “comparison and anomaly generation are required” or “comparison is required and anomaly generation is not needed” is shown in the clock-in/out comparison field, there should be a Yes after a clock-in/out method field change is allowed.',
		'theSpecialBreakRuleIsNull': 'Annual leave rules are null after change.',
		'overtimeRulesAreNullAfterChanges': 'Overtime rules are null after change.',
		'nullValueAfterAChangeIn': 'Working hour rules are null after change.',
		'theValueIsNullAfterThe': 'Clock-in/out comparison is null after change.',
		'theClassAttributeIsNullAfter': 'Shift nature is null after change.',
		'theChangeInClassAttributesIs': 'If the shift nature is changed to “shift scheduling is not required” (requested based on hours), there should be no shifts, period and shift rules.',
		'theChangeInClassAttributesIsNeedCalendar': 'If the shift nature is changed to “shift scheduling is not required” (requested based on hours), calendars, annual leave rules, attendance hour rules, conversion of clock-in/out entries on workdays to overtime, overtime rules, working hour rules should be set.',
		'theChangeInClassAttributesIsNotNeedCalendar': 'If the shift nature is changed to “rotating shifts” (by period), shifts, calendars, attendance hour rules, conversion of clock-in/out entries on workdays to overtime are unsettable.',
		'theChangeInClassAttributesIsNeedRule': 'If the shift nature is changed to “rotating shifts” (by period), period and shift rules, annual leave rules, overtime rules, working hour rules should be set.',
		'theChangeInClassAttributesIsNotNeedRule': 'If the shift nature is changed to “rotating shifts” (by shift), shifts, period and shift rules, attendance hour rules, conversion of clock-in/out entries on workdays to overtime are unsettable.',
		'theChangeInClassAttributesIsNeedAnnual': 'If the shift nature is changed to “rotating shifts” (by shift), annual leave rules, overtime rules, working hour rules should be set.',
		'theChangeOfClassAttributesIs': 'If the shift nature is changed to “fixed shifts,” period and shift rules, attendance hour rules, conversion of clock-in/out entries on workdays to overtime are unsettable.',
		'theClassAttributeChangeIsA': 'If the shift nature is changed to “fixed shifts,” shifts, calendars, annual leave rules, overtime rules, working hour rules should be set.',
		'ifTheEmployeeHasInformationOn': 'The employee has leave without pay and resignation data not in effect before the change effective date.',
		'employeeAttendanceRulesNeedToExist': '<%=temp1%>: Employee attendance rules should exist.',
		'theNewPersonnelChangeOrderFailed': 'Staffing change form adding failed.',
		'classAttributeChangeIsFixedClass': '<%=temp1%> Shift nature is changed to “fixed shifts”,',
		'shiftAttributeChangeToShiftAccording': '<%=temp1%> Shift nature is changed to “rotating shifts” (by shift),',
		'shiftAttributeChangeIsScheduledAccording': '<%=temp1%> Shift nature is changed to “rotating shifts” (by period),',
		'classAttributeChangeIsNotRequired': '<%=temp1%> Shift nature is changed to “shift scheduling is not required” (requested based on hours),',
		'specialLeaveRules': 'Annual leave rules',
		'settingsRequired': 'Should be set',
		'notConfigurable': 'Unsettable',
		'impeachmentLeaveRules': 'Flexible leave rules',
		'noAttendanceRules': 'There are no attendance rules.',
		'selected': '<%=temp1%> items selected.',
		'ifTheCalendarTimeBeforeAnd': 'The calendar day is different before and after change. The change will be effective after deleting the shift data after the effective date.',
		'someWorkingHoursDoNotSupport': 'Part time employee is not allowed for advance annual leave.',
		'changedDescription': 'Changed description',
	},
	'hp.m5.m510010.wf070': {
		'effectiveDate': 'Effective date <%=date%>',
		'pleaseSelectACostCenter': 'Please select cost center.',
		'apportionmentRate': 'Shared proportion',
		'holiday': 'Holiday',
		'whetherHolidaysArePaid': 'Is there holiday pay',
		'remindYouThatTheSalaryUnit': 'As a reminder, there is a salary calculation unit change, please pay attention to the calculation method and final amount of salary items!',
		'pleaseEnterANumber': 'Please enter a number.',
		'thereIsNoSalaryDataFor': 'Employee has no salary data.',
		'hourlyEmployeesCannotSetAFull': 'For part-time employees, perfect attendance bonuses are unsettable.',
		'thereAreAlreadyChangesToThe': 'A salary rule change with the same name and the same change effective date already exists.',
		'theChangeProjectHasMoreInformation': 'The item to change has change data after the change effective date.',
		'thereIsNoEffectiveInformationFor': 'The item to change has data not in effect.',
		'employeesShouldBeEmployedOnThe': 'The employee must be employed on the change effective date.',
		'noSalarySettlementInformationIsAvailable': 'There should be no salary archiving data after the change effective date.',
		'costCenterChangeDataIsAvailable': 'There is already cost center change data after or on the change effective date.',
		'theSumOfTheCostCenter': 'The sum of cost center percentages does not equal 100.',
		'salaryCalculationInformationCannotBeAvailable': 'There should be no salary calculation data after the change effective date.',
		'employeePayRulesNeedToExist': 'Employee salary rules should exist.',
		'salaryAdjustmentInformationIsAvailableOn': 'There is already salary adjustment data with the same change effective date.',
		'addedFailureNoSalaryDataFor': 'Adding <%=temp1%> failed as the employee has no salary data.',
		'costCenterProportionsMustAddUp': 'The sum of cost center percentages should equal 100%.',
		'addFailurePayrollAccountCurrencyData': 'Adding <%=temp1%> failed as no salary account + currency data conflict is allowed.',
		'pleaseSelectTheReasonForThe': 'Please select the reason for change.',
		'noPayrollData': 'No salary data is available.',
		'amount': 'Amount',
		'totalNTD': 'Total (NTD)',
		'newTaiwanDollar': 'NTD',
		'salaryStructure': 'Salary structure',
		'payrollItems': 'Salary item',
		'pleaseSelectAReason': 'Please select the reason.',
		'theReasonForTheChangeIsDisabled': ' PM ',
		'theReasonForTheChangeHasBeenDeleted': ' PM ',
		'ruleVars': 'Information of calculation rules change',
		'varsCause': 'Reason for salary approval',
		'structureVars': 'Information of salary structure change',
		'payAlteredAfter': 'There is already a salary adjustment record after the effective date of the change.',
	},
	'hp.m5.m510010.wf021': {
		'overtimeCheckError': 'Overtime request form error detected.',
		'theFormInformationIsIncomplete': 'Incomplete form information.',
		'overtimeWorkersDoNotIncludeEmployees': 'Employees requesting overtime do not include those applying the approval process.',
		'thereIsAnErrorInThe': 'Error in applying the approval process.',
		'addANewStroke': 'Add an entry',
		'sinceTheOvertimeHoursAreHours': 'The approval process cannot be generated as the overtime hours are 0. Please select other employees.',
		'common': 'Total',
		'totalEmps': 'Total <%=temp1%> employee<%=temp2%>.',
		'employee': ' employee<%=temp1%>',
		'deducted': 'Deduct rest time',
		'companyRegulations': 'Deciding whether to deduct break time according to company regulations.'
	},
	'hp.m5.m510010.wf021_row': {
		'advancedSearch': 'Advanced search',
		'overtimePayCanOnlyBeClaimed': 'Only overtime pay can be requested.',
		'youCanOnlyApplyForCompensatory': 'Only compensatory time can be requested.',
		'overtimePayCompensatoryLeave': 'Overtime pay + compensatory time',
		'employeeNumberNameEnglishName': 'Staff ID / Name',
		'listOfEmployees': 'Staff roster',
		'selected': 'Selected',
		'importIn': 'Import',
		'bit': 'employee(s)',
		'ifOvertimeAllowedDuringRest': 'If overtime work is allowed during rest periods, rest periods will ',
		'deductedRestPeriods': ' ',
	},
	'hp.m5.m510010.wf011': {
		'batchLeaveApplicationIsSuccessful': 'Batch leave request form submitted successfully.',
		'batchLeaveRequestFailed': 'Batch leave request form submission failed.',
		'aMaximumOfGroupsCanBe': 'Up to 20 leave requests may be submitted.',
		'theLeaveApplicantDoesNotInclude': 'Employees taking leave do not include those applying for the approval process.',
		'sinceTheNumberOfLeaveHours': 'The approval process cannot be generated as the leave hours are 0. Please select other employees.',
		'total': '<%=temp1%> - <%=temp2%> Total <%=temp3%> <%=temp4%>',
		'of': 'of',
	},
	'hp.m5.Commons': {
		'formNumber': 'Form no. <%=temp1%>',
		'addApproverPrior': 'Add approvers before my approval.',
		'exceedApprovalTimeTitle': 'Exceeds the approval time.',
		'overTimeLimitRejection': 'The form can only be rejected as the approval time expired.',
		'pendingAtOthers': 'The form is pending approval from other personnel.',
		'overrule': 'Reject',
		'rejection': 'Rejection',
		'reject-pastTense': 'rejected',
		'approved': 'Approve',
		'approval': 'Approval',
		'signOff': 'Approval',
		'preSignoff': 'Pre-approval',
		'operate': 'Operation',
		'failure': '<%=temp1%> failed',
		'theFormHasAlreadyBeenSigned': 'This form has been approved by another person and does not need further processing.',
		'theFormCannotBeSignedPlease': ' cannot be approved. Please confirm the leave status.',
		'failure2': '<%=temp1%> failed: <%=temp2%>',
		'oopsThereIsAnAbnormalStatus': 'Oops! Anomalous leave data.',
		'ifSomeOfTheLeaveIn': 'Partial leave data in this form is anomalous. You may reject this form or cancel its rejection and approve this form after the data is verified.',
		'oopsThereIsAnAbnormalState': 'Oops! Anomalous overtime data.',
		'ifThereIsAnAbnormalState': 'Partial overtime data in this form is anomalous. You may reject this form or cancel its rejection and approve this form after the data is verified.',
		'oopsThereIsAnAbnormalStatus2': 'Oops! Anomalous salary change.',
		'oopsPersonnelAbnormalStatus': 'Oops! Anomalous staffing change.',
		'oopsTheBatchLeaveHasAn': 'Oops! Anomalous batch leave data.',
		'ifSomeOfTheLeaveRequests': 'Partial leave data in this form is anomalous. You may reject this form or cancel its rejection and approve this form after the data is verified.',
		'oopsBatchOvertimeHasAnAbnormal': 'Oops! Anomalous batch overtime data.',
		'oopsAttendanceAbnormalStatus': 'Oops! Anomalous attendance data <%=temp1%>',
		'time': 'Period',
		'ifThereIsAnAbnormalStatus': 'Partial attendance data <%=temp1%> in this form is anomalous. You may reject this form or cancel its rejection and approve this form after the data is verified.',
		'oopsThereIsAnAbnormalState3': 'Oops! Anomalous overtime pre-approval data.',
		'theNumberOfApplicationHoursIs': 'There is a change in the hours requested.',
		'originalApplication': 'Originally requested: ',
		'actualApproval': 'Actually approved: ',
		'signoffStatus': 'Approval status: ',
		'pendingYourSignOff': 'Waiting for your approval',
		'waitingForYourReply': 'Waiting for your reply',
		'downloadExceptionError': 'Download anomalous <%=temp1%>, error',
		'list': 'list',
		'information': 'information',
		'theDownloadFormDidNotWork': 'Form not downloaded.',
		'downloadException': 'Download anomalous <%=temp1%>',
		'yourSignatureResult': 'Your approval result:',
		'currentProcessSignOff': 'Current process: Approving.',
		'currentProcessApproved': 'Current process: Approved.',
		'endTheProcess': 'Process ended.',
		'currentProcessRejection': 'Current process: Rejected.',
		'currentProcessLottery': 'Current process: Form withdrawn.',
		'currentProcessDeleteTheOrder': 'Current process: Form deleted.',
		'mainBusinessContractors': 'Main person in charge: ',
		'contractorPhone': 'Tel. of the person in charge.',
		'drawOrders': 'Withdraw form',
		'deleteAList': 'Delete form',
		'unarchive': 'Cancel archiving',
		'approved2': 'Approved',
		'batchTempCompleted': '<%=temp1%> by batch successfully.',
		'oopsNoneOfThemCanBe': 'Oops ! All cannot be approved.',
		'approvedTemp': '<%=temp1%> forms have been approved.',
		'personnelRepeatsTempPen': '<%=temp1%> form<%=temp2%> with same employees.',
		'reselect': 'Reselect',
		'iKnow': 'I understand.',
		'skipAndProceedWithSignOff': 'Skip and continue approval.',
		'restAssuredThatOtherFormsHave': 'Don’t worry. The other forms have been approved.',
		'youChoseForm': 'You selected <%=temp1%> forms.',
		'approvalSignOffComplete': 'Approved > Approval completed',
		'signOffOnComments': 'Approval opinion',
		'sign': 'Countersign',
		'pleaseSelectTheCountersigner': 'Please select countersigner.',
		'pleaseSelectAPersonWhoAsked': 'Please select personnel.',
		'syncNotificationsCheckable': 'Simultaneous notification (multiple choice)',
		'selectSyncNotifiers': 'Please select personnel.',
		'ifYouDoNotNeedTo': 'Confirm directly if adding is not required.',
		'allTemp': 'All <%=temp1%>',
		'pen': '<%=temp1%><%=temp2%> form(s)',
		'restAssuredThatTheOtherForms': 'Don’t worry. The other forms have been <%=temp1%>.',
		'oopsAllCannotBe': 'None of the forms can be <%=temp1%>.',
		'processedPens': '<%=temp1%> form(s) has(have) been processed.',
		'restAssuredThatOtherFormsHave2': 'Don’t worry. The other forms have been processed.',
		'cause': '<%=temp1%> Reason',
		'repeatSignOff': 'Repeated approval.',
		'inAdditionThisFormHasAlready': 'The <%=temp1%> form(s) has(have) been approved by another person and does(do) not need your further processing.',
		'inAdditionThisFormHasAlready2': ' The <%=temp1%> form(s) has(have) completed the approval process and does(do) not need your further processing.',
		'duplicationOfPersonnel': 'Same personnel',
		'thePersonYouSelectedIsAlready': 'The personnel you selected has been an approver/a replier/an applicant. Please select again or continue approving other forms.',
		'thePersonYouSelectedIsAlready2': 'The personnel you selected has been an approver/a replier/an applicant.',
		'hasServedAsASignator': 'Has been an approver.',
		'thoseWhoHaveRespondedToComments': 'Has been a replier.',
		'isAFormApplicant': 'Is a form submitter.',
		'unableToSignOff': 'Approval not available.',
		'inAdditionThisFormCannotBe': 'The <%=temp1%> form(s) cannot be approved.',
		'inAdditionThisFormCannotBe2': 'The <%=temp1%> form(s) cannot be approved due to the following reason(s).',
		'cannotSignOffTheseAs': 'The <%=count%> form(s) cannot be <%=action%>.',
		'restrictCountersignTitle': 'Function of  countersignature not available.',
		'restrictCountersignMsg': 'The selected form only has approval permissions and cannot use the countersignature function.',
		'restrictAskMsg': 'The selected form only has approval permissions and cannot use the inquiry function.',
		'systemError': 'System error',
		'theAskForOpinionFeatureIs': 'Function of asking for opinions not available.',
		'theSelectedWindowSheetIsThe': 'The function of asking for opinions is not available as the selected form is at the last stage.',
		'theFormHasRespondedToComments': 'The form has been replied.',
		'theSignOffProcessHasEnded': 'Reply is not available as the approval process has ended.',
		'respondToComments': 'Give opinions',
		'opinion': 'Reasons',
		'enterYourOpinionUpToWords': 'Enter opinions, up to 100 words.',
		'youHaveAlreadyServedAsA': 'The personnel has been an approver. Please reselect.',
		'alreadyAResponderToTheOpinion': 'The personnel has been a replier. Please reselect.',
		'confirmTheAddition': 'Confirm the adding',
		'completeTheAdditionOfPreSigners': 'Adding of the pre-approver completed.',
		'thisFunctionIsToAddA': 'This function is intended to add an approver to approve the form [before] your approval. <%=temp1%> You cannot continue the approval process until the approval result of the approver is released.',
		'pleaseSelectASignOff': 'Please select approver.',
		'ifYouDoNotNeedTo2': 'Confirm rejection directly if adding is not required.',
		'confirmTheRejection2': 'Confirm rejection',
		'rejected': 'Rejected',
		'ifYouDoNotNeedTo3': 'Confirm approval directly if adding is not required.',
		'confirmApproval': 'Confirm approval',
		'askForOpinions': 'Ask for opinions',
		'endProcess': 'Process ended <%=temp1%>',
		'applied': 'Requested',
		'toBeSigned': 'Waiting for approval',
		'replied': 'Replied',
		'toBeReplied': 'Waiting for reply',
		'pleaseEnterAReason': 'Please enter the reason.',
		'cause2': 'Reason: ',
		'cause3': 'Reason',
		'opinion2': 'Reasons:',
		'theChangeOfSignOffWas': 'Approver changed successfully.',
		'noNewSignOffIsSelected': 'A new approver has not been selected.',
		'forFormApplicantsPleaseSelectAgain': 'The personnel is a form submitter. Please reselect.',
		'noChangeInSignOff': 'Approver not changed.',
		'changeTheSignoffper': 'Change Approver',
		'formNumber2': 'Form no. ',
		'raw': 'Original',
		'change': 'Change',
		'systemExceptionDataWriteFailed': '(System anomaly data writing failed.)',
		'theCounterSignerAndThePerson': 'The countersigner should not be the same as the personnel to ask for opinions.',
		'addSignOffFormer': 'Add approver *(previous)',
		'theRemainingWereNotSigned': 'There are <%=temp1%> forms not to be approved. Please reselect',
		'ifSomeOfTheAbnormalItems': 'Partial staffing change data in this form is anomalous. You may reject this form or cancel its rejection and approve this form after the data is verified.',
		'notified': 'Notified',
		'notNotified': 'Waiting for notification',
		'changed': 'Change approver',
		'viewChanged': 'View',
		'notifiedCkpDesc': 'Notification recipients',
		'sysSigned': 'System proxy signature',
		'flowEnd': 'End',
		'agent': 'Substitute',
		'changeSignerFail': 'Failed to change approver',
		'signersLostSync': 'The information of the approver has been updated. Please refresh and try again.',
		'duplicatedOldEmp': 'The original approver for the same workflow stage cannot be duplicated. Please reselect.',
		'duplicatedNewEmp': 'The same approver(s) already exist for the stage. Please confirm if you wish to make changes.',
		'oldSigner': 'Original approver',
		'newSigner': 'New approver',
		'oldSigner2': 'Original approver',
		'newSigner2': 'New approver',
		'changer2': 'Changer',
		'changeTime2': 'Change time',
		'notifyTime': 'Notification time',
		'notifiedEmp': 'Recipient',
		'downloadSummaryTable': 'Download summary table',
		'downloadForm': 'Download',
		'downloadTime': 'Download time:',
		'systemAnomaly': '(System anomaly)',
		'person': 'Main person in charge',
		'personTel': 'Tel. of the person in charge',
		'latestTime': 'Latest processing time',
		'formNo': 'Form no.',
		'downloadTime2': 'Download time',
		'onlyApprove': 'Only approve',
		'oopsFormId17Title': 'Oops! Anomalous shift data.',
		'oopsFormId17Msg': 'Shift data in this form is anomalous. You may reject this form or cancel its rejection and approve this form after the data is verified.',
		'isMultiTip3': 'Approval from all members is required.',
		'isMultiTip4': 'Approval from one person is required.',
		'oopsCancelLeaveAnAbnormalStatus': 'Oops! Anomalous leave resumption data.',
		'ifCancelLeaveTheAbnormalItems': 'Leave resumption data in this form is anomalous. You may reject this form or cancel its rejection and approve this form after the data is verified.',
		'systemReject': ' (System Rejected)',
	},
	'hp.m5.Commons,Decision.Footer': {
		'approve': 'Approving',
		'reject': 'Rejecting',
		'terminate': 'Withdrawing',
		'delete': 'Deleting',
	},
	'hp.m5.Commons.Decision.Mail': {
		// 'title': '(EN)簽核中...',
		'signingOffMsg': 'Approving. Please wait.',
		'signOffConfirmMsg': 'Please confirm whether to <%=action%>?',
		'confirmBtn': 'OK',
		'cancelBtn': 'Cancel',
		'cancelledMsg': 'Cancelled. The approval was not submitted.',
		'notExist': 'No data.',
		'beWithdrawn': 'The form has been withdrawn.',
		'beDeleted': 'The form has been deleted.',
		'beSignedOff': 'The form has been approved.',
		'cannotSignOff': 'Cannot approve. Please check the form information.',
		'signOffSuccess': 'Approval successful.',
		'rejectSuccess': 'Rejection successful.',
	},
	'hp.m5.m510010.index': {
		'profileLoadingError': 'Profile loading error.',
		'unableToApply': 'Submission not available.',
		'youDonTCurrentlyHaveA': 'You currently have no forms available for submission.',
		'theAdditionSuccess': 'Added <%=temp1%> successfully',
		'theNewFailed': '<%=temp1%> submission failed',
		'toFindOutPleaseProceedWith': 'Continue the request',
		'returnToRefill': 'Back and refill',
		'leaveHoursCanBeRequested': 'Available leave hour(s)',
		'leaveStatistics': 'Leave Statistics',
		'generalLeaveWork': 'General leave',
		'noUpperLimit': 'No limit',
		'compensatoryLeave': 'Compensatory time',
		'elasticFake': 'Flexible leave',
		'secondary': 'time',
	},
	'components.AttachFile': {
		'unableToUploadExecutableFileE': 'EXE files cannot be uploaded',
		'maximumFileSizeMB': '.',
		'filesExceedTheLimitOfMB': 'File exceeds the limit of 3 MB.',
		'unsupportedFileTypes': 'Unsupported file type.',
		'pleaseSelectAtLeastFiles': 'Please select at least  <%=temp1%> file(s)!',
		'theFileNameCannotContainSpecial': 'File name should not contain special characters <%=temp1%>.',
		'fileSizeExceedsLimit': 'File size over limit!',
		'uploadFailed': 'Uploading failed! <%=temp1%>',
		'deleteFailed': 'Deletion failed!',
		'noFileSelected': 'No file is selected!',
		'uploadTheFile': 'Upload the file',
	},
	'hp.m5.commonsDetail': {
		'applicationTime': 'Request time',
		'costCenter': 'Cost center',
		'overtimeCategory': 'Overtime type',
		'overtimePeriod': 'Overtime period',
		'workOvertime': 'Overtime',
		'overtime': 'Overtime',
		'hours': 'hours',
		'waysOfWorkingOvertime': 'Overtime redemption method',
		'support': 'Receipt',
		'missedMealFee': 'missed meal allowance',
		'payForMissedMeals': 'Receipt of missed meal allowance',
		'reasonForOvertime': 'Overtime reason',
		'failedToLoadJudgmentCardSwipingTimeSetting': 'Clock-in/out time determination setting loading failed.',
		'theDayTheEventOccurred': 'Event date',
		'theReasonForTheDayThe': 'Event date and reason',
		'timeOff': 'Leave time',
		'leaveDate': 'Leave date',
		'jobAgent': 'Substitute',
		'signOffAgent': 'Substitute approver',
		'reasonForTakingLeave': 'Leave reason',
		'contentOfTheApplication': 'Request content',
		'leavePerson': 'Employee taking leave',
		'overtimers': 'Employee requesting overtime',
		'costCenterByEmployeePayroll': 'By employee salary cost center',
		'reasonsForTheWriteOff': 'Reason for leave resumption',
		'holidayTemp': 'Holiday <%=temp1%>',
		'totalSalary': 'Total salary',
		'totalItems': '<%=temp1%> item<%=temp2%> in total.',
		'shift': 'Shift',
		'formNo': 'Form no.',
		'shiftAdjustmentTime': 'Shift adjustment time',
	},
	'hp.service.m5.service-m510010_wf010': {
		'err490': 'System integration fields have not been configured.',
		'err490Last': 'System integration fields have not been configured, data cannot be returned.',
		'err491': 'As no approval process is generated, the form cannot be activated.',
		'err492': 'Form writing failed.',
		'err493': 'Attachment writing error.',
		'err494': 'Master leave file writing failed.',
		'err498': 'Leave request submission failed (other causes).',
		'err499': 'The addition or deduction item does not exist.',
		'err500': 'Employee not employed during the addition/deduction period.',
		'err501': 'The addition/deduction amount must be greater than 1.',
		'err502': 'The currency for the adjustment item does not exist.',
		'err503': 'The addition/deduction amount can have up to X decimal places.',
		'err504': 'The cost center assignment method does not exist.',
		'err505': 'The cost center does not exist.',
		'err506': 'If the cost center is set to “According to employee salary cost center”, it is not required to enter the cost center and allocation amount.',
		'err507': 'If the cost center is set to “Custom Cost Center”, it is required to enter the cost center and allocation amount.',
		'err508': 'The allocated cost can have up to X decimal places.',
		'err509': 'The total allocated amount must equal the addition/deduction amount.',
		'err510': 'The special leave name does not exist.',
		'err511': 'The special leave has been deactivated.',
		'err512': 'The annual leave period does not exist.',
		'err513': 'Duplicate annual leave carryover settings for special-leave exception personnel.',
		'err514': 'The leave for this year has already been carried over.',
		'err515': 'There is no special leave for the year X.',
		'err516': 'The carry-forward method does not exist.',
		'err517': 'Prioritize handling of non-existent items.',
		'err518': 'The selected carryover method does not align with the required/optional status of the priority processing fields.',
		'err519': 'The option for the post-carry-forward period does not exist.',
		'err520': 'If the post-carry-forward period is "May be taken at any time during the next annual leave year", it is not required to enter days or date.',
		'err521': 'If the post-carry-forward period is "Must be used within X days in the next annual leave year", the days is required, and the date is not required to enter.',
		'err522': 'If the cost center is set to “Must be used by MM/DD in the next annual leave year”, the date is required, and the days is not required to enter.',
		'err523': 'Days must be a positive integer.',
		'err524': 'Days must be a positive integer starting from 1.',
		'err525': 'Days must be a positive integer up to 99.',
		'err526': 'The date format is incorrect.',
		'err527': 'Max 500 characters.',
		'err528': 'Updated max 5 files.',
		'err529': 'There is a cost center duplication.',
		'err530': 'File exceeds the limit of 3 MB.',
	},
	'hp.service.m5.service-m510010_wf021': {
		'theBatchOvertimeOrderApplicationWas': 'Batch overtime request form submitted successfully.',
	},
	'hp.m5.m510010.wf011_row': {
		'bit': 'employee(s)',
	},
	'app.api.wf.api-wf040': {
		'employeesWhoDoNotNeedTo': 'Non-shift employees are not allowed to take leave.',
	},
	'hp.service.m5.service-m510010_wf060': {
		'thereAreNoChangesInPersonnel': 'The staffing change item has changes not in effect.',
		'thereAreRelativelyNewChangesIn': 'The staffing change item has newer changes not in effect.',
		'notInEffect': 'Not in effect',
	},
	'hp.m4.m410120': {
		'changeTheAccountID': 'Change account',
		'changeTheLoginPassword': 'Change login password',
		'changeThePaybagPassword': 'Change payroll password',
		'changeThePasswordWhenLoggingIn': 'Change the password to log in to the system.',
		'payrollBag': 'Payroll',
		'pleaseBeAssuredThatThisIs': 'Don’t worry. This is to change the electronic payroll password which is different from the login password.',
		'identifyTheChange': 'Confirm the change',
		'theAccountIDHasBeenChanged': 'Account changed successfully.',
		'theAccountIDWasChangedIncorrectly': 'Account change error.',
		'theOriginalAccountIDIsInconsistent': 'Not match with the original account.',
		'accountDataDoesNotExist': 'Account data does not exist.',
		'theNewAccountIDIsThe': 'New account is the same as the old account.',
		'enterTheSameIDAsThe': 'Original account entered is the same as the new account.',
		'originalAccountNumber': 'Original account',
		'newAccount': 'New account',
		'pleaseEnterANewAccountNumber': 'Please enter the new account.',
		'theLoginPasswordWasChangedSuccessfully': 'Login password changed successfully.',
		'failedToChangeLoginPassword': 'Login password change failed.',
		'theOldPasswordWasEnteredIncorrectly': 'Incorrect old password entered.',
		'theOldAndNewPasswordsCannot': 'New and old passwords should not be the same. Please confirm.',
		'theNewPasswordIsInconsistentPlease': 'New passwords do not match. Please confirm.',
		'originalPassword': 'Original password <%=temp1%>.',
		'newPassword': 'New password <%=temp1%>.',
		'thePayrollBagPasswordWasChanged': 'Payroll password changed successfully.',
		'failedToChangePayrollBagPassword': 'Payroll password change failed.',
		'theApplicationDoesNotExist': 'Application does no exist.',
		'theEmployeePaybagPasswordInformationDoes': 'Staff payroll password data does not exist.',
		'thePayrollBagPasswordStatusIs': 'Payroll password status error.',
		'payrollBagPasswordToBeEnabled': 'Payroll password waiting for activation.',
		'thePayrollBagPasswordIsLocked': 'Payroll password locked.',
		'thePaybagPasswordHasBeenDeactivated': 'Payroll password deactivated.',
		'enteredTooManyTimesByError': 'Due to too many incorrect account login attempts, the account has been locked.',
		'thePasswordWasChangedSuccessfully': 'Password changed successfully.',
		'textAndNumberCheck': 'Text/number check',
		'thePasswordMustBeCheckedFor': 'Error detected: Password does not contain special characters.',
		'theOldAndNewPasswordsCannot2': 'New and old passwords should not be the same.',
		'changeTheEmailLanguage': 'Change email language',
		'theUserLanguageFamilyWasModified': 'Email language changed successfully.',
		'failedToModifyUserLanguage': 'Email language change failed.',
		'mailLanguage': 'Email language',
		'dataNotModified': 'No data is modified.',
		'languageDataError': 'Email language error.',
	},
	'hp.m4.m410121': {
		'filledIllustrate1': 'If you use multiple commute modes, please select the primary mode of transport used for commuting.',
		'filledIllustrate2': 'Do not include transportation used for client visits.',
		'transName': 'Transportation',
		'commuteStloc': 'Departure',
		'commuteDsloc': 'Destination',
		'commuteKM': 'Distance',
		'fillSelectedAddress': 'Enter the address and select from the dropdown',
		'GPSCoordinate': 'GPS Coordinates',
		'add': 'Add Row',
		'save': 'Save',
		'showMap': 'Show Map',
		'hideeMap': 'Hide Map',
		'km': 'km',
		'lastSave': 'Last saved time:',
		'saveSuccessfully': 'Saved successfully.',
		'dataIsNotEdited': 'No changes were made.',
		'stlocAndDslocCanNotBeSame': 'Distance cannot be "0". Please adjust the departure and destination.',
		'selectTaichungStation': 'Please select Taichung MRT station',
		'selectTaipeiStation': 'Please select Taipei MRT station',
		'selectTaoyuanStation': 'Please select Taoyuan MRT station',
		'selectHighSpeedStatsion': 'Please select Taiwan HSR station',
		'requiredField': 'Required field',
		'serialNumber': 'No.',
	},
	'wf.normal': {
		'waitingForApproval': 'Waiting for approval by approver.',
		'approvalCompleted': 'Approval completed',
		'formHasBeenSigned': 'The form has been approved by another person.',
		'formInAccess': '(EN)其它使用者正在簽核此表單，請稍後重試',
	},
	'wf.service.wf010': {
		'noThisForm': 'Form not found.',
		'noThisLeave': 'Leave data not found.',
		'cannotVerifyHour': 'Hour check not available.',
	},
	'app.api.wf.api-global': {
		'getWFReqBasic.404': 'Form operation not available.',
		'isCalOrClose1': 'Leave may have been calculated or archived.',
		'isCalOrClose2': 'Leave may have been resumed, calculated or archived.',
		'noOneNeedsToSignOff': 'No one needs to approve.',
	},
	'app.api.wf.api-wf010': {
		'noLimit': 'No limit',
		'used': 'Used',
		'remains': 'Available',
	},
	'app.api.wf.api-wf030': {
		'empNotWorking': 'Employee is unemployed on the date.',
		'FutureDateNotAllowed': 'Future date cannot be selected.',
		'TheApplicationTimeIsDuplicate': 'No request time conflict is allowed.',
		'TheApplicationTimeIsDuplicate2': 'The same clock-in/out time already exists.',
		'reachForgetCheckinLimit': 'Over the limit of missed clock-ins/outs.',
		'noFlowNoForm': 'As no approval process is generated, the form cannot be activated.',
	},
	'app.api.wf.api-wf020': {
		'pleaseUpgradeToTheLatestVersionOfAPP': 'Please upgrade APP to the latest version to submit overtime request forms.',
		'overtimeHoursAndInconsistentCostCenterAllocation': 'The overtime hours calculated using the overtime redemption method do not match with those allocated to the cost center.',
		'hoursOfCompensatoryLeaveAndInconsistentCostCenterAllocation': 'The compensatory time hours calculated using the overtime redemption method do not match with those allocated to the cost center.',
		'overtimeTotalHoursIsInconsistentCostCenterAllocation': 'The total hours calculated using the overtime redemption method do not match with those allocated to the cost center.',
		'overtimePayAndCompensatoryLeaveFor': 'The overtime pay and ompensatory time of the cost center cannot equal to 0 at the same time.',
	},
	'components.HP': {
		'arrivalDate': 'Report-to-duty date',
	},
	'hp.service.service-am-utils': {
		'processed': 'Processed',
		'work': 'At work',
		'offWork': 'Off work',
		'overtimeTempBegins': 'Overtime starts (<%=temp1%>)',
		'overtimeBegins': 'Overtime starts',
		'overtimeTempEnds': 'Overtime ends (<%=temp1%>)',
		'endOfOvertime': 'Overtime ends',
		'restTempGoOut': 'Go out for break (<%=temp1%>)',
		'restAndGoOut': 'Go out for break',
		'restTempReturns': 'Come back from break (<%=temp1%>)',
		'restBack': 'Come back from break',
		'takeLeaveTempToGoOut': 'Go out on leave (<%=temp1%>)',
		'takeTimeOffWorkToGo': 'Go out on leave',
		'leaveTempIsReturned': 'Come back from leave (<%=temp1%>)',
		'leaveToReturn': 'Come back from leave',
		'testTest': 'Test, test',
	},
	'hp.m5.m510030': {
		'pleaseSelectACompany': 'Please select company.',
		'formName': 'Form name',
		'search': 'Searching',
		'searchForTheApplicantOrForm': 'Applicant/Staff be changed/Form no.',
		'batchApproval': 'Approve by batch',
		'lotRejection': 'Reject by batch',
		'penSelected': '<%=temp1%> form(s) selected.',
		'formNumber': 'Form no.',
		'summaryInformation': 'Summary',
		'signoffAgent': 'Approver substitution: <%=temp1%>',
		'dedcutedRestTime': 'If overtime work is allowed during rest periods, rest periods will be deducted.',
		'notDedcutedRestTime': 'If overtime work is allowed during rest periods, rest periods will not be deducted.'
	},
	'hp.m5.m510031': {
		'signOffOnTheResults': 'Approval result',
		'commentsHaveBeenRepliedTo': 'Replied',
		'noResponse': 'No reply',
		'agentSignOff': 'Approval by substitute approver',
		'formSignOffStatus': 'Status',
		'completed': 'Completed',
		'terminated': 'Terminated',
		'otherLevelsAreSignedOff': 'Approval in progress in other stages',
		'signoffTime': 'Approval time',
		'whenYouSignOff': 'Your approval time',
		'youSignOffOnTheResults': 'Your approval result',
		'overrule': 'Rejected',
		'approved': 'Approved',
	},
	'app.api.wf.api-wf060': {
		'retiredOrganizationalCategoriesDepartmentsCannotBe': 'Deactivated organization types are departments that cannot changed.',
	},
	'app.service.wf.service-wf060': {
		'theChangeOfClassAttributesIs': 'Shift nature is changed to “fixed shifts”.',
		'theChangeInClassAttributesIs': 'Shift nature is changed to “rotating shifts” (by shift).',
		'theChangeInClassAttributesIsection': 'Shift nature is changed to “rotating shifts” (by period).',
		'needsToBeSet': '<%=temp1%> should be set <%=temp2%>.',
		'cannotBeSet': '<%=temp1%> it is not allowed to set <%=temp2%>',
		'classAttributeChangeIsNotRequired': 'Shift nature is changed to “shift scheduling is not required” (requested based on hours),',
		'attachEdError': 'Writing of attachment into staff profile failed.',
		'attachPbError': 'Writing of attachment into the master attendance file failed.',
	},
	'app.api.wf.api-wf070': {
		'salaryAccountCurrencyDataIsNot': 'No salary account + currency data conflict is allowed.',
		'attachError': 'Writing of attachment into salary data failed.',
	},
	'hp.service.m5.service-global': {
		'signOffSignoff': 'Approve as a substitute for <%=temp1%>.',
		'signatureResult': 'Substitute approver <%=temp%> - <%=result%>.',
		'notAnApplicantOrProcessorWith': 'Not the “applicant” or a “processor with edit permission”.',
		'hasBeenDrawnBySomeoneElse': 'Withdrawn by another person.',
		'hasBeenDeletedByOthers': 'Deleted by another person.',
		'hasBeenSignedOffBySomeone': 'Approved by another person.',
		'theFormStatusIsNotSignoff': 'Form status: Not being approved.',
		'formNumberFailedToDelete': 'Form no. <%=temp1%>  deletion failed.',
		'unableToDeleteOrder': 'Cannot be deledted.',
		'systemDetectsTheCauseOfAnomaly': 'System detects the cause of anomaly.',
		'attendanceTime': 'Attendance time',
		'anomalousData': 'Anomalous data',
	},
	'app.api.wf.api-track': {
		'thereIsNoSuchForm': 'Form does not exist.',
		'theFormCannotBeResent': 'Form cannot be resubmitted.',
	},
	'wf.service.wf011': {
		'failedToDeleteBatchesOfLeaveRequests': 'Batch leave request form deletion failed.',
	},
	'wf.service.wf020': {
		'theOvertimeCategoryIsInconsistentAfterTheCreditCardInformationIsAdjusted': 'The overtime type after the clock-in/out data is adjusted does not match with that in the form initially submitted.',
		'theAllocationAfterTheTransactionIsInconsistent': 'The overtime/compensatory time hours after change do not match with those allocated to the cost center.',
		'inconsistentCardInformationAfterAdjustment': 'The overtime type after the clock-in/out data is adjusted does not match with that in the form initially submitted.',
	},
	'wf.api.wf021': {
		'new.err495': 'There should be no more than 10 teams working overtime in a single form.',
		'new.err496': 'There should be no more than 100 employees working overtime in a single form.',
	},
	'wf.service.wf021': {
		'failedToDeleteBatchesOfOvertimeOrders': 'Batch overtime request form deletion failed.',
		'zeroOverTime': 'The approval process cannot be generated as the overtime hours are 0. Please select other employees.',
		'totally': 'Total',
	},
	'wf.service.wf040': {
		'noThisForm': 'Form not found.',
		'employeesWhoDoNotNeedTo': 'Non-shift employees are not allowed to take leave.',
	},
	'wf.service.wf064': {
		'nonEffectiveResignationJob': 'There are resignation operations not in effect.',
		'theResignationDateMustBeGreaterThanTheStayEffectiveDate': 'Resignation effective date should be later than the leave without pay effective date.',
		'theLeavingDateMustBeGreaterThanTheStartingDate': 'Resignation effective date should be later than or equal to the report-to-duty date.',
	},
	'wf.service.wf065': {
		'thereArePendingStayOperations': 'There are leave without pay operations not in effect.',
		'thereArePendingReinstatementOperations': 'There are reinstatement operations not in effect.',
		'noReinstatementOperations': 'There are no reinstatement operations.',
		'theStayDateMustBeGreaterThanTheDutyDate': 'Leave without pay effective date should be later than or equal to the report-to-duty date.',
		'theStayDateMustBeGreaterThanTheLastReinstatementDate': 'Leave without pay effective date should be later than or equal to the previous return-to-work date',
		'effectiveDateOfStayAndStayYypeCannotBeRepeated': 'No leave without pay effective date + leave without pay type conflict is allowed.',
	},
	'h2.service.am.attend': {
		'totalCountOIs0': 'Total hours are 0.',
	},
	'hp.H2Inputs': {
		'laborInsuranceInsuredUnits': 'Labor insurance policyholder',
		'healthInsuranceInsuredUnits': 'Health insurance policyholder',
		'departmentalLevel': 'Department level',
	},
	'sp.wf020.am.emp.ot.check': {
		'code01': 'Employee is unemployed or there is no shift time data available on this date.',
		'code11': 'There is no such employee in the company.',
		'code12': 'The company has no such overtime type.',
		'code13': 'Overtime parameters cannot be read.',
		'code14': 'Overtime range earlier than the system’s earliest leave date.',
		'code15': 'Overtime range later than the system’s latest leave date.',
		'code16': 'Overtime range misses the overtime request deadline.',
		'code17': 'Overtime range is not entitled to annual leave.',
		'code18': 'Such overtime period is unopened.',
		'code19type1': 'Employment status: Failed to report to duty.',
		'code19type2': 'Employment status: Leave without pay.',
		'code19type3': 'Employment status: Resigned',
		'code20': 'No overtime request is allowed for the overtime range.',
		'code21': 'Overtime range exceeds the period during which overtime is allowed.',
		'code22': 'Overtime range falls within the period during which overtime is prohibited.',
		'code23': 'Overtime should not conflict with other items.',
		'code24': 'Attachment is required.',
		'code25': 'Prior overtime request submission is required.',
		'code26': 'Overtime request submission should be completed within <%=A%> days after the overtime is worked.',
		'code27': 'Overtime reason is required.',
		'code28': 'Overtime hours are less than the minimum hours.',
		'code29': 'Overtime hours are more than the maximum hours.',
		'code30': 'Overtime is not allowed for the calendar.',
		'code31': 'Total hours should not be 0.',
		'code32': 'Overtime has been settled.',
		'code33': 'Overtime range does not fall within the overtime vesting date.',
		'code34': 'This overtime redemption method does not apply to the employee.',
		'code35': 'Overtime data does not exist.',
		'code36': 'Overtime request rule error.',
		'code37': 'Prior overtime request submission is not allowed.',
		'code38': 'Non-shift employees are not allowed to redeem overtime hours for compensatory time.',
		'code39': 'Overtime pre-approval form is required.',
		'code40': 'Staff overtime pre-approval form does not exist.',
		'code41': 'Actual time of overtime does not fall within the scheduled time of overtime.',
		'code42': 'Overtime request submission should be completed before the overtime starts.',
		'code42type1': 'Overtime request submission should be completed within <%=A%> workdays before the overtime starts.',
		'code42type2': 'Overtime request should be approved within <%=A%> workdays before the overtime starts <%=A%>.',
		'code42type3': 'Overtime request submission should be completed within <%=A%> workdays after the overtime ends.',
		'code42type4': 'Overtime request should be approved within <%=A%> workdays after the overtime ends.',
		'code42type5': 'Overtime request submission should be completed within <%=A%> calendar days after the overtime starts.',
		'code42type6': 'Overtime request should be approved within <%=A%> calendar days before the overtime starts.',
		'code42type7': 'Overtime request submission should be completed within <%=A%> calendar days after the overtime ends.',
		'code42type8': 'Overtime request should be approved within <%=A%> calendar days after the overtime ends.',
		'code42type9': 'Overtime request submission should be completed within <%=A%> hours after the overtime starts.',
		'code42type10': 'Overtime request should be approved within <%=A%> hours before the overtime starts.',
		'code42type11': 'Overtime request submission should be completed within <%=A%> hours after the overtime ends.',
		'code42type12': 'Overtime request should be approved within <%=A%> hours after the overtime ends.',
		'code43': 'Prior overtime request submission is not allowed.',
		'code90': 'The overtime hours recalculated do not match with those allocated to the cost center.',
		'code91': 'The overtime redemption method has been changed.',
		'code44': 'There are shift change requests pending approval.',
	},
	'sp.wf020.am.emp.ot.checkDelete': {
		'code11': 'Overtime has been settled.',
		'code12': 'Overtime has been canceled.',
		'code13': 'Data file for the redemption of staff overtime for compensatory time has been settled.',
		'code14': 'Data file for the redemption of staff overtime for compensatory time has been used.',
		'code15': 'Overtime data does not exist.',
	},
	'sp.wf010.am.emp.leave.check': {
		'code11': 'There is no such employee in the company.',
		'code12': 'The company has no such overtime type.',
		'code13': 'Unemployed during the leave range.',
		'code14': 'This leave item does not apply to the employee.',
		'code15': 'Leave parameters cannot be read.',
		'code16': 'Leave range earlier than the system’s earliest leave date.',
		'code17': 'Leave range later than the system’s latest leave date.',
		'code18': 'Leave range misses the leave request deadline.',
		'code19': 'There are remaining prior leave hours.',
		'code20': 'Leave should not conflict with other items.',
		'code21': 'Later leave request submission is not allowed.',
		'code22': 'Leave request submission should be completed within <%=A%> day(s) after the leave is taken.',
		'code23': 'Substitute during leave is required.',
		'code24': 'Leave reason is required.',
		'code25': 'Attachment is required.',
		'code26': 'Remaining hours are less than the minimum hours.',
		'code27': 'Submission is not allowed until days have elapsed since the start of the probation period.',
		'code28': 'Submission is allowed only in the birth month.',
		'code29': 'Submission is allowed only on the birth date.',
		'code30': 'Leave hours are less than the minimum leave hours.',
		'code31': 'Leave hours are more than the maximum leave hours.',
		'code32': 'Exceed the limit, plus other leave hours.',
		'code33': 'Exceed the limit, plus the number of other leaves.',
		'code34': 'Has insufficient remaining hours.',
		'code35': 'Total hours should not be 0.',
		'code36': 'Leave has been resumed.',
		'code37': 'Leave may have been calculated or archived.',
		'code38': 'Substitute does not exist or is unemployed.',
		'code39': 'Exceed the available leave range.',
		'code40': 'No available hours to <%=A%>.',
		'code41': 'Part time employee has no available hours of <%=A%>.',
		'code42': 'Master staff leave file does not exist.',
		'code43': 'Event date is not set.',
		'code44': 'Leave range and overtime range conflict.',
		'code45': 'Annual leave data has been settled.',
		'code46': 'Compensatory time data has been settled.',
		'code47': 'Flexible leave data has been settled.',
		'code48': 'Employees working multiple shifts in one day should not take leave “for the first half or second half of the day”.',
		'code49': 'Non-shift employee is not allowed to take leave period.',
		'code50': 'Substitute has taken leave.',
		'code51': 'Has been a substitute for another employee during the leave time, in part or in whole.',
		'code52': 'Serving as a substitute for multiple employees simultaneously is not allowed.',
		'code53': 'Serving as a substitute for another employee is not allowed for the calendar.',
		'code54': 'Taking leave is not allowed when serving as a substitute for another employee.',
		'code55': 'Event date data does not exist.',
		'code56': 'Event date and description are the same as those in other leave data.',
		'code57': 'There should be no archiving data after the leave deadline.',
		'code58': 'Available leave hours are more than the full time employee.',
		'code70': 'Substitute is not on the list.',
		'code71': 'There are shift change requests pending approval.',
	},
	'sp.wf010.am.emp.leave.checkByHour': {
		'code11': 'There is no such employee in the company.',
		'code12': 'The company has no such overtime type.',
		'code13': 'Unemployed during the leave range.',
		'code14': 'This leave item does not apply to the employee.',
		'code15': 'Leave parameters cannot be read.',
		'code16': 'Leave range earlier than the system’s earliest leave date.',
		'code17': 'Leave range later than the system’s latest leave date.',
		'code18': 'Leave range misses the leave request deadline.',
		'code20': 'No leave item and date conflict is allowed.',
		'code21': 'Later leave request submission is not allowed.',
		'code22': 'Leave request submission should be completed within <%=A%> day(s) after the leave is taken.',
		'code23': 'Substitute during leave is required.',
		'code24': 'Leave reason is required.',
		'code25': 'Attachment is required.',
		'code31': 'Leave hours are more than the maximum leave hours.',
		'code32': 'Exceed the limit, plus other leave hours.',
		'code33': 'Exceed the limit, plus the number of other leaves.',
		'code34': 'Has insufficient remaining hours.',
		'code35': 'Total hours should not be 0.',
		'code37': 'Leave may have been calculated or archived.',
		'code38': 'Substitute does not exist or is unemployed.',
		'code39': 'Exceed the available leave range.',
		'code40': 'No available hours to <%=A%>.',
		'code41': 'Part time employee has no available hours of <%=A%>.',
		'code42': 'Master staff leave file does not exist.',
		'code43': 'Event date is not set.',
		'code44': 'Event date data does not exist.',
		'code45': 'Annual leave data has been settled.',
		'code46': 'Compensatory time data has been settled.',
		'code47': 'Flexible leave data has been settled.',
		'code48': 'The sum of leave hours and attendance hours should not exceed 24 hours.',
		'code50': 'Substitute has taken leave.',
		'code51': 'Has been a substitute for another employee during the leave time, in part or in whole.',
		'code52': 'Serving as a substitute for multiple employees simultaneously is not allowed.',
		'code53': 'Serving as a substitute for another employee is not allowed for the calendar.',
		'code54': 'Taking leave is not allowed when serving as a substitute for another employee.',
		'code56': 'Event date and description are the same as those in other leave data.',
		'code60': 'Shift is required.',
		'code61': 'Shift deactivated.',
		'code62': 'Non-shift employee is not allowed to fill in the shift.',
		'code71': 'There are shift change requests pending approval.',
	},
	'sp.wf010.am.emp.leave.checkDelete': {
		'code11': 'Leave has been settled.',
		'code12': 'Leave has been resumed.',
		'code13': 'Staff annual leave data has been settled (previous period).',
		'code14': 'Staff annual leave data has been settled (current period).',
		'code15': 'Staff compensatory time data has been settled.',
		'code16': 'Staff flexible leave data has been settled.',
		'code21': 'Master leave file error.',
	},
	'sp.wf010.am.emp.biz.checkDelete': {
		'code21': 'Master business trip file error.',
	},
	'sp.wf050.am.emp.leave.cancel.check': {
		'code11': 'There is no such employee in the company.',
		'code12': 'No leave data in this company.',
		'code13': 'Leave resumption range exceeds the leave resumption request deadline.',
		'code14': 'Calendar has been changed.',
		'code15': 'There are no sufficient leave resumption hours.',
		'code16': 'There is a leave resumption range conflict.',
		'code17': 'The leave to resume is the leave prior to another requested leave.',
		'code18': 'Leave resumption hours are less than the minimum leave hours.',
		'code19': 'Total hours should not be 0.',
		'code20': 'Leave resumption has been settled.',
		'code21': 'Leave hours are more than the remaining hours.',
		'code22': 'Leave resumption period should be falls within the leave period.',
		'code23': 'Staff annual leave data has been settled (previous period).',
		'code24': 'Staff annual leave data has been settled (current period).',
		'code25': 'Staff compensatory time data has been settled.',
		'code26': 'Staff flexible leave data has been settled.',
		'code27': 'Such data range has no leave data.',
		'code28': 'Master leave resumption file does not exist.',
		'code29': 'Leave data is in transit.',
		'code30': 'Leave has been settled.',
		'code31': 'Pay on leave has been calculated.',
		'code32': 'Leave resumption hours are more than the leave hours due to leave unit change.',
		'code33': 'There is already annual leave overtime data.',
		'code35': 'Working hours have been changed.',
		'codeL19': 'There are remaining prior leave hours.',
		'codeL20': 'Leave should not conflict with other items.',
		'codeL32': 'Exceed the limit, plus other leave hours.',
		'codeL33': 'Exceed the limit, plus the number of other leaves.',
		'codeL44': 'Leave range and overtime range conflict.',
	},
	'sp.wf050.am.emp.leave.cancel.checkDelete': {
		'code11': 'Leave resumption has been settled',
		'code12': 'Staff annual leave data has been settled (previous period).',
		'code13': 'Staff annual leave data has been settled (current period).',
		'code14': 'Staff compensatory time data has been settled.',
		'code15': 'Staff flexible leave data has been settled.',
		'code21': 'Master leave file error.',
		'code22': 'Master staff leave consumption file error.',
		'code23': 'Leave has been settled.',
		'codeL19': 'There are remaining prior leave hours.',
		'codeL20': 'Leave should not conflict with other items.',
		'codeL32': 'Exceed the limit, plus other leave hours.',
		'codeL33': 'Exceed the limit, plus the number of other leaves.',
		'codeL44': 'Leave range and overtime range conflict.',
		'codeL34': 'Has insufficient remaining hours.',
		'codeL40': 'No available hours to <%=A%>.',
	},
	'sp.wf022.am.emp.preot.check': {
		'code01': 'Employee is unemployed or there is no shift time data available on this date.',
		'code11': 'There is no such employee in the company.',
		'code12': 'The company has no such overtime type.',
		'code13': 'Overtime parameters cannot be read.',
		'code14': 'Scheduled time of overtime earlier than the system’s earliest leave date.',
		'code15': 'Scheduled time of overtime later than the system’s latest leave date.',
		'code16': 'Overtime range misses the overtime request deadline.',
		'code17': 'Overtime range is not entitled to annual leave.',
		'code18': 'Such overtime period is unopened.',
		'code19type1': 'Employment status: Failed to report to duty.',
		'code19type2': 'Employment status: Leave without pay.',
		'code19type3': 'Employment status: Resigned.',
		'code20': 'No overtime request is allowed for the overtime range.',
		'code21': 'Overtime range exceeds the period during which overtime is allowed.',
		'code22': 'Overtime range falls within the period during which overtime is prohibited.',
		'code23': 'Overtime should not conflict with other items.',
		'code24': 'Attachment is required.',
		'code25': 'Prior overtime request submission is required.',
		'code26': 'Overtime request submission should be completed within <%=A%> days after the overtime is worked.',
		'code27': 'Overtime reason is required.',
		'code28': 'Scheduled overtime hours are less than the minimum hours.',
		'code29': 'Scheduled overtime hours are more than the maximum hours.',
		'code30': 'Overtime is not allowed for the calendar.',
		'code31': 'Total hours should not be 0.',
		'code32': 'Overtime has been settled.',
		'code33': 'Overtime range does not fall within the overtime vesting date.',
		'code34': 'This overtime redemption method does not apply to the employee.',
		'code35': 'Overtime data does not exist.',
		'code36': 'Overtime request rule error.',
		'code37': 'Prior overtime request submission is not allowed.',
		'code38': 'Prior overtime request submission is required.',
		'code39': 'Later overtime request submission is not allowed.',
		'code40': 'Staff overtime pre-approval form does not exist.',
		'code41': 'Actual time of overtime does not fall within the scheduled time of overtime.',
		'code42type1': 'Overtime request submission should be completed within <%=A%> workdays before the overtime starts.',
		'code42type2': 'Overtime request should be approved within <%=A%> workdays before the overtime starts.',
		'code42type3': 'Overtime request submission should be completed within <%=A%> workdays after the overtime ends.',
		'code42type4': 'Overtime request should be approved within <%=A%> workdays after the overtime ends.',
		'code42type5': 'Overtime request submission should be completed within <%=A%> calendar days after the overtime starts.',
		'code42type6': 'Overtime request should be approved within <%=A%> calendar days before the overtime starts.',
		'code42type7': 'Overtime request submission should be completed within <%=A%> calendar days after the overtime ends.',
		'code42type8': 'Overtime request should be approved within <%=A%> calendar days after the overtime ends.',
		'code42type9': 'Overtime request submission should be completed within <%=A%> hours after the overtime starts.',
		'code42type10': 'Overtime request should be approved within <%=A%> hours before the overtime starts.',
		'code42type11': 'Overtime request submission should be completed within <%=A%> hours after the overtime ends.',
		'code42type12': 'Overtime request should be approved within <%=A%> hours after the overtime ends.',
		'code43': 'Prior overtime request submission is not allowed.',
		'code90': 'The overtime hours recalculated do not match with those allocated to the cost center.',
		'code91': 'The overtime redemption method has been changed.',
		'code44': 'There are shift change requests pending approval.',
	},
	'sp.wf022.am.emp.preot.checkDelete': {
		'code11': 'Overtime has been canceled.',
		'code12': 'Overtime data does not exist.',
	},
	'sp.wf090.am.emp.attend.check': {
		'code01': 'There is no such employee in the company.',
		'code03': 'Attendance hours should not exceed 24 hours',
		'code04': 'Attendance start time later than end time.',
		'code05': 'The attendance hours do not match with those allocated to the cost center.',
		'code06': 'Attachment is required.',
		'code07': 'Attendance reason is not provided.',
		'code08': 'Attendance hours are less than the minimum hours.',
		'code09': 'Attendance hours are more than the maximum hours.',
		'code10': 'Total hours should not be 0.',
		'code11': 'Attendance should not conflict with other attendance items.',
		'code12': 'Attendance should not conflict with overtime.',
		'code13': 'Attendance should not conflict with leave.',
		'code14': 'Employee does not set attendance hour rules.',
		'code15': 'Employee is unemployed.',
		'code16': 'Prior attendance hour request submission is not allowed.',
		'code17': 'Attendance time earlier than the system’s earliest leave date.',
		'code18': 'Shift nature of the employee’s “attendance” period does not allow submission of attendance hour requests.',
		'code19': 'Requesting attendance data from the previous <%=A%> for salary calculation is not allowed.',
		'code20': 'The sum of paid attendance hours and increments is less than 0.',
		'code21': 'Shift nature of the employee’s “attendance” period does not allow submission of attendance hour requests.',
		'code22': 'Insufficient clock-in/out data.',
		'code23': 'Attendance vesting date exceeds the attendance time.',
		'code24type1': 'Attendance hour form submission should be completed within <%=A%> calendar days after the attendance end date.',
		'code24type2': 'Attendance hour form submission should be completed within <%=A%> workdays after the attendance end date.',
		'code25': 'Request deadline parameter error.',
		'code26': 'Cost center data should not be empty.',
	},
	'sp.wf090.am.emp.attend.checkCardmatch': {
		'code11': 'Clock-in/out comparison error.',
	},
	'sp.wf020.am.emp.ot.checkCardmatch': {
		'code11': 'Clock-in/out comparison error.',
	},
	'sp.wf090.am.emp.attend.checkDelete': {
		'code11': 'Attendance hours have been settled.',
		'code12': 'Master attendance hour file error.',
	},
	'sp.wf021.wf.batch.ot.do': {
		'code01': 'Employee is unemployed or there is no shift time data available on this date.',
		'code10': 'Working hour rule error.',
		'code11': 'Clock-in/out comparison error.',
		'code12': 'The company has no such overtime type.',
		'code13': 'Overtime parameters cannot be read.',
		'code14': 'Overtime range earlier than the system’s earliest leave date.',
		'code15': 'Overtime range later than the system’s latest leave date.',
		'code16': 'Overtime range misses the overtime request deadline.',
		'code17': 'Overtime range is not entitled to annual leave.',
		'code18': 'Such overtime period is unopened.',
		'code19type1': 'Employment status: Failed to report to duty.',
		'code19type2': 'Employment status: Leave without pay.',
		'code19type3': 'Employment status: Resigned.',
		'code20': 'No overtime request is allowed for the overtime range.',
		'code21': 'Overtime range exceeds the period during which overtime is allowed.',
		'code22': 'Overtime range falls within the period during which overtime is prohibited.',
		'code23': 'Overtime should not conflict with other items.',
		'code24': 'Attachment is required.',
		'code25': 'Prior overtime request submission is required.',
		'code26': 'Overtime request submission should be completed within <%=A%> days after the overtime is worked.',
		'code27': 'Overtime reason is required.',
		'code28': 'Overtime hours are less than the minimum hours.',
		'code29': 'Overtime hours are more than the maximum hours.',
		'code30': 'Overtime is not allowed for the calendar.',
		'code31': 'Total hours should not be 0.',
		'code32': 'Overtime has been settled.',
		'code33': 'Overtime range does not fall within the overtime vesting date.',
		'code34': 'This overtime redemption method does not apply to ',
		'code35': 'Overtime data does not exist.',
		'code36': 'Overtime request rule error.',
		'code37': 'Prior overtime request submission is not allowed.',
		'code38': 'Non-shift employees are not allowed to redeem overtime hours for compensatory time.',
		'code39': 'Overtime pre-approval form is required.',
		'code40': 'Staff overtime pre-approval form does not exist.',
		'code41': 'Actual time of overtime does not fall within the scheduled time of overtime.',
		'code42type1': 'Overtime request submission should be completed within <%=A%> workdays before the overtime starts.',
		'code42type2': 'Overtime request should be approved within <%=A%> workdays before the overtime starts.',
		'code42type3': 'Overtime request submission should be completed within <%=A%> workdays after the overtime ends.',
		'code42type4': 'Overtime request should be approved within <%=A%> workdays after the overtime ends.',
		'code42type5': 'Overtime request submission should be completed within <%=A%> calendar days after the overtime starts.',
		'code42type6': 'Overtime request should be approved within <%=A%> calendar days before the overtime starts.',
		'code42type7': 'Overtime request submission should be completed within <%=A%> calendar days after the overtime ends.',
		'code42type8': 'Overtime request should be approved within <%=A%> calendar days after the overtime ends.',
		'code42type9': 'Overtime request submission should be completed within <%=A%> hours after the overtime starts.',
		'code42type10': 'Overtime request should be approved within <%=A%> hours before the overtime starts.',
		'code42type11': 'Overtime request submission should be completed within <%=A%> hours after the overtime ends.',
		'code42type12': 'Overtime request should be approved within <%=A%> hours after the overtime end.',
		'code43': 'Prior overtime request submission is not allowed.',
		'code90': 'The overtime hours recalculated do not match with those allocated to the cost center.',
		'code91': 'The overtime redemption method has been changed.',
		'code44': 'There are shift change requests pending approval.',
	},
	'sp.wf011.wf.batch.leave.do': {
		'code11': 'There is no such employee in the company.',
		'code12': 'The company has no such overtime type.',
		'code13': 'Unemployed during the leave range.',
		'code14': 'This leave item does not apply to the employee.',
		'code15': 'Leave parameters cannot be read.',
		'code16': 'Leave range earlier than the system’s earliest leave date.',
		'code17': 'Leave range later than the system’s latest leave date.',
		'code18': 'Leave range misses the leave request deadline.',
		'code19': 'There are remaining prior leave hours.',
		'code20': 'Leave should not conflict with other items.',
		'code21': 'Later leave request submission is not allowed.',
		'code22': 'Leave request submission should be completed within <%=A%> day(s) after the leave is taken.',
		'code23': 'Substitute during leave is required.',
		'code24': 'Leave reason is required.',
		'code25': 'Attachment is required.',
		'code26': 'Remaining hours are less than the minimum hours.',
		'code27': 'Submission is not allowed until days have elapsed since the start of the probation period.',
		'code28': 'Submission is allowed only in the birth month.',
		'code29': 'Submission is allowed only on the birth date.',
		'code30': 'Leave hours are less than the minimum leave hours.',
		'code31': 'Leave hours are more than the maximum leave hours.',
		'code32': 'Exceed the limit, plus other leave hours.',
		'code33': 'Exceed the limit, plus the number of other leaves.',
		'code34': 'Has insufficient remaining hours.',
		'code35': 'Total hours should not be 0.',
		'code36': 'Leave has been resumed.',
		'code37': 'Leave has been settled.',
		'code38': 'Substitute does not exist or is unemployed.',
		'code39': 'Exceed the available leave range.',
		'code42': 'Master staff leave file does not exist.',
		'code43': 'Event date is not set.',
		'code44': 'Leave range and overtime range conflict.',
		'code45': 'Annual leave data has been settled.',
		'code46': 'Compensatory time data has been settled.',
		'code47': 'Flexible leave data has been settled.',
		'code48': 'Employees working multiple shifts in one day should not take leave “for the first half or second half of the day”.',
		'code49': 'Non-shift employees are not allowed to take leave.',
		'code50': 'The job agent has asked for leave during the leave period <%=S%>~<%=E%>.',
		'code51': 'Has been a substitute for another employee during the leave time, in part or in whole.',
		'code52': 'Serving as a substitute for multiple employees simultaneously is not allowed.',
		'code53': 'Serving as a substitute for another employee is not allowed for the calendar.',
		'code54': 'Taking leave is not allowed when serving as a substitute for another employee.',
		'code55': 'Event date data does not exist.',
		'code56': 'Event date and description are the same as those in other leave data.',
		'code71': 'There are shift change requests pending approval.',
	},
	'sp.signIn.ac.user.checkPwd': {
		'code11': 'Logged in successfully.',
		'code12': 'Logged in successfully, with a password change reminder.',
		'code17': 'Default password activation account.',
		'code18': 'Change password',
		'code19': 'AD verification',
		'code21': 'Login failed.',
		'code22': 'Account being locked.',
		'code23': 'Account closed.',
		'code24': 'Account unverified.',
		'code26': 'Due to too many incorrect account login attempts, the account has been locked.',
		'code31': 'Application does no exist.',
		'code32': 'Account does not exist.',
		'code33': 'Account status error.',
		'code34': 'Verification mode error.',
		'code35': 'Account with multiple companies.',
		'code36': 'APP function not enabled.',
		'code37': 'Corporate login account has been closed. Please contact the permission administrator.',
		'code38': 'Corporate login account has been closed. Please contact the 104 service personnel.',
		'code91': 'Require sign-in with Microsoft account.',
	},
	'sp.auth.ac.user.checkPwdChange': {
		'code11': 'Activation successful',
		'code19': 'AD verification',
		'code21': 'Incorrect password entered.',
		'code22': 'Account being locked.',
		'code23': 'Account closed.',
		'code24': 'Account unverified.',
		'code25': 'Due to too many incorrect account login attempts, the account has been locked.',
		'code31': 'Application does no exist.',
		'code32': 'Account does not exist.',
		'code33': 'Account status error.',
		'code34': 'Verification mode error.',
		'code41': 'Minimum password length error detected.',
		'code42': 'Text/numeric error detected.',
		'code43': 'Error detected: Password does not contain special characters.',
		'code44': 'Time has not passed.',
		'code45': 'Same as the previous password.',
		'code46': 'New and old passwords should not be the same.',
		'code47': 'Password contains at least one capital English letter.',
	},
	'sp.auth.ac.user.checkPwdReset': {
		'code11': 'Password changed successfully.',
		'code19': 'AD verification',
		'code21': 'Incorrect password entered.',
		'code23': 'Account closed.',
		'code24': 'Account unverified.',
		'code25': 'Due to too many incorrect account login attempts, the account has been locked.',
		'code31': 'Application does no exist.',
		'code32': 'Account does not exist.',
		'code33': 'Account status error.',
		'code34': 'Verification mode error.',
		'code39': 'TOKEN error.',
		'code41': 'Minimum password length error detected.',
		'code42': 'Text/numeric error detected.',
		'code43': 'Error detected: Password does not contain special characters.',
		'code44': 'Time has not passed.',
		'code45': 'Same as the previous password.',
		'code46': 'New and old passwords should not be the same.',
		'code47': 'Password contains at least one capital English letter.',
	},
	'app.service.wf.service-global': {
		'sinceThereAreMoreThanOvertime': 'As there are over 100 employees requesting overtime, approval may only be performed in Portal.',
		'holiday': 'Holiday',
		'noneOfThemCanBeSigned': 'All cannot be approved.',
	},
	'app.service.am.service-personal-clock': {
		'theEmployeeDoesNotHaveThis': 'Employee has no such data entry.',
		'theReasonForOvertimeAttendanceCannot': 'Reason for excess attendance hours cannot be provided for this data entry.',
	},
	'hp.service.m4.service-m410070': {
		'thePreviousPeriodWasExtended': 'Extended from the previous period',
		'thisIssue': 'Current period',
	},
	'app.service.am.service-personal-leave': {
		'cancelledLeave': 'Leave has been resumed.',
	},
	'app.service.am.service-manager': {
		'totalOf': 'Total <%=temp2%><%=temp3%><%=temp4%> of leave in <%=temp1%>.',
		'totalOfAbnormal': 'Total <%=temp2%> abnormal record<%=num%> in <%=temp1%>.',
	},
	'app.service.auth': {
		'quickLoginNotCreated': 'Quick login is not created.',
		'keyVerificationFailed': 'Key verification failed.',
		'keyOperationException': 'Key operation anomaly.',
		'theUserAccountDoesNotExist': 'User account does not exist.',
		'accountLocked': 'Account being locked.',
		'accountClosed': 'Account closed.',
		'accountNotAuthenticated': 'Account unverified.',
		'theAPPFunctionIsNotTurnedOn': 'APP function not enabled.',
		'invalidRefreshToken': 'Verification failed (Please update and try again).',
		'cannotCreateRefreshToken': 'New link cannot be generated.',
		'verifyToken490': 'Token invalid (JWT).',
		'verifyToken491': 'Token expired (JWT).',
		'verifyToken492': 'Not exist (Employee may have been deleted or related data may have been deactivated or deleted).',
		'verifyToken493': 'Token invalid (Operation has been completed or logic has been changed. Please use the link in the latest email).',
		'noRelevantInformationFound': 'Related data not found (e.g., password rules).',
		'notOpenToUseAPP': 'APP not available for use.',
		'adEnableFailed': 'AD activation failed.',
		'userIsNotExist': 'User does not exist.',
		'abnormalAccountStatus': 'Anomalous account status.',
		'passwordDoesNotMatch': 'Password does not meet the length or complexity requirements of login rules.',
		'forgetPwd490': 'This account is not applicable. Please log in with a Microsoft account.',
		'forgetPwd491': 'Incorrect account.',
		'forgetPwd492': 'The account you are using is AD. To reset the AD account or password, please contact company staff. Thank you!',
		'forgetPwd493': 'Your account is unactivated. Please contact the account administrator to request another account verification email.',
		'forgetPwd494': 'Your account has been locked. Please log in to the system again after the lockout effective period passes or contact the account administrator. Thank you!.',
		'forgetPwd495': 'Your account has been closed. Please contact the account administrator. Thank you!',
		'forgetPwd496': 'Token generation failed.',
		'forgetPwd497': 'Notification email sending failed as there is no email template.',
		'forgetPwd498': 'No password notification email can be sent. Please contact the system administrator.',
		'noRelatedRulesFound': 'Related rules not found.',
		'wrongVersionNumberFormat': 'Version number format error.',
		'aadEnableFailed': 'Azure Active Directory activation failed.',
	},
	'app.service.head': {
		'userIsNotExist': 'User does not exist.',
		'noInfo': 'No data.',
	},
	'app.service.presetCode': {
		'preset401': 'Verification failed (Please update access token and try again).',
		'preset403': 'Insufficient permission.',
		'preset404': 'User does not exist.',
		'preset440': 'Parameter error (Please check if OR fields and formats are completed and correct).',
		'preset450': 'Error',
		'presetDB499': 'DB error',
		'preset499': 'System anomaly (internal).',
		'preset500': 'System anomaly.',
	},
	'app.service.file': {
		'invalidFileFormat': 'Invalid file format: ',
		'wrongFileName': 'File name should not contain special characters.',
	},
	'app.service.am.attendStatistic': {
		'theEmployeeDoesNotHaveThis': 'Employee has no such data entry.',
	},
	'app.service.am.clock': {
		'noCheckInLocations': 'No clock-in/out location available.',
		'notYetInTheCheckInRange': 'Clock-in/out range has not started.',
		'unableToGetDBTime': 'DB time cannot be retrieved.',
		'clockIn490': 'Working hour error detected.',
		'clockIn491': 'Clock-in/out time conflict.',
		'clockIn493': 'Body temperature is required for the first clock-in on the current day.',
		'clockIn494': 'Body temperature is required for the first clock-in each shift.',
		'clockIn499': 'DB error.',
		'hyperthermia': 'Abnormally high body temperature.',
		'disabledWifi': 'Wifi disabled.',
		'noWifiMatch2': 'Wifi singal cannot be detected.\nGo to the setting to activate other Wifi.',
		'noCheckInSetting': 'Unable to complete clock-in function initialization (clock-in function not enabled or no available clock-in location).',
		'checkInSettingsError': 'Error in loading the clock-in setting.',
		'noWifiCheckIn': 'No available Wi-Fi check-in locations.',
		'fahrenheit': 'If the temperature is in Fahrenheit, only values between 95 and 113 are accepted.',
		'celsius': 'If the temperature is in Celsius, only values between 35 and 45 are accepted.',
		'gpsTitle': 'GPS clock-in.',
		'wifiTitle': 'Wi-Fi clock-in.',
		'checkInWifi': 'The check-in Wi-Fi does not match the authorized Wi-Fi.',
	},
	'app.service.ac.appReg': {
		'notAppRegRule': 'The user is not subject to the mobile phone binding rules.',
		'remind': 'Remind.',
		'deviceBindingRequired': 'After binding your device, normal usage is permitted.',
		'oneDevicePerAccountBinding': '(One device can only be linked to one account.)',
		'deviceAlreadyBoundUseAnother': 'This device has been linked to another account. Please use another device to bind.',
		'accountAlreadyBoundToAnother': 'This account has been bound to another device.',
		'oneAccountOneDeviceBinding': '(One account can only be linked to one device.)',
		'accountNotBoundToDevice': 'This account has not yet bound a device.',
		'unbindSuccess': 'Release the device binding successfully.',
		'notified': 'Notified',
		'unbindNotificationSentPleaseWait': 'The main person in charge has been notified of the unbinding. Please wait for the relevant personnel to handle it.',
		'send': 'Send',
		'verificationEmailSentUnbindUponSuccess': 'A verification letter has been sent to your mailbox. Once successfully verified, the binding will be automatically released.',
		'messageNotificationEstablished': 'Failed to send email, message notification has not been enabled.',
		'failedToSendVerificationLetter': 'Failed to send verification letter.',
		'linkExpired': 'This link has expired. Please request a new one.',
		'invalidLink': 'Invalid link. Please request a new one.',
		'identitySuccessful': 'Identity verification successful. Device binding has been automatically released.',
	},
	'hp.m5.preview.wf020': {
		'thereAreTempTypesOfOvertime': '<%=temp1%> overtime type<%=temp2%> in total.',
	},
	'hp.m5.preview.wf011': {
		'aTotalOfOfPeopleOn': '<%=temp1%> employee<%=temp2%> took leaves in total.',
	},
	'components.Grids': {
		'inquire': 'Search',
	},
	'workflow.common.formTable': {
		'formNo': 'Form no.',
		'applicationTime': 'Request time',
	},
	'workflow.common.notification': {
		'portalUrl': 'Portal Website',
		'approveUrl': 'Approve',
		'rejectUrl': 'Reject',
		'agentSettingUrl': 'Agent Setting',
	},
	'h2.pb.pb40910': {
		'payrollPwdDefault1': '"<%=A%><%=B%>"',
		'payrollPwdDefault2': ', with <%=D%> put <%=C%>',
	},
	'hp.m5.m510010.wf100': {
		'pleaseSelectBizTime': 'Total business trip hours',
		'falseAttendanceCalculationError': 'Business trip calculation error',
		'itineraryDetails': 'Business Trip Details',
		'rowHeader': 'Trip',
		'theBusinessTripApplicationFailed': 'Adding Business trip failed',
		'failedToWriteToTheFake': 'Master business trip file writing failed.',
		'bizTripType': 'Business trip type',
		'bizDate': 'Business trip time',
		'totalBizTripHours': 'Total business trip hours',
		'bizLocation': 'Business trip location',
		'transportation': 'Transportation',
		'appointment': 'Appointment',
		'bizReason': 'Business trip reason',
		'servedAsAgentForOtherColleagues': 'Has been a substitute for another employee during the business trip time, in part or in whole.',
		'totalCountCannotBe': 'Total hours should not be 0.',
		'fakeProjectLoadingError': 'Business trip item loading error.',
		'substituteRequired': 'Substitute during leave is required.',
		'segmentedBizTime': 'Segmented business trip time',
		'totalBizTime': 'Total hours for each business trip segment',
	},
	'sp.wf100.am.emp.biz.check': {
		'code11': 'There is no such employee in the company.',
		'code12': 'The company has no such overtime type.',
		'code13': 'Unemployed during the leave range.',
		'code14': 'This leave item does not apply to the employee.',
		'code15': 'Leave parameters cannot be read.',
		'code16': 'Leave range earlier than the system’s earliest leave date.',
		'code17': 'Leave range later than the system’s latest leave date.',
		'code18': 'Leave range misses the leave request deadline.',
		'code19': 'There are remaining prior leave hours.',
		'code20': 'Business trip should not conflict with the same item.',
		'code21': 'Later leave request submission is not allowed.',
		'code22': 'Leave request submission should be completed within <%=A%> day(s) after the leave is taken.',
		'code23': 'Substitute during leave is required.',
		'code24': 'Leave reason is required.',
		'code25': 'Attachment is required.',
		'code26': 'Remaining hours are less than the minimum hours.',
		'code27': 'Submission is not allowed until days have elapsed since the start of the probation period.',
		'code28': 'Submission is allowed only in the birth month.',
		'code29': 'Submission is allowed only on the birth date.',
		'code30': 'Leave hours are less than the minimum leave hours.',
		'code31': 'Leave hours are more than the maximum leave hours.',
		'code32': 'Exceed the limit, plus other leave hours.',
		'code33': 'Exceed the limit, plus the number of other leaves.',
		'code34': 'has insufficient remaining hours.',
		'code35': 'Total hours should not be 0.',
		'code36': 'Leave has been resumed.',
		'code37': 'Leave has been settled.',
		'code38': 'Substitute does not exist or is unemployed.',
		'code39': 'Exceed the available leave range.',
		'code40': 'No available hours to <%=A%>.',
		'code42': 'Master staff leave file does not exist.',
		'code43': 'Event date is not set.',
		'code44': 'Leave range and overtime range conflict.',
		'code45': 'Annual leave data has been settled.',
		'code46': 'Compensatory time data has been settled.',
		'code47': 'Flexible leave data has been settled.',
		'code48': 'Employees working multiple shifts in one day should not take leave “for the first half or second half of the day”.',
		'code49': 'Non-shift employees are not allowed to take leave.',
		'code50': 'Substitute has taken leave.',
		'code51': 'Has been a substitute for another employee during the leave time, in part or in whole.',
		'code52': 'Serving as a substitute for multiple employees simultaneously is not allowed.',
		'code53': 'Serving as a substitute for another employee is not allowed for the calendar.',
		'code54': 'Taking leave is not allowed when serving as a substitute for another employee.',
		'code55': 'Event date data does not exist.',
		'code56': 'Event date and description are the same as those in other leave data.',
		'code57': 'There should be no archiving data after the leave deadline.',
		'code60': 'Business trip request is not allowed for non-shift employee.',
		'code61': 'Business trip should not conflict with the same item.',
		'code62': 'Request time is not allowed to exceed the total time.',
		'code63': 'No request time conflict is allowed.',
		'code70': 'Substitute is not on the list.',
	},
	'sp.wf050.am.emp.leave.cancel.check.byHour': {
		'code11': 'There is no such employee in the company.',
		'code12': 'No leave data in this company.',
		'code13': 'Leave resumption range exceeds the leave resumption request deadline.',
		'code23': 'Staff annual leave data has been settled (previous period).',
		'code24': 'Staff annual leave data has been settled (current period).',
		'code25': 'Staff compensatory time data has been settled.',
		'code26': 'Staff flexible leave data has been settled.',
		'code29': 'Leave data is in transit.',
		'code30': 'Leave has been settled.',
		'code33': 'There is already annual leave overtime data.',
	},
	'components.custom-form.single-text.view': {
		'maxWords': 'Up to <%=temp1%> words.',
		'pleaseEnterAnEMailAddress': 'Please enter email.',
	},
	'hp.m3.m310510': {
		'kindED': 'Personnel',
		'kindAM': 'Attendance',
		'kindPB': 'Salary',
		'timeUnit': 'Unit',
		'year': 'Year',
		'season': 'Season',
		'period': 'Interval',
		'all': 'All',
		'active': 'During usage',
		'deptLevel': 'Dept. level displays',
		'fullComp': 'Entire company',
		'proofAll': 'Compare to entire company',
		'yearTitle': '<%=y1%>~<%=y2%>',
		'xLegend1': '<%=y1%>Q<%=q1%>',
		'xLegend2': '<%=y1%>  Q<%=q1%>',
		'xLegend3': '<%=y1%>',
		'men': 'Male',
		'women': 'Female',
		'genderTitle': 'Gender statistics',
		'genderTip':
			'■ The data will be updated on a regular basis according to the daily update frequency set by HR.\n\t\t\t■ Employees who are "employed" or "leave without pay" are counted based on the last day of the date range according to the filtering criteria.\n\t\t\t■ Percentages are rounded to one decimal place.\n\t\t\t■ Example: In 2022, Department A has 6 males and 1 female, while Department B has 3 males and 7 females. On March 1, 2023, one male employee from Department A transferred to Department B.\n\t\t\tWhen filtering for Departments A and B in 2022, Department A comprises 86% males (6 individuals) and 14% females (1 individual), while Department B comprises 30% males (3 individuals) and 70% females (7 individuals).\n\t\t\tWhen filtering for Departments A and B in 2023, Department A comprises 83% males (5 individuals) and 17% females (1 individual), while Department B comprises 36% males (4 individuals) and 64% females (7 individuals).',
		'genderCnt': 'staffs',
		'ageTitle': 'Age statistics',
		'ageTip':
			'■ The data will be updated on a regular basis according to the daily update frequency set by HR.\n\t\t\t■ Employees who are "employed" or "leave without pay" are counted based on the last day of the date range according to the filtering criteria.\n\t\t\t■ Percentages are rounded to one decimal place.\n\t\t\t■ Example: In 2022, Department A has 4 employees aged 35, 41, 42, and 43. In 2023, the 35-year-old employee goes on leave, and the 42-year-old employee resigns.\n\t\t\tWhen filtering for Department A in 2022, the age range 31-40 constitutes 25% (1 person), and the age range 41-50 constitutes 75% (3 people).\n\t\t\tWhen filtering for Department A in 2023, the age range 31-40 constitutes 33% (1 person), and the age range 41-50 constitutes 67% (2 people).',
		'ageSlice': 'Analysis unit X',
		'baseAge20': 'Based on 20 years old.',
		'season1': 'Q1',
		'season2': 'Q2',
		'season3': 'Q3',
		'season4': 'Q4',
		'xLegend4': 'Under 20',
		'xLegend5': 'Over <%=XX%>',
		'quitTitle': 'Turnover statistics',
		'quitTip':
			'■ The data will be updated on a regular basis according to the daily update frequency set by HR.\n\t\t\t■ Resigned employees within the filtering criteria interval are calculated.\n\t\t\t■ If an employee leaves multiple times within the filtering interval, only the last departure is counted as one person.\n\t\t\t■ Turnover rate = Number of departures / ((Number of employees on the first day of the interval + Number of employees on the last day of the interval) / 2) *100%.\n\t\t\t■ Percentages are rounded to one decimal place.\n\t\t\t■ Example: Filtering criteria are on an annual basis, from 2022 to 2023.\n\t\t\tEmployee A departed once each in 2022 and 2023.\n\t\t\tEmployee B departed twice in 2023.\n\t\t\tOn January 1, 2022, there were 10 employees, and on December 31, 2022, there were 30 employees.\n\t\t\tOn January 1, 2023, there were 30 employees, and on December 31, 2023, there were 40 employees.\n\t\t\tIn 2022, one employee left, resulting in a turnover rate of 1/20 = 5%.\n\t\t\tIn 2023, two employees left, resulting in a turnover rate of 2/35 = 5.7%.',
		'quitLevel': 'Highlight turnover rate exceeding X in orange.',
		'cover': '(including)',
		'xLegend6': 'Voluntary resignations (excluding retirements)',
		'xLegend7': 'Voluntary resignations (including retirements)',
		'xLegend8': 'Involuntary separations',
		'stopTitle': 'Parental leave and return-to-work statistics',
		'stopTip':
			'■ The data will be updated on a regular basis according to the daily update frequency set by HR.\n\t\t\t■ Leave without pay and return-to-work employees within the filtering criteria interval are calculated.\n\t\t\t■ If an employee resumes multiple times within the filtering interval, only the last resumption is counted as one person.\n\t\t\t■ Reemployment rate = (Actual number of employees resumed / Expected number of employees to resume) * 100%\n\t\t\t■ Percentages are rounded to one decimal place.\n\t\t\t■ Example: Filtering criteria are on an annual basis, from 2022 to 2023.\n\t\t\tAn employee in Department A was supposed to return in 2022 but did not. An employee in Department B was supposed to return twice in 2023 and actually returned twice in 2023.\n\t\t\tTherefore, the reemployment rate for Department A is 0%, and for Department B is 100%.',
		'stopLevel': 'Highlight return-to-work rate below X in orange.',
		'stopBack': 'Return-to-work rate',
		'stopExpect': 'Expected number of return-to-work employees.',
		'stopActual': 'Actual number of return-to-work employees.',
		'hurtTitle': 'Work-related injury and sickness absence statistics',
		'hurtTip':
			'■ The data will be updated on a regular basis according to the daily update frequency set by HR.\n\t\t\t■ Employees who have been "on duty" for at least one day within the specified scope are counted.\n\t\t\t■ The total actual leave hours include all "active and inactive" leaves categorized as "work-related injury and sickness leave" according to Taiwanese regulations.\n\t\t\t■ Actual leave hours = Leave hours - Cancelled leave hours. Only "approved" leave records are considered.\n\t\t\t■ Percentage = (Actual leave hours / Total work hours) * 100%\n\t\t\t■ The percentage is rounded to one decimal place.\n\t\t\t■ Example: In a department with 2 employees, each requiring 20 days of work in March, with 8 hours per day. Employee A takes 4 hours of half-pay sick leave, approved, and Employee B takes 16 hours of work-related injury and sickness leave, pending approval. The percentage would be 4 / (8 * 20 * 2) = 1.3%',
		'hurtLevel': 'Highlight leave rate exceeding X in orange.',
		'hurtJoin': 'All (Combine gender)',
		'hurtApart': 'All (Separate by gender)',
		'percent': 'Percentage',
		'hour': 'hours',
		'hurtIssue': 'Actual leave hours',
		'hurtTotal': 'Total working hours',
		'breedTitle': 'Maternity leave/maternity examination leave/paternity leave statistics',
		'breedTip':
			'■ The data will be updated on a regular basis according to the daily update frequency set by HR.\n\t\t\t■ Employees who have been "on duty" for at least one day within the specified scope are counted.\n\t\t\t■ The total actual leave hours include all "active and inactive" leaves categorized as "maternity leave, maternity examination leave, and paternity leave" according to Taiwanese regulations.\n\t\t\t■ Actual leave hours = Leave hours - Cancelled leave hours. Only "approved" leave records are considered.\n\t\t\t■ Percentage = (Actual leave hours / Total work hours) * 100%\n\t\t\t■ The percentage is rounded to one decimal place.\n\t\t\t■ Example: In a department with 2 employees, each requiring 20 days of work in March, with 8 hours per day. Employee A takes 4 hours of paternity leave, approved, and Employee B takes 40 hours of maternity leave, pending approval. The percentage would be 4 / (8 * 20 * 2) = 1.3%',
		'breedLevel': 'Highlight leave rate exceeding X in orange.',
		'pay2Title': 'Salary structure statistics',
		'pay2Tip': `■ The data will be updated on a regular basis according to the daily update frequency set by HR.
			■ Employees who have been "on duty" for at least one day within the specified scope are counted.
			■ Salary items only for salary structure calculation.
			■ Amounts are rounded to the nearest integer.`,
	},
	'hp.m1.m110010': {
		'type': 'Type',
		'status': 'Status',
		'search': 'Search',
		'announcementTime': 'Publish time',
		'titleOrPublishingUnit': 'Title or publishing unit',
		'startDate': 'Start date',
		'endDate': 'End date',
		'no': 'No.',
		'category': 'Category',
		'title': 'Title',
		'readStatus': 'Read status',
		'publishingUnit': 'Publishing unit',
		'read': 'Read',
		'unread': 'Unread',
		'announcement': 'Announcement',
		'bulletinPublishingUnit': 'Publishing unit:',
		'bulletinCategory': 'Category:',
	},
	'hp.m1.m110020': {
		'addAnnouncement': 'Add Announcement',
		'titleOrLastUpdater': 'Title or last updater',
		'statistics': 'Statistics',
		'lastUpdate': 'Last update',
		'suspendPublication': 'Suspend publication',
		'content': 'Content',
		'category': 'Category',
		'categoryMaintenance': 'Category maintenance',
		'no': 'No.',
		'general': 'General',
		'displayOnTheList': 'Display on the list',
		'important': 'Important',
		'topOfTheHomepage': 'Displayed at the top of the homepage',
		'mandatory': 'Mandatory',
		'windowHomepage': 'Display as a pop-up window before entering the homepage.',
		'pleaseSelect': 'Please select',
		'enterTheTitle': 'Enter the title, up to 50 words.',
		'attachmentLabel': 'Attachment',
		'publishingSettings': 'Publishing settings',
		'announcementTime': 'Publish time',
		'startTime': 'Start time',
		'endTime': 'End time',
		'bottomButton': 'Bottom button',
		'noButtonRequired': 'No button required',
		'displayButton': 'Display button',
		'publishingTarget': 'Publishing target',
		'publishingMethod': 'Publishing method',
		'endOfAnnouncement': 'End of announcement, keep it in the message center',
		'keepIt': 'Keep it',
		'takeItDown': 'Take it down',
		'publishingUnit': 'Publishing unit',
		'optional': '(optional)',
		'noteUpToWords': 'Enter the note, up to 50 words.',
		'saveAsDraft': 'Save as draft',
		'publish': 'Publish',
		'noticeOfInspection': 'View',
		'suspendPublicationDlg': 'Suspend publication?',
		'suspendSuccessfully': 'Suspend publication successfully.',
		'suspendFailed': 'Suspend publication failed.',
		'afterSuspension': 'After suspension, all staff are unable to see the announcement.',
		'deletedSuccessfully': 'Deleted successfully.',
		'deletionFailed': 'Deletion failed.',
		'currentlyBeingPublished': 'The announcement is currently being published.',
		'afterDeletion': 'After deletion, all staff are unable to see the announcement.',
		'publicationSuccessful': 'Publication successful.',
		'publicationfailed': 'Publication failed',
		'addingAttachmentFailed': 'Adding attachment failed.',
		'addingContentFailed': 'Adding content failed.',
		'contentIsRequired': 'Content is required.',
		'contentToWords': 'Content should be less than 10,000 words.',
		'formatError': 'Format error. Only accept URLs in the format of http or https.',
		'preview': 'Preview',
		'saving': 'Saving',
		'publishing': 'Publishing',
		'displayedTop': 'Displayed at the top of the list',
		'weekTo1': 'Mon.',
		'weekTo2': 'Tue.',
		'weekTo3': 'Wed.',
		'weekTo4': 'Thur.',
		'weekTo5': 'Fri.',
		'weekTo6': 'Sat.',
		'weekTo7': 'Sun.',
		'displayPerDay': 'Display <%=N%> times daily.',
		'updateAnnouncement': 'Update and publish?',
		'updatedSuccessfully': 'Updated and published successfully.',
		'editingAttachmentFailed': 'Editing attachment failed.',
		'editingContentFailed': 'Editing content failed.',
		'editingRulesFailed': 'Editing rules failed.',
		'startDateChanged': 'The start date of publication cannot be changed.',
		'afterUpdatedAnnouncement': 'After publication, all staff see the updated announcement.',
		'confirmUpdate': 'Confirm',
		'editAnnouncement': 'Edit Announcement',
		'updatedAndPublished': 'Updated and published',
		'enterToWords': 'Enter custom ID, up to 10 words.',
		'displayEveryday': 'Display',
		'resetCalculation': 'Reset count daily at 00:00.',
		'times': 'times daily.',
		'addToFavorites': 'Add to the list of favorites',
		'textDisplayed': 'The text displayed on the button, up to 10 words.',
		'enterWebsite': 'Enter website or link',
		'downloadedSuccessfully': 'Downloaded successfully.',
		'downloadFailed': 'Download failed.',
		'emailSuccessfullySent': 'The reminder email has been successfully sent.',
		'emailFailedSend': 'The reminder email failed to send.',
		'title': 'Title:',
		'period': 'Period:',
		'type': 'Type:',
		'shouldRead': 'Should read:',
		'haveRead': 'Have read:',
		'unreadNum': 'Unread:',
		'readingRate': 'Reading rate',
		'lastSent': 'Last sent:',
		'sendReminderNotification': 'Send reminder notification',
		'download': 'Download',
		'unread': 'Unread',
		'read': 'Read',
		'numberOfRead': 'Number of times read',
		'latestReading': 'Latest reading',
		'announcement': 'Announcement',
		'weekToNum1': 'Mon.',
		'weekToNum2': 'Tue.',
		'weekToNum3': 'Wed.',
		'weekToNum4': 'Thur.',
		'weekToNum5': 'Fri.',
		'weekToNum6': 'Sat.',
		'weekToNum7': 'Sun.',
		'bulletinPublishingUnit': 'Publishing unit:',
		'bulletinCategory': 'Category:',
		'announcementReadingStatus': 'Announcement Reading Status',
		'updatingInProgress': 'Updating in progress',
		'updateAndPublish': 'Update and publish',
		'wantToDelete': 'Are you sure you want to delete?',
		'publishBtn': 'Publish',
	},
	'hp.m1.m110030': {
		'addCategory': 'Add Category',
		'editCategory': 'Edit Category',
		'zhTW': '繁體中文',
		'zhUS': 'English',
		'zhEN': '简体中文',
		'categoryName': 'Category name',
		'upTpword': 'Up tp 20 word.',
		'deledtedCompleted': 'Deledted completed.',
		'deletionFailed': 'Deletion failed.',
		'defaultAndCannotBeDeleted': 'This is a system default and cannot be deleted.',
		'wantToDelete': 'Are you sure you want to delete "<%=name%>"?',
		'systemDefault': 'System default',
		'additionCompleted': 'Addition completed.',
		'addingFailed': 'Adding failed.',
		'duplicateName ': 'Duplicate name for category.',
		'editionCompleted': 'Edition completed. <%=name%>',
		'editingFailed': 'Editing failed.',
		'confirmToDeactivate': 'Confirm to deactivate the category.',
		'categoryNotBeDeleted': 'The category has been published and will not be deleted.',
		'confirmToActivate': 'Confirm to enable this category',
	},
	'hp.m1.m110040': {
		'addListOfFavorites': 'Add List of Favorites',
		'closeSetting': 'Close setting',
		'name': 'Name',
		'selectTarget': 'Select target',
		'confirmDelete': 'Are you sure you want to delete "',
		'confirmDelete1': '"?',
		'deletedCompleted': 'Deledted (<%=name%>) completed.',
		'deleteFailed': 'Deletion failed: "(<%=name%>)" is in use.',
		'deleting': 'Deleting',
		'noExisting': 'There are currently no existing lists.',
		'additionCompleted': 'Addition completed.',
		'addingFailed': 'Adding failed.',
		'duplicateName': 'Duplicate name for the list.',
		'editListOfFavorites': 'Edit List of Favorites',
		'editionCompleted': 'Edition completed.',
		'editingFailed': 'Editing failed.',
	},
	'hp.m5.m510060': {
		'searchForAll': 'Applicant/Approver/Staff be changed/Form no.',
		'formStatus': 'Form status',
		'status': 'Status',
		'approver': 'Approver',
        'handlers': 'Handlers',
        'stakeholders': 'Stakeholders',
	},
	'components.custom-form.file-upload.prompt': {
		'format': 'Format',
		'detail': 'Details',
		'executableFilesSuchAsExeCannot': 'Executable files, such as .exe, cannot be uploaded.',
		'noLimit': 'Not limited.',
		'image': 'Image',
		'file': 'Document',
		'briefing': 'Presentation',
		'trialBalance': 'Spreadsheet',
	},
	'components.custom-form.number-format.view': {
		'enterANumber': 'Enter a number',
	},
	'components.custom-form.import-image.preview': {
		'preview': 'Preview',
	},
	'components.custom-form.date-range.date-range': {
		'startDate': 'Start date',
	},
	'components.custom-form.details': {
		'add': 'Add an entry',
	},
	'components.custom-form.remark': {
		'checkItems': 'Multiple choice: Please select <%=min%> to <%=max%> options.',
	},
	'hp.m4.m410081': {
		'month': 'Month',
		'shiftName': 'Class',
		'scheduledTime': 'Scheduled clock‑in/clock‑out time',
		'systemCardTime': 'System recorded clock‑in/clock‑out time',
		'actualTime': 'Actual attendance time',
		'attendStats': 'Attendance statistics',
		'shouldWorkDays': 'Expected working days',
		'actualWorkDays': 'Actual working days',
		'confirmBtn': 'Attendance record confirmation',
		'confirmStatus': 'Confirmation status',
		'unconfirmed': 'Unconfirmed',
		'confirmed': 'Submitted. Submission date:',
		'submittedBy': 'Submitted by:',
		'actualCardTime': 'Actual attendance time',
		'lastSubmitTime': 'Last submitted time',
		'noCardNeeded': 'No card required',
		'overAttend': 'Overtime attendance',
		'normal': 'Normal',
		'genTestMonthlyData': 'Generate monthly clock-in data randomly',
		'err001': 'Please enter time in MM/DD HH:MM format.',
		'err002': 'The attendance records for X exceed the allowed working hours. Please adjust them according to regulations and resubmit.',
	},
	'hp.m4.m410080': {
		'searchRange': 'Search range',
		'requestStatus': 'Request status',
		'deductedHours': 'Deducted hours',
		'vestingDate': 'Vesting date:',
		'attendanceHoursDet': 'Attendance Hours Details',
		'attVestingDate': 'Vesting date',
		'calendar': 'Calendar',
		'inTransit': 'In transit',
	},
	'hp.m3.m310310': {
		'shiftLabel': 'Shift label',
		'label': 'Label',
		'shiftKeyword': 'Keyword',
		'useStatus': 'Status',
		'source': 'Source',
		'addLabel': 'Add label',
		'import': 'Import',
		'serial': 'No.',
		'labelCode': 'Label code',
		'labelName': 'Label name',
		'note': 'Note',
		'lastUpdate': 'Last update',
		'addShiftLabel': 'Add Shift Label',
		'copyLabel': 'Copy label',
		'pleaseSelectLabel': 'Label',
		'shiftLabelCode': 'Label code',
		'pleaseEnterLabelCode': 'Label code',
		'shiftLabelName': 'Label name',
		'pleaseEnterLabelName': 'Label name',
		'fillColor': 'Background color',
		'wordColor': 'Word color',
		'preview': 'Preview',
		'pleaseEnterText': 'Please enter text.',
		'editShiftLabel': 'Edit Shift Label',
		'shiftLabelDetail': 'Shift Label Details',
		'latestUpdate': 'Latest update',
		'confirmDelete': 'Are you sure you want to delete "<%=name%>"?',
		'shiftLabelImport': 'Import shift label',
		'importShiftLabel': 'Import shift label',
		'status': 'Status',
		'rules': 'Rules',
		'format': 'Format',
		'example': 'Example',
		'required': 'Required',
		'labelCodeConflict': 'No label code conflict is allowed. Up to 10 words.',
		'useOrDeactivated': 'In use or deactivated',
		'upTo20Words': 'Up to 20 words.',
		'addShiftLabelCompleted': 'Adding of the shift label completed.',
		'addShiftLabelFailed': 'Shift label adding failed.',
		'labelNameNotRepeated': 'No label name conflict is allowed.',
		'labelCodeNotRepeated': 'No label code conflict is allowed.',
		'shiftLabelCodeNotContainComma': 'Label code should not contain "，".',
		'shiftLabellNameNotContainComma': 'Label name should not contain "，".',
		'labelCodeNotContainComma': 'Label code should not contain "，".',
		'labelNameNotContainComma': 'Label name should not contain "，".',
		'importFormat': 'Import file format.',
		'downloadImportSample': 'Download import sample',
		'fieldRequired': 'Required',
		'importFileFormatRequired': 'Import file format is required.',
		'fileNameNotContainSpecialChar': 'File name should not contain special characters, such as \\ / : * ? " < > | # % &.',
		'shiftLabelReadError': 'Shift label data reading error.',
		'shiftLabelNotExist': 'Shift label data does not exist.',
		'editShiftLabelCompleted': 'Editing of the shift label completed.',
		'editShiftLabelFailed': 'Shift label editing failed.',
		'deleteShiftLabelCompleted': 'Deleting of the shift label completed.',
		'deleteShiftLabelFailed': 'Shift label deleting failed.',
		'addShiftLabelImportFormat': 'Adding shift label import format.xlsx',
		'editShiftLabelImportFormat': 'Editing shift label import format.xlsx',
		'backstage': 'HR Max',
		'usageStatusNotExist': 'Usage status does not exist.',
		'systemId': 'System ID',
		'errorMsg': 'Error message',
		'duplicateCode': 'Duplicate code.',
		'duplicateTraditionalChineseName': 'Duplicate Traditional Chinese name.',
		'duplicateEnglishName': 'Duplicate English name.',
		'duplicateSimplifiedChineseName': 'Duplicate Simplified Chinese name.',
		'systemIdNotExist': 'System ID does not exist.',
		'duplicateDataExist': 'Duplicate data exists.',
		'shiftGroup': 'Shift group',
		'group': 'Group',
		'groupKeyword': 'Keyword',
		'commonShift': 'Common shift',
		'commonLabel': 'Common label',
		'addGroup': 'Add group',
		'deleteShiftGroupMsg': 'Are you sure you want to delete <%=count%>?',
		'groupName': 'Group name',
		'shiftManager': 'Shift schedule manager',
		'addShiftGroup': 'Add Shift Group',
		'copyGroup': 'Copy group',
		'selectGroup': 'Group',
		'pleaseEnterGroupName': 'Group name',
		'shiftLeaderAuthorityDescription': 'The shift schedule manager can be seen as a minor supervisor, with the authority to schedule shifts, publish schedules, and submit requests for shift changes and support.',
		'shiftScheduleApprover': 'Shift schedule approver',
		'classListApproverAuthorityDescription': 'The shift schedule approver can be seen as a major supervisor, with the authority to review and approve the publication of schedules, sign off on requests for shift changes, and support.',
		'shiftScheduleCoordinator': 'Shift schedule coordinator',
		'scheduleOrganizerPermissionsDescription': 'The shift schedule coordinator can be seen as part of the HR department, with the authority to review and approve the publication of schedules, sign off on requests for shift changes, and support.',
		'applicableRecipients': 'Applicable recipients',
		'scheduleValidationExplanation': 'When scheduling, the system will automatically check applicable recipients within the group to ensure that within the actual schedule cycle, there is at least one day where the shift attribute corresponds to the scheduled personnel. If an employee is not designated as scheduled personnel within the cycle, then their schedule cannot be arranged.',
		'shiftScheduleCycle': 'Shift schedule cycle',
		'to': 'to',
		'shiftsPerDay': 'Number of shifts available per day',
		'shift1': 'One shift',
		'shift2': 'Two shifts',
		'shift3': 'Three shifts',
		'shift4': 'Four shifts',
		'editShiftGroup': 'Edit Shift Group',
		'shiftGroupDetails': 'Shift Group Details',
		'maxShiftsPerDayPerPerson': 'The shift schedule allows for <%=alias%> shifts (each person can be scheduled for up to <%=shiftMax%> shifts per day).',
		'shiftGroupImport': 'Import shift group',
		'importShiftGroup': 'Import shift group',
		'companyName': 'Company name',
		'staffId': 'Staff ID',
		'workHourRegulationCycle': '"Fixed cycle" or "Cycle based on working hour regulations"',
		'startMonth': 'Starting month',
		'fixedCycleRequired': "If the shift schedule cycle is set to 'Fixed Cycle', then this field is required.",
		'monthPosition': 'Previous month, current month, or next Month',
		'startDate': 'Start date',
		'monthDate': '1st...30th, 31st',
		'endMonth': 'Ending month',
		'endDate': 'Ending date',
		'monthDateEnd': '1st...30th, 31st, end of month',
		'typeWorkRules': 'Type of working hour rules',
		'workingHourRegulationCycleRequired': "If the shift schedule cycle is set to 'Cycle based on Working Hour Regulations', then this field is required.",
		'workingHourRegulationOptions': 'Standard working hours, bi-weekly rotation, four-week rotation, or eight-week rotation',
		'workingHourCycleStartDate': 'Start date of working hour calculation cycle',
		'dateFormatDescription': "\"Enter the date in the format: YYYY/MM/DD. For AD - acceptable separator symbols: '/' or '-'. For ROC (Taiwanese calendar) - acceptable separator symbols: '/', '-', or '年'\"\".\"",
		'multipleCommonShiftsDescription': 'If there are multiple common shifts, you can input multiple shift codes or shift abbreviations, separated by commas",".',
		'shift': 'Shift',
		'shiftCode': 'Shift code',
		'shiftAbbreviation': 'Shift abbreviation',
		'viewWorkingHourCalculationCycle': 'View Working Hour Calculation Cycle',
		'previousCycle': 'Previous cycle',
		'nextCycle': 'Next cycle',
		'viewCycle': 'View cycle',
		'groupNameConflictNotAllowed': 'No group name conflict is allowed.',
		'shiftGroupDataNotExist': 'Shift group data does not exist.',
		'setAtLeastOneFilterCriteria': 'Set at least one filter criteria',
		'startDateShouldBeEarlierThanEndDate': 'Start time must be earlier than the end time.',
		'viewSchedulesLimitedTo8Weeks': 'You can only view schedules for up to 8 weeks.',
		'addShiftGroupFailed': 'Shift group adding failed.',
		'addShiftGroupCompleted': 'Adding of the shift group completed.',
		'shiftGroupReadError': 'Shift group data reading error.',
		'editShiftGroupFailed': 'Editing of the shift group completed.',
		'editShiftGroupCompleted': 'Shift group editing failed.',
		'one': '1',
		'two': '2',
		'three': '3',
		'four': '4',
		'accordingToWorkHourRulesCycle': 'According to the <%=otWorkhourType%> rules cycle.',
		'theStartDateOfWorkingHourCalculationCycleIs': 'The start date of the working hour calculation cycle is <%=date%>.',
		'deleteShiftGroupCompleted': 'Deleting of the shift group completed.',
		'deleteShiftGroupFailed': 'Shift group deleting failed.',
		'editShiftGroupImportFormat': 'Editing shift group import format.xlxs',
		'otherErrorMsg': 'Other error messages.',
		'staffIdNotExist': 'Staff ID does not exist.',
		'shiftScheduleCycleNotExist': 'Shift schedule cycle does not exist.',
		'startMonthNotExist': 'Start month does not exist.',
		'startDateNotExist': 'Start date does not exist.',
		'endMonthNotExist': 'End month does not exist.',
		'endDateNotExist': 'End date does not exist.',
		'typeWorkRulesNotExist': 'Type of working hour rules does not exist.',
		'commonShiftNotExist': 'Common shift does not exist.',
		'commonLabelNotExist': 'Common label does not exist.',
		'companyNotExist': 'Company does not exist.',
		'duplicateSystemId': 'Duplicate system ID.',
		'importFileSameGroupName': 'There are groups with the same name in the import file.',
		'unauthorizedOperation': 'Unauthorized operation.',
		'employeeNotActiveEmployment': 'Employee is not in active employment.',
		'availableWorkHours': 'Available work hours',
		'start': 'Start',
		'end': 'End',
		'totalManpower': 'Total manpower',
		'employeeMgmt': 'Employee Mgmt.',
		'importEmployeeManagement': 'Import Employee Mgmt.',
		'empNo': 'Employee ID',
		'empName': 'Employee Name',
		'labelIsNotExist': 'Label does not exist.',
		'invalidTimeFormat': 'Invalid time format.',
		'startTimeShouldBeEarlierThanEndTime': 'Start time must be earlier than the end time.',
		'required': 'Required field.',
		'mondayStart': 'Monday Start',
		'mondayEnd': 'Monday End',
		'tuesdayStart': 'Tuesday Start',
		'tuesdayEnd': 'Tuesday End',
		'wednesdayStart': 'Wednesday Start',
		'wednesdayEnd': 'Wednesday End',
		'thursdayStart': 'Thursday Start',
		'thursdayEnd': 'Thursday End',
		'fridayStart': 'Friday Start',
		'fridayEnd': 'Friday End',
		'saturdayStart': 'Saturday Start',
		'saturdayEnd': 'Saturday End',
		'sundayStart': 'Sunday Start',
		'sundayEnd': 'Sunday End',
		'nationalHolidayStart': 'National Holiday Start',
		'nationalHolidayEnd': 'National Holiday End',

		'incorrectDataImport': 'Incorrect data import',
	},
	'hp.m3.m310080': {
		'exportCompleted': 'Export completed.',
		'exportFailed': 'Export failed.',
		'downloadDetailed': 'Download detailed report',
		'staffIdName': 'Staff ID/Name',
		'totalAttHours': 'Total attendance hours',
		'companyDept': 'Company/Dept.',
		'attendancePeriod': 'Attendance period:',
		'totalAttendanceHours': 'Total attendance hours are <%=h%> hours and <%=m%> mins.',
		'min': 'min',
		'detailedAttendanceReportTitle': 'Detailed Attendance Report of Subordinates',
		'detailedAttendanceReport': 'Detailed Attendance Report',
		'company': 'Company',
		'chineseName': 'Chinese name',
		'englishName': 'English name',
		'startDate': 'Start date',
		'endDate': 'End date',
		'number': 'Number',
		'unit': 'Unit',
		'deductingHours': 'The interval for deducting hours',
		'searchRange': 'Search range:',
	},
	'hp.m4.m410060': {
		'leaveType': 'Leave type',
		'leaveTime': 'Leave time',
		'leaveHours': 'Leave hours',
		'leaveResumptionHours': 'Leave resumption hours',
		'actualHours': 'Actual hours',
		'substitute': 'Substitute',
		'leaveStartAndEendTime': 'Leave start/end time',
		'eventDateDescription': 'Event date description',
		'officialLeave ': 'Official leave ',
		'annualLeave': 'Annual leave',
		'compensatoryTime': 'Compensatory time',
		'flexibleLeave': 'Flexible leave',
		'generalLeave': 'General leave',
		'leaveResumptionLoadingError': 'Leave resumption details loading error.',
		'leaveResumptionDetails': 'Leave resumption details',
		'available': 'Available',
	},
	'hp.m4.m410050': {
		'overtimeStartAndEndTime': 'Overtime start/end time',
		'overtimeHours': 'Overtime hours',
		'deductedHours': 'Deducted hours',
		'redeemedForOvertimePay': 'Redeemed for overtime pay',
		'redeemedForCompensatoryTime': 'Redeemed for compensatory time',
		'detailedOvertimeInformation': 'Detailed Overtime Information',
		'available': 'Available',
		'availableNoExpiration': 'Available: No expiration',
		'aboutToExpire': 'About to expire',
		'expiryDate': 'Expiry date',
		'noDetailedOvertime': 'No detailed overtime information available.',
		'noExpiration': 'No expiration',
	},
	'hp.m4.m410070': {
		'year': 'Year',
		'rule': 'Rule',
		'noLimit': 'No limit',
		'or': 'or',
		'time': 'time',
		'every': 'Every',
		'used': 'Used',
		'remaining': 'Remaining',
		'approving': 'Approving',
		'canApply': 'Available',
		'businessTrip': 'Business trip',
		'annualLeaveEntitlement': 'Annual leave entitlement',
		'officialLeave': 'Official leave',
		'officialLeaveStatistics': 'Official Leave Statistics',
		'annualLeaveStatistics': 'Annual Leave Statistics',
		'startDateForLeave': 'Start date for leave',
		'endDateOfAllowableLeave': 'End day for leave',
		'type': 'Type',
		'available': 'Available',
		'useding': 'Used',
		'total': 'Total',
		'wantToTakeALeave': 'Leave',
		'compensatoryTimeStatistics': 'Compensatory Time Statistics',
		'restLimit': 'Available',
		'source': 'Source',
		'flexibleLeaveStatistics': 'Flexible Leave Statistics',
		'aAndBYear': '<%=A%> <%=B%>',
		'flexName': 'Name',
		'leaveDate': 'Receiving date',
		'allowAdvanceUse': 'Allow advance use',
		'deduction': 'Deduction',
		'generalLeaveStatistics': 'General Leave Statistics',
		'goOnABusinessTrip': 'Biz trip',
		'tripStartDate': 'Start date',
		'tripEndDate': 'End date',
		'businessTripDuration': 'Business trip duration',
		'leaveSart': 'Start date',
		'leaveEnd': 'End date',
		'perYear': '<%=A%> <%=B%> /per year',
		'everyYear': 'Every <%=A%> year<%=B%>',
		'everyMonth': 'Every <%=A%> month<%=B%>',
		'everyDay': 'Every <%=A%> day<%=B%>',
		'everyTime': 'Every time',
		'birthMonth': 'Birth month',
		'birthDay': 'Birth day',
		'leavehours': 'Leave hours',
		'endDate': 'End date',
	},
	'hp.m3.m310040': {
		'abnormal': 'Abnormal',
		'leaveType': 'The count of each abnormal condition is based on the results of comparing the employee\'s attendance records.',
		'oddLate': 'Anomalous-Not specified',
		'oddLeaveEarly': 'Late',
		'oddAbsenteeism': 'Leave early',
		'oddFailureToClockIn': 'Absenteeism',
		'oddExcessAttendanceHours': 'Failure to clock in',
		'oddOvertimeClockInTime': 'Excess attendance hours',
		'oddOvertimeSwiping': 'Insufficient overtime clock-in time',
		'overtimeClockInTime': 'Insufficient overtime clock-in time',
		'oddClockInOutData': 'Insufficient clock-in/out data',
		'explanation': 'Explanation: Count of various types of leave comes from the total actual data recorded by the system,',
		'explanationAll': 'including approved and pending approval statuses. The total value is an approximate value due to algorithm limitations. For details, please click to view all.',
		'late': 'Late',
		'leaveEarly': 'Leave early',
		'absenteeism': 'Absenteeism',
		'failureToClockIn': 'Failure to clock in',
		'excessAttendanceHours': 'Excess attendance hours',
		'clockInOutData': 'Insufficient clock-in/out data',
		'anomalousDetails': 'Anomalous Details of Clock-in/out',
		'searchRange': 'Search range:',
		'total': 'Total',
		'anomalousData': 'anomalous data.',
		'haveBeenProcessed': 'Have been processed',
		'waitForProcessing': 'Wait for processing',
	},
	'hp.m3.m310050': {
		'downloadMultiplierStatistical': 'Download multiplier statistical report',
		'totalHourMin': '<%=h%> hour<%=hs%> <%=m%> min<%=ms%>',
		'overtimeDetails': 'Overtime Details',
		'searchRange': 'Search range:',
		'overtimeHourMin': 'Total overtime hours are <%=h%> hour<%=hs%> and <%=m%> min<%=ms%>.',
		'vestingDate': 'Vesting date:',
		'available': 'Available:',
		'noExpiration': 'No expiration',
		'aboutToExpire': 'About to expire',
		'subordinateOvertimeRateStatistics': 'Subordinate Overtime Rate Statistics',
		'subordinateOvertimeRateCalendar': 'Subordinate Overtime Rate Statistics - Calendar-based',
		'subordinateOvertimeDetails': 'Subordinate Overtime Details',
		'startDate': 'Start date',
		'endDate': 'End date',
		'overtimeVestingDate': 'Vesting date',
		'overtime': 'Overtime',
		'deduction': 'Deduction',
		'compensatoryLeaveStart': 'Compensatory leave start date',
		'compensatoryLeaveEnd': 'Compensatory leave end date',
		'times1334': '1.334 times',
		'workingDay': 'Working day',
		'times': ' times',
		'statisticsTitle': 'Subordinate Overtime Rate',
		'rateCalendarTitle': 'Subordinate Overtime Rate(2)',
	},
	'hp.m3.m310060': {
		'statisticsloadingError': 'Annual leave attendance statistics loading error.',
		'listMode': 'List mode',
		'sumMode': 'Sum mode',
		'leaveRecords': 'Leave Records',
		'annualUnit': 'Annual leave <%=n%> hours.',
		'compensatoryUnit': 'Compensatory time <%=n%> hour<%=s%>.',
		'flexibleUnit': 'Flexible leave <%=n%> hour<%=s%>.',
		'officialUnit': 'Official leave <%=n%> hour<%=s%>.',
		'generalUnit': 'General leave <%=n%> hour<%=s%>.',
		'subordinateLeaveDetails': 'Subordinate Leave Details',
		'leaveStartDate': 'Start date',
		'leaveEndDate': 'End date',
		'leave': 'Leave',
		'leaveResumption': 'Leave resumption',
		'actual': 'Actual',
		'attachment': 'Attachment',
		'leaveTime': 'Leave time',
		'approx': 'Approx. <%=n%> hour<%=s%>',
	},
	'hp.m3.m310070': {
		'keyword': 'Keyword',
		'leaveDataSearch': 'Subordinate attendance/leave data search',
		'noData ': 'No data meets the search criteria. ',
		'leaveSummary': 'Subordinate Leave Summary',
		'downloadYear': 'Year:',
		'used': 'Used',
		'remaining': 'Remaining',
	},
	'hp.m3.m310110': {
		'subordinateProfileSearch': 'Subordinate Profile Search',
		'salaryData': 'Salary Data',
		'downloadingFailed': 'Downloading personal info. failed.',
		'jobAndYearOfService': 'Job and year of service',
		'eduAndWorking': 'Education and working experiences',
		'skillsAndExpertise': 'Skills and expertise',
		'payrollLoadingError': 'Payroll loading error.',
		'noSalaryRule': 'No salary rule have taken effect.',
		'fromSalaryCalculation': 'Display Items excluded from salary calculation.',
		'effectiveDate': 'Effective date: ',
		'salaryMethod': 'Salary calculation method: ',
		'salaryApproval': 'Reason for salary approval: ',
		'changeHistory': 'Change History',
		'salaryAccount': 'Salary account',
		'partOfTheSalary': 'Counted as part of the salary',
		'numberOfChanges': 'Number of changes: ',
		'loginFailed': 'Login failed.',
		'noData': 'No data.',
		'listening': 'Listening',
		'speaking': 'Speaking',
		'reading': 'Reading',
		'writing': 'Writing',
		'level': 'Level',
	},
	'hp.m4.m410110': {
		'familyMembersError': 'List of family members loading error.',
		'changeDetails': 'Change details',
		'listOfFamilyMembers': 'dependent list',
		'changeDetailsOfFamilyMembers': 'Change Details of Family Members',
		'rejectionOpinion': 'Rejection opinion:',
		'relationship': 'Relationship',
		'birthday': 'Birthday',
		'nationality': 'Nationality',
		'dependents': 'Dependents',
		'idNumber': 'ID number',
		'alienResidentNumber': 'Alien Resident Certificate (ARC) number',
		'degreeOfDisability': 'Degree of disability',
		'survivalStatus': 'Survival status',
		'requestTimeStart': 'Start',
		'requestTimeEnd': 'End',
		'auditStatus': 'Audit status',
		'changeitems': 'Change items',
		'approver': 'Approver',
		'auditTime': 'Audit time',
		'result': 'Result',
		'originalContent': 'Original content',
		'contentAfterModification': 'Content after modification',
		'blueTextRepresents': 'The blue text represents the requested modification items.',
		'deleted': '(Deleted)',
		'releativesData': 'Releatives data does not exist.',
		'attachmentsError': 'Attachments cannot be stored.',
		'dependentsT': 'Dependents:',
		'reviewNotification': "You have submitted the request on <%=t%>. Please wait for the administrator's review notification.",
		'wantToDelete': 'Are you sure you want to delete "',
		'wantToDelete1': '"?',
		'exJessicaLo': 'ex: Jessica Lo',
		'error': 'Error',
		'category': 'Category',
		'changeIems': 'Change items',
		'resultTd': 'Result',
		'note': 'Note',
		'approved': 'Approved',
		'rejected': 'Rejected',
		'releativesError': '<%=name%> already has insurance-related information, and it cannot be deleted ',
		'updateError': 'Failed to update <%=s%>',
	},
	'hp.m4.m410100': {
		'profileLoadingError': 'Profile loading error.',
		'changeDetails': 'Change Details',
		'personalSummary': 'Personal summary',
		'contactInfo': 'Contact info.',
		'education': 'Education',
		'workingExperiences': 'Working experiences',
		'skillsAndExpertise': 'Skills and expertise',
		'certifications': 'Certifications',
		'disabilityCategory': 'Disability category',
		'passportName': 'Passport name',
		'passportnumber': 'Passport number',
		'exitDates': 'Entry and exit dates',
		'expirationDateOfResidencePermit': 'Expiration date of residence permit',
		'intermediaryUnit': 'Intermediary unit',
		'contactPhoneNumber': 'Contact phone number',
		'primaryEmergencyContact': 'Primary emergency contact',
		'noData': '(no data)',
		'secondaryEmergencyContact': 'Secondary emergency contact',
		'languageProficiency': 'Language proficiency',
		'dialectProficiency': 'Dialect proficiency',
		'level': 'Level',
		'competency': 'Competency',
		'schoolNameChinese': 'School name (Chinese)',
		'departmentNameChinese': 'Department name (Chinese)',
		'dateOfEnrollment': 'Enrollment',
		'dateOfDepartureFromschool': 'Departure from school',
		'departmentProgramCategory': 'Department/Program category',
		'companyName': 'Company name',
		'dateOfEmployment': 'Employment',
		'dateOfResignation': 'Resignation',
		'positionCategory': 'Position category',
		'managerialPosition': 'Did you hold a managerial position?',
		'certificateName': 'Certificate name',
		'type': 'Type',
		'certificateNumber': 'Certificate number',
		'issuingAuthority': 'Issuing authority',
		'approvalNumber': 'Approval document number',
		'trainingHours': 'Training hours',
		'acquisitionDate': 'Acquisition date',
		'cancellationDate': 'Cancellation date',
		'changeDetailsOfProfile': 'Change Details of Profile',
		'changeCategory': 'Change category',
		'category': 'Category',
		'disabilityCategoryIsDuplicated': 'Disability category is duplicated.',
		'exitDateRangeExists': 'Duplicate entry and exit date range exists.',
		'theSavedData': 'The entry and exit date range must be greater than the saved data.',
		'dateIsDuplicated': 'Residence permit expiration date is duplicated.',
		'exJessicaLoEN': 'ex: Jessica Lo',
		'age': 'Age',
		'year': '<%=n%>',
		'asShownOnPassport': 'Passport name (as shown on passport)',
		'passportNumber': 'Passport number',
		'idNoARC': 'Alien Resident Certificate (ARC) number',
		'doesNotExist': 'Contact info. does not exist.',
		'areYouSave': 'If you change the company email, the Portal account will need to be reauthenticated before use. Are you sure you want to save?',
		'countyCityArea': 'County/city area',
		'permanentAddress': 'Permanent address',
		'registeredInformation': 'Same as registered information',
		'mailingAddress': 'Mailing address',
		'exTel': 'ex: 02 22881256',
		'exCel': 'ex: 0912 345 678',
		'exEmail': 'ex: youremail@company.com',
		'exEmail2': 'ex: youremail@urself.com',
		'exSelect': 'Select',
		'listeningTemplate': 'Listening<%=n%>',
		'speakingTemplate': 'Speaking<%=n%>',
		'readingTemplate': 'Reading<%=n%>',
		'writingTemplate': 'Writing<%=n%>',
		'listening': 'Listening',
		'speaking': 'Speaking',
		'reading': 'Reading',
		'writing': 'Writing',
		'exCompetency': 'Please select competency (up to 50 items)',
		'eduDataDoesNotExist': 'Education data does not exist.',
		'reviewNotification': "You have submitted the request on <%=t%>. Please wait for the administrator's review notification.",
		'youWantToDelete': 'Are you sure you want to delete "<%=d%>"?',
		'exCollege': 'ex: 104 college',
		'exDepartments': 'ex: Dept. of industrial engineering',
		'graduation': 'Graduation',
		'periodOfStudy': 'Period of study',
		'expDoesNotExist': 'Experience data does not exist.',
		'companyNameP': 'Company name',
		'termOfEmployment': 'Term of employment',
		'certificationAddingFailed': 'Certification adding failed.',
		'certificationDataDoesNotExist': 'Certification data does not exist.',
		'laterThanThe': 'Expiration date should be later than the effective date.',
		'laterThanTheAcquisitionDate': 'Cancellation date should be later than the acquisition date.',
		'expirationDateT': 'Expiration date:',
		'effectiveDateT': 'Effective date:',
		'exTOEIC': 'ex: TOEIC',
		'exNo': 'ex: 12345678',
		'pleaseFillIssuingAuthority': 'Issuing authority',
		'number': 'Number',
		'date': 'Date',
		'underReview': 'Data under review.',
		'loadingError': '<%=t%> loading error.',
		'updatedSuccessfully': '<%=s%> updated successfully.',
		'noMessageNotification': 'No message notification template available.',
		'noAssignedPersonnel': 'No handler.',
		'noFieldChanges': 'No field changes.',
		'noRelatedFormSettings': 'No related form settings.',
		'pleaseRefreshAndRryAgain': 'Contains prohibited operation fields. Please refresh and try again.',
		'overridden': 'This method needs to be overridden.',
		'notRequireReview': 'Editing the data that does not require review.',
		'editingRequiresToReview': 'Editing the data that requires to review.',
		'submit': 'Submit',
		'itWillTakeEffect': 'After filling in the following fields, submission for review is required. The administrator will review, and upon approval, it will take effect.',
		'afterApproval': "You have submitted the request on <%=t%>. Please wait for the administrator's review notification. After approval, editing of the following fields will be enabled.",
		'waitingForTheReviewProcess': "You have submitted the request on <%=t%>. Please wait for the administrator's review notification. You can continue editing other fields while waiting for the review process.",
		'wantToDeleteTheData': 'Are you sure you want to delete the data?',
		'hasBeenDeleted': 'Failed to update <%=d%>',
		'deletionFailed': 'Failed to delete <%=d%>',
		'notYetImplemented': 'Not yet implemented <%=n%>.',
		'deleteTheData': 'Are you sure you want to delete the data?',
		'administratorReviewAndNotification': "You have submitted the information on <%=t%>. Please wait for the administrator's review and notification.",
		'language': 'Language',
		'identity': 'Identity',
		'dialect': 'Dialect',
		'expirationDate': 'Expiration date',
	},
	'hp.m3.m310220': {
		'readingFailed': 'Reading failed.',
		'shiftGroup': 'Shift group',
		'searchRange': 'Search range',
		'items': 'Items',
		'subtotal': 'Subtotal',
		'downloadFail': 'Downloading the manpower statistics by shift failed.',
		'notSchedule': 'Not scheduled',
		'leave': 'Leave',
		'allDayLeave': 'All-day leave',
		'overtime': 'Overtime',
		'rotatingShiftsByShiftEmployees': 'Rotating shifts (by shift) employees',
		'rotatingShiftsByPeriodEmployees': 'Rotating shifts (by period) employees',
		'allRotatingShiftsEmployees': 'All rotating shifts employees',
		'workTime': 'Work time: ',
		'restTime': 'Rest time: ',
		'exportDate': 'Export date: ',
		'startendtime': 'Start/end time: ',
		'shiftTime': 'Shift date: ',
		'dept': 'Dept: ',
		'date': 'Date',
		'manpowerStatisticsByClass': 'Manpower Statistics by Shift',
		'manpowerStatisticsByShift': 'Manpower statistics by shift',
		'shift': 'Shift',
		'workTimeTitle': 'Work time',
		'restTimeTitle': 'Rest time',
		'allowableOvertimeHours': 'Available overtime hours',
		'prohibitionOfOvertimeHours': 'Overtime is prohibited',
		'shiftHours': 'Shift hours: <%=N%> hour<%=S%>',
		'dailyTotal': 'Daily total',
		'actualShiftHours': 'Actual shift hours: <%=N%> hour<%=s%>',
		'everyHourOfWorkMinuteOfRest': 'For every <%=H%> hour<%=Hs%> of work, <%=M%> minute<%=Ms%> of rest are required.',
		'previousDay': 'Previous day',
		'currentDay': 'Current day',
		'followingDay': 'Following day',
		'restTemp': 'Rest for <%=M%> minute<%=MS%> every <%=H%> hour<%=HS%>.',
		'weeklyTemp': 'Weekly: Rest for <%=M%> minute<%=MS%> every <%=H%> hour<%=HS%>.',
		'fixedTimeTemp': 'Fixed time: <%=S%> - <%=E%>',
	},
	'hp.m3.m310230': {
		'reportSettings': 'Report Settings',
		'manpowerStatisticsbyPeriod': 'Manpower Statistics by Period',
		'startendtime': 'Start/end time',
		'shiftGroupIsNotSet': 'Shift group is not set.',
	},
	'hp.m4.m410090': {
		'62-bonusForExceeding': '62-Bonus for exceeding four times the monthly insured amount for the cumulative total of the year for the insured unit.',
		'63-nonInsuredUnits': '63-Salary income paid by non-insured units.',
		'65-incomeFromProfessionalPractice': '65-Income from professional practice.',
		'66-dividendIncome': '66-Dividend income.',
		'67-interestIncome': '67-Interest income.',
		'68-rentalIncome': '68-Rental income.',
		'reportType': 'Report type',
		'corporateTaxIDNo.': 'Corporate tax ID no.',
		'period': 'Period',
		'result': 'Result',
		'details': 'Detail',
		'insurancePremiumProofSearch': 'Insurance Premium Proof Search',
		'proof': 'Proof',
		'laborInsurancePremiumDetailsItem': 'Labor insurance premium details',
		'yearMonthOfHealth': 'Year/month',
		'yearMonthOfLabor': 'Year/month',
		'actualPaidLaborInsurancePremium': 'Actual paid labor insurance premium',
		'healthInsurancePremiumDetailsItem': 'Health insurance premium details',
		'relationship': 'Relationship',
		'actualPaidHelathInsurancePremium': 'Actual paid helath insurance premium',
		'laborAndHealthInsurancePremiumDetails': 'Labor and health insurance premium details',
		'TotalActualPaidInsurancePremium': 'Total actual paid insurance premium',
		'proofOfLaborInsuranceAndHealthInsurancePremiums': 'Proof of labor insurance and health insurance premiums',
		'IDNumber': 'ID number',
		'dateOfBirth': 'Date of birth',
		'healthInsurancePremium': 'Health insurance premium',
		'laborInsurancePremium': 'Labor insurance premium',
		'totalInsurancePremium': 'Total insurance premium',
		'nationalHealthInsurance': 'National Health Insurance',
		'certificateOfSupplementaryInsurancePremium': 'Certificate of supplementary insurance premium',
		'unifiedBusinessNumberForDeductionUnit': 'Unified business number for deduction unit',
		"taxpayersIDNo": "Taxpayer's ID No.",
		'incomeCategory': 'Income category',
		'taxpayersName': "Taxpayer's name",
		'taxpayersAddress': "Taxpayer's address",
		'yearOfPayment': 'Year of payment',
		'totalAmountPaid': 'Total amount paid',
		'amountOfSupplementaryInsurancePremiumWithheld': 'Amount of supplementary insurance premium withheld',
		'deductionUnit': 'Deduction unit',
		'name': 'Name',
		'taxWithholders': 'Tax withholders',
		'incomeCategoryExplain': 'Income category',
		'accurate': 'The above information has been verified to be accurate and correct.',
		'corporateTaxIDNumber': 'Corporate tax ID number',
		'companyName': 'Company name:',
		'companyAddress': 'Company address:',
		'nameOfTheResponsiblePerson': 'Name of the responsible person :',
		'fiscalYear': 'Fiscal year',
		'myself': 'Myself',
		'address': 'Address',
		'page': 'Page : <%=temp1%>／<%=temp2%>',
		'noInformation': 'No information available. Try to search again!',
		'amountInNT': 'The amount is calculated in New Taiwan Dollars.',
		'dateOfCompilation': 'Date of compilation : ',
		'groupInsuranceApplicantNo': 'Group insurance applicant no.',
		'proofOfPremium': 'Proof of premium',
		'premiumDetails': 'Premium details',
		'proofOfSupplementaryPremium': 'Proof of supplementary premium',
		'healthInsurancePremiumDetails': 'Health insurance premium details',
		'laborInsurancePremiumDetails': 'Labor insurance premium details',
	},
	'hp.m4.m410030': {
		'fiscalYear': 'Fiscal year',
		'noTaxWithholdingForm': 'No tax withholding form',
		'taxWithholdingFormSearch': 'Tax Withholding Form Search',
		'theInquiryFunctionIsCurrentlyUnavailable.': 'The inquiry function is currently unavailable.',
		'parameterFileLoadingError': 'Parameter file loading error',
		'taxWithholdingFormLoadingError': 'Tax withholding form loading error',
		'noTaxWithholdingFormFor': 'No tax withholding form for <%=temp1%>.',
		'incomeLessThan1000 ': 'Income less than NT$1,000  does not require a withholding tax form in <%=temp1%>',
		'taxWithholdingForm': '-Tax Withholding Form.pdf',
	},
	'hp.m5.m510050': {
		'applicantApproverFormNo': 'Applicant/Approver/Staff be changed/Form no.',
		'deleteByBatch': 'Delete by Batch',
		'cancelArchivingByBatch': 'Cancel Archiving by Batch',
		'generalForm': 'General Form',
		'archivedForm': 'Archived Form',
		'rquestLeaveOver': 'Request time/Leave time/Overtime/Shift adjustment time',
		'unableToWithdrawOrDelete': 'Unable to withdraw or delete form.',
		'withdrawalFailed': 'Withdrawal failed: The form has already been withdrawn, deleted, approved, or settled by someone else, so it cannot be withdrawn.',
		'deletionFailed': 'Deletion failed.',
		'confirmDeletion': 'Confirm deletion',
		'deletionCompleted': 'Deletion completed.',
		'reason': 'Reason',
		'confirmWithdrawn': 'Confirm withdrawn',
	},
	'hp.m4.m410200': {
		'shiftType': 'Shift type:',
		'calendar': 'Calendar: ',
		'shift': 'Shift: ',
		'noEmployeeAttendanceRulesOrCalendars': 'No employee attendance rules or calendars established.',
		'leaveOvertimeDetails': 'Details',
		'annualSchedule': 'Annual schedule',
		'monthlySchedule': 'Monthly schedule',
		'loadingFailed': 'Loading failed.',
		'beforeTheChange': 'Before change',
		'afterTheChange': 'After change',
		'notScheduled': 'Not scheduled:',
		'loadingOfShiftDataFailed': 'Loading of shift data failed.',
		'leaveAbbreviation': 'Leave',
		'leave': 'Leave',
		'leaveTime': 'Leave:',
		'leaveResumption': 'Leave resumption:',
	},
	'h2.am.ShiftingSidePanelComps': {
		'workingHoursStatistics': 'Working hours statistics',
		'hoursDays': 'Hours/days',
		'scheduledHours': 'Scheduled hours',
		'numberOfUnscheduledDays': 'Number of unscheduled days',
		'shouldBeScheduled': 'Should be scheduled',
		'alreadyScheduled': 'Already scheduled',
		'difference': 'Difference',
		'statisticsOfFlexibleWorkingHoursIntervals': 'Statistics of flexible working hours intervals',
		'period': 'Period',
		'workingHours': 'Scheduled working hours',
		'publicHolidays': 'Public holidays',
		'restDays': 'Rest days',
		'theCycleDaysAreNotMet': 'The cycle days are not met.',
		'calendarStatistics': 'Calendar statistics',
		'shiftStatistics': 'Shift statistics',
		'shift': 'Shift',
		'labelStatistics': 'Label statistics',
		'leaveOvertimeStatistics': 'Leave/overtime statistics',
		'hoursTimes': 'Hours/times',
		'overtimeHours': 'Overtime hours',
		'leaveHours': 'Leave hours',
		'totalFullDayLeaveInstances': 'Total full-day leave instances',
		'project': 'Item',
		'hour': 'hour',
		'day': 'day',
		'days': 'Days',
		'unitOfDays': 'Number of',
		'calendar': 'Calendar',
		'shiftLabel': 'Shift label',
		'times': 'Times',
		'secondary': 'time',
		'onlyWorkingDays': 'Working day only',
	},
	'hp.m5.m510040': {
		'formName': 'Form name',
		'firstSubstitute': 'First substitute',
		'secondSubstitute': 'Second substitute',
		'agentStatus': 'Proxy status',
		'signOffAgentTime': 'Proxy approval time',
		'selectSubstitute': 'Select substitute',
		'atLeastOneSubstitute': 'At least one substitute is required.',
		'proxyTime': 'Proxy time',
		'atLeastOneInterval': 'At least one interval is required.',
		'setSubstituteApprover': 'Set Substitute Approver',
		'batchSettings': 'Batch settings',
		'substituteApproverBatchSettings': 'Set Substitute Approver - Batch Settings',
		'selectForms': 'Select forms',
		'applyTheSettings': ' Apply the settings above to the selected forms.',
		'noFormDataFound': 'No form data found.',
		'theModificationOfApproverSubstituteSettingsIsComplete': 'The modification of approver substitute settings is complete.',
		'theModificationOfApproverSubstituteSettingsFailed': 'The modification of approver substitute settings failed.',
		'theFormDoesNotExist': 'The form does not exist.',
		'theEndDateOfTheProxyTimeIsBeforeTheSetDate': 'The end date of the proxy time is before the set date. Please reset it.',
		'noProxyTimeConflictIsAllowed': 'No proxy time conflict is allowed. Please reset it.',
		'theProxyStartAndEndTimesCannotOverlap': 'The proxy start and end times cannot overlap. Please reset it.',
		'savedSuccessfully': 'Saved successfully.',
		'batchSettingsFailed': 'Batch settings failed.',
		'pleaseSelectForms': 'Please select forms.',
	},
	'hp.m3.m310210': {
		'subordinateShift': 'Subordinate Shift',
		'downloadReport': 'Download',
		'reports': 'Reports',
		'failedToExportTheReport': 'Failed to export the report.',
		'noDataAvailableForExport': 'No data available for export. Please reset the export criteria.',
		'shiftStartEndTime': 'Shift start/end date',
		'pleaseSetTheShiftStartEndTime': 'Please set the shift start/end time.',
		'allEmployees': 'All employees',
		'specificEmployees': 'Specific employees',
		'reportType': 'Report type',
		'shiftHoursSummary': 'Shift hours summary',
		'employeePeriod': 'Manpower details by employee/period',
		'shiftDate': 'Manpower statistics by shift/date',
		'shiftAndDate': 'Statistics by shift and date',
		'periodDate': 'Manpower statistics by period/date',
		'periodAndDate': 'Statistics by period and date',
		'totalShiftHours': 'Total shift hours',
		'totalClockInHours': 'Total clock-in hours',
		'totalOvertimeHours': 'Total overtime hours',
		'totalLeaveHours': 'Total leave hours',
		'shiftReport': 'Shift Report',
		'totalManpowerHours': 'Total manpower/hours',
		'timeUnit': 'Time unit: ',
		'shiftToN': 'Shift (<%=N%>)',
		'shiftHours': 'Shift hours',
		'clockInHours': 'Clock-in hours',
		'employee': 'Employee: ',
		'totalEmployee': ' Total <%=N%> employee<%=S%>.',
		'specificReport': 'Specific employees.',
	},
	'hp.m2.m210021': {
		'tree': 'Tree',
		'pyramid': 'Pyramid',
		'display': 'Display',
		'proportion': 'Proportion',
		'deptHead': 'Dept. head',
		'closedDpet': 'Closed dept.',
		'deptHeadCount': 'Departmental headcount',
		'noCurrentSupervisor': 'No current supervisor',
		'noSupervisorAssigned': 'No supervisor assigned',
		'noCurrentDeputySupervisor': 'No current deputy supervisor',
		'noDeputySpuerviseorAssigned': 'No deputy supervisor assigned',
		'code': 'Code',
		'name': 'Dept.',
		'abbr': 'Abbr.',
		'supervisor': 'Supervisor',
		'deputySupervisor': 'Deputy supervisor',
		'upperDept': 'Upper dept.',
		'organizationLevel': 'Organization level',
		'deptAddress': 'Address',
		'deptEnglishAddress': 'English address',
		'tel': 'Tel.',
		'fax': 'Fax',
		'note': 'Note',
		'status': 'Status',
		'noOrganizationalData': 'No data available.',
		'noMatchData': 'No data available.',
		'dataNotEffectSearchCriteria': 'The data may not have taken effect yet. We suggest consulting with the system administrator or resetting the search criteria.',
		'expandFromDept': 'Expand from this department.',
		'onlyDisplay': 'Only display',
		'subDept': 'the sub-departments of the',
		'onlyDisplaySunDept': 'Only display the sub-departments of the',
		'restoreOrganizationChart': 'Restore the entire organization chart.',
	},
	'hp.m3.m310410_new': {
		'theNameOfTheSchedule': 'Shift name',
		'enterAScheduleName': 'Enter shift name',
		'scheduleTime': 'Shift time',
		'scheduleFrom': 'Start date',
		'timetableAttendance': 'End date',
		'holidaysTotalTempDays': 'Holidays (<%=temp1%> day<%=s%> in total)',
		'shiftStaff': 'Shift Member',
		'pleaseSelectAShiftGroup': 'Shift group',
		'editMembers': 'Edit member',
		'pleaseSelectYourRegularClass': 'Common shift',
		'pleaseSelectAFrequentlyUsedTag': 'Common label',
		'employeePreScheduling': 'Employee pre-scheduled shift',
		'rowableTypes': 'Types of shifts that can be scheduled',
		'allowEmployeesToPrescheduleShiftsWhen': 'When allowing employees to pre-schedule their shift, the types of shifts that can be scheduled.<%=temp1%> For example, if allowing employees to schedule rest days, employees cannot schedule national <%=temp1%>holidays and statutory holidays.If allowing employees to schedule "leave", it only means that <%=temp1%>employees can pre-book leave, and actual leave still requires submitting a leave application form.',
		'employeesCanBeScheduledForShifts': 'Types of shifts employees can schedule',
		'pleaseSelectTheEmployeeAvailableShifts': 'Types of shifts employees can schedule.',
		'openSchedulingHours': 'The time available for scheduling',
		'ifTheScheduleStartsAndEnds': 'If the shift period is from 7/1 to 7/30, and the time available for scheduling is 10 to 5 days before, then employees can pre-schedule shifts from 6/21 to 6/26.',
		'theScheduleStartsBeforeTheDate': 'Before the start of the shift',
		'pleaseEnter': 'Number',
		'sky': 'days',
		'daysYouCanSchedule': 'Employees can arrange the shift for <%=temp1%> to <%=temp2%>, starting from <%=temp3%> to <%=temp4%>.',
		'openToViewOtherEmployeesPre': 'Enable viewing of the pre-scheduled shifts for other employees',
		'canEmployeesViewOtherStaffSchedules': 'Can employees view the shifts of other employees within the same roster?',
		'editTheRoster': 'Edit Shift Member',
		'thereShouldBeAtLeastOne': 'At least one employee must be scheduled.',
		'aTotalOfPersonnelWereIncluded': 'Total of <%=temp1%> employees are included in the schedule.',
		'storageToTheNextStep': 'Save and to next step',
		'itMustNotBeLessThan': 'The time cannot be earlier than the following time.',
		'failedToSaveScheduleTheAvailable': 'Failed to save the schedule: The schedulable types in the pre-scheduled table for employees must include both shifts and tags.',
		'ifYouChangeTheScheduleTime': 'If you change the schedule time, the content of the schedule will be cleared. Are you sure you want to change it?',
		'failedToAddASchedule': 'Failed to add the schedule.',
		'theScheduleDoesNotExist': 'The schedule does not exist.',
		'duplicateScheduleNames': 'Duplicate schedule name.',
		'shiftGroupDisabled': 'The shift group is disabled. Please select another one.',
		'thereAreNoScheduledStaffPlease': 'No schedulable personnel. Please recheck.',
		'saveAndPublishSchedules': 'Save and publish shift',
		'theStorageScheduleWasSuccessful': 'Schedule saved successfully.',
		'addedASchedule': 'Add shift',
		'addedAScheduleDlg': 'Add Shift',
		'setScheduleProperties': 'Set shift schedule attributes',
		'editTheSchedule': 'Edit shift schedule',
		'deleteTheScheduleAndYouRe': 'Schedule deletion completed.',
		'deleteAScheduleError': 'Deleting schedule error.',
		'areYouSureYouWantTo': 'Are you sure you want to delete these <%=temp1%> schedules?',
		'scheduleStatus': 'Status',
		'reasonsForRejection': 'Reason for rejection',
		'unpublish': 'Publish has been canceled.',
		'stockpile': 'Save',
		'cancelThisSchedule': 'Cancel this schedule?',
		'theScheduleHasnTBeenSaved': 'The schedule has not been saved yet, are you sure you want to cancel it?',
		'goBackToThePreviousStep': 'Back',
		'pleaseMakeSureThatTheSchedule': 'Please ensure the schedule has been saved to avoid data loss.',
		'areYouSureYouWantTo2': 'Are you sure you want to go back to the previous step?',
		'time': 'Search range',
		'inShifts': 'Scheduling',
		'toBeReviewed': 'Approving',
		'published': 'Published',
		'reasonsForRejectionOfSchedules': 'Reason for Rejecting the Shift',
		'className': 'Shift name: ',
		'dismissalOfThePerson': 'Rejecter',
		'timeOfRejection': 'Rejection time',
		'unpublishTheSchedule': 'Unpublish shift',
		'theScheduleWasUnpublishedSuccessfully': 'Canceling schedule publication succeeded.',
		'failedToUnpublishSchedule': 'Canceling schedule publication failed.',
		'oKToUnpublish': 'Confirm',
		'areYouSureYouWantTo3': 'Are you sure you want to cancel the publication of this schedule?',
		'manpowerStatistics': 'Manpower statistics',
		'failedToDownloadTheSummaryTable': 'Failed to download the schedule.',
		'thereIsNoDataToExport': 'No data available for export. Please reconfigure the export conditions.',
		'theDatePeriodMustBeWithin': 'Query limit is 2 months.',
		'onlyPublishedSchedulesAreDownloaded': 'Only download published shifts.',
		'exportTheObject': 'Export target',
		'approver': 'Reviewer',
		'endDateAfterStartDate': 'End date must be on or after start date.',
		'maxPeople': 'The maximum number of people on duty is 60.',
	},
	'hp.m3.m310410': {
		'myNewSchedule': 'The Schedule I Added',
		'theScheduleIReviewed': 'The Schedule I Reviewed',
	},
	'hp.m3.m310410_statistics': {
		'actualShiftHoursHours': 'Actual shift hours: <%=temp1%> hour<%=s%>.',
		'realTimeManpowerStatistics': 'Real-Time Manpower Statistics',
		'shiftStagingFailed': 'Shift staging failed.',
		'failedToReadParameters': 'failed to read parameters.',
		'failedToExportShiftStatistics': 'failed to export the shift statistics.',
		'realTimeClassManpowerStatistics': 'Real-Time Statistics by Shift',
		'realTimeManpowerStatisticsForPeriods': 'Real-Time Statistics by Period',
		'downloadTheReport': 'Download report',
		'employees': 'employees',
		'startendtime': 'Time',
		'realTimeShiftReport': 'Real-Time Manpower Statistics Report by Shift',
		'realTimeSectionReport': 'Real-Time Manpower Statistics Report by Period',
	},
	'hp.m3.m310410_shifting': {
		'ndSection': 'Two shifts',
		'failedToGetTheSchedule': 'Failed to retrieve the schedule.',
		'workingHours': 'Working hours: <%=temp1%>',
		'allowableOvertimeHours': 'Overtime is allowed: ',
		'prohibitionOfOvertimeHours': 'Overtime is prohibited: ',
		'clearThemAll': 'Clear all',
		'overlappingWorkingHours': 'Work hours overlap.',
		'theCalendarTimeOfTheClass': 'Shift calendar days are different.',
		'theOvertimeAttributionDaysOfThe': 'Shift overtime attribution days are different.',
		'temp': '<%=temp1%> and <%=temp2%><%=temp3%>',
		'temp1': '<%=temp1%>~<%=temp2%> and <%=temp3%>~<%=temp4%> <%=temp5%>',
		'overlapsWithRestTime': '<%=temp1%>~<%=temp2%>  overlaps with <%=temp3%>~<%=temp4%> in rest time.',
		'shiftSchedules': 'Shift',
		'thereAreNoScheduledShiftsOn': 'No shifts scheduled on working days.',
		'theClassIsFullAndNo': 'The shift is fully booked, unable to add more shifts.',
		'aMaximumOfScheduleTagsCan': 'A maximum of <%=temp1%> scheduling tags can be added to each shift.',
		'thereAreDaysOfClassesAre': 'There are <%=temp1%> days with fully booked shifts, unable to add more shifts.',
		'thereAreStaffClassesAreFull': 'There are <%=temp1%> employees with fully booked shifts, unable to add more shifts.',
		'scheduleStatistics': 'Schedule Statistics',
		'theScheduleHasBeenScheduledSection': '<%=temp1%> segments of shifts have been scheduled, unable to reduce the number of schedulable shifts.',
		'thereIsAnErrorInThe': 'There are errors in the schedule, unable to save the temporary file.',
		'theImportWasSuccessful': 'Import successfully.',
		'thereIsNoScheduleInformationTo': 'No schedule data to save.',
		'thereIsAnErrorInThe2': 'There are errors in the schedule, unable to save.',
		'performAComparisonOfStoredData': 'Performing data comparison for saving.',
		'saveTheError': 'Save error.',
		'someOfTheStaffHaveChanged': "Some employees' scheduled hours have changed. Do you want to leave the website?",
		'optionToCollapse': 'Close',
		'shiftsCanBeScheduledDaily': 'Daily schedulable shifts',
		'incomingClassScheduling': 'Import rotating shifts (by shift)',
		'importTimeSlotScheduling': 'Import rotating shifts (by period)',
		'roundRobinScheduling': 'Cyclic scheduling',
		'clearTheSchedule': 'Clear shift',
		'importEmployeeSchedules': 'Import pre-scheduled shifts',
		'batchJobs': 'Batch',
		'other': 'Others',
		'areYouSureYouWantTo': 'Are you sure you want to clear all shift data for this schedule?',
		'day': 'Day <%=temp1%>: <%=temp2%>',
		'breaksOverlapWithMultipleShifts': "Rest time overlaps with multiple shifts' work hours.",
		'theSetupIsComplete': 'Settings completed.',
		'noTimeSlotSchedulingEmployeeData': 'No employee data for rotating shifts (by period).',
		'areYouSureYouWantTo2': 'Are you sure you want to apply the new rules, replacing the current schedule data?',
		'theClassScheduleScreenImportFormat': 'ScheduleImportFormat.xlsx',
		'selectThePersonOnTheRoster': 'Select scheduling personnel.',
		'timeManagementRulesAreNotBeing': 'Not Compliant With The Working Hours Rules',
		'theTimeRuleCheckFailed': 'Work hour rule check failed.',
		'thereIsNoExportMaterial': 'No export data.',
		'employeesOtherEmployeesEmployeesATotal': '<%=temp1%> <%=temp2%> employees + other <%=temp3%> employees, total <%=temp4%> employees.',
		'scheduleStartAndEndTimes': 'Shift start/end time',
		'theTypeOfWorkException': 'Abnormal types',
		'violationOfTheRules': 'Violation of rules',
		'exceptionDate': 'Abnormal date.',
		'allEmployeesInTheShiftAre': 'All employees in the schedule comply with work hour rules check.',
		'theTypeOfWorkException2': 'Type of work abnormality.',
		'anomalyIntervals': 'Abnormal period',
		'workProjects': 'Rules',
		'schedulesStoreResults': 'Shift Schedule Saving Result',
		'saveShiftFailed': 'Failed to save the schedule.',
		'shiftStaff': 'Shift member:',
		'classScheduleStartsAndEndsTimetable': 'Shift schedule start and end times:',
		'workingHoursRuleReminder': 'Total of <%=temp1%> entries, including <%=temp2%> reminders of working hours rule.',
		'executionResult': 'Execution result',
		'theResultOfTheWorkHour': 'Work hour abnormality check result',
		'reminderCount': 'Reminders',
		'numberOfStrokesIsProhibited': 'Prohibitions',
		'pen': '<%=temp1%> entries',
		'remindersOfAbnormalWorkingHours': 'Work hour abnormality reminder.',
		'theTimeRulesAreNotBeing': 'Did Not Comply With Work Hour Rules',
		'scheduledEmployeesHaveBeenSelected': 'Selected scheduling employees.',
		'schedule': 'Shift schedule',
		'offDays': 'Took vacations',
		'offFullDays': 'Whole day off',
		'deformPeriod': 'Shift rotation for flexible working hours',
		'shifting': 'Shift data',
		'leaveName': 'Holidays',
		'restTemplate': 'Cycle: For every <%=H%> hour<%=HS%> of work, <%=M%> minute<%=MS%> of rest are required.',
		'sumFile': 'Shift summary',
		'totalStaff': '<%=N%> employees in total',
		'totalStaff2': '<%=N%> employee in total',
		'shiftResult': 'Shift saving result',
		'failSchedule': 'InvalidSchedule',
		'areYouSureYouWantTo3': 'Are you sure you want to clear the schedule data in batch?',
	},
	'hp.m3.m310410_extra': {
		'employees': '<%=temp1%> <%=temp2%> employees in total.',
		'checkTheWorkingHours': 'Check working hours',
		'exportSchedules': 'Export',
		'failedToExportSchedules': 'Failed to export the schedule.',
		'allEmployeesInTheSchedule': 'All employees within the shift',
		'partOfTheStaff': 'Some employees.',
		'theScheduleDisplaysInformation': 'Info.',
		'classScheduleContent': 'Filters',
		'showHolidayNonWorkingDay': 'Display holidays (non-working days)',
		'calendarExportFormat': 'Export format of the calendar',
		'shiftExportFormat': 'Export format of the shift',
		'shiftLabelExportFormat': 'Export format of the shift label',
		'someDatesArePastTheSchedule': 'Some dates exceed the schedule change deadline.',
		'schedulingDataIsAvailable': 'Scheduling data already exists.',
		'violationOfWorkingHoursRulesReminders': 'Violation of work hour rules (reminder).',
		'employeesAreNotScheduledEmployeesOn': 'Some dates for the employee are not scheduled.',
		'importClassSchedules': 'Import Rotating Shifts (By Shift)',
		'theImportFormatIsIncorrect': 'Import format error.',
		'theNumberOfShiftsThatEmployees': 'Different number of schedulable shifts for employees.',
		'scheduleDatesAreNotConsecutive': 'Non-consecutive schedule dates.',
		'theNumberOfScheduleDaysExceeds': 'The number of schedule days exceeds the limit.',
		'exceedingTheNumberOfShiftsThat': 'Exceeds the number of schedulable shifts.',
		'pleaseDoNotChangeTheImport': 'Do not modify the schedule import format, as it may cause the schedule to fail to import.',
		'ifYouAreSureThatYou': 'After import, the previewed schedule content will be overwritten. If you are sure you want to update the schedule data, be sure to click the "Save Schedule" button for the update to succeed.',
		'theCalendarIsCombinedWithDifferent': 'Combine calendar and shift type, without labels.',
		'theCalendarIsCombinedWithTags': 'Combine calendar and shift, including labels.',
		'calendarClassesAreNotCombined': 'Calendar and shift not combined.',
		'numberOfShiftTags': 'Number of scheduling tags',
		'importFormat': 'Import type',
		'calendarTempOrClass': 'Combine calendar <%=temp1%> or shift',
		'incorrectFormatting': 'Incorrect format.',
		'required': '(Required)',
		'optional': '(Optional)',
		'abnormalData': 'Abnormal data:',
		'downloadTheResultsOfTheTime': 'Download work hour check results.',
		'importTimeSlotSchedules': 'Import Rotating Shifts (By Period)',
		'employeesOtherEmployeesEmployeesATotal': '<%=temp1%> <%=temp2%> employees + <%=temp3%> other employees <%=temp4%> employees, total <%=temp5%> employees.',
		'classScheduleStartsAndEndsTimetable': 'Shift start/end time:',
		'shiftStaff': 'Shift member:',
		'succeed': 'success:',
		'failed': 'failed:',
		'workingHoursRuleReminderTransactions': '<%=temp1%> entries (work hour rule reminders: <%=temp2%> entries), <%=temp3%>',
		'itCannotBePublishedBecauseThere': 'Due to failed data, it cannot be published.',
		'confirmTheRelease': 'Confirm',
		'theReleaseWasSuccessful': 'Published successfully.',
		'reminderOfWorkingHours': 'Total of <%=temp1%> entries, including <%=temp2%> reminders of working hours rule.',
		'importEmployeeSchedules': 'Import pre-scheduled shifts<%=temp1%>',
		'onceAnEmployeeScheduleIsImported': '!After importing the pre-scheduled shifts, the employee will not be able to perform pre-scheduling operations.',
		'pleaseCheckAtLeastOneEmployee': 'Please select at least one employee.',
		'previewStatus': 'Status',
		'importSchedules': 'Import shift',
		'reflowIsAllowed': 'Allow rearrangement',
		'toBeContinued': 'Unfinished',
		'imported': 'Imported.',
		'notImported': 'Not imported',
		'totalPeople': 'Total of <%=temp1%> employee.',
		'peopleWhoHaveCompletedThePre': '<%=temp1%> employees have completed the pre-scheduling.',
		'tempPeopleWhoHaveNotCompleted': '<%=temp1%> employees have not completed the pre-scheduling.',
		'lastSent': 'Last sent time: <%=temp1%>',
		'sendReminderNotifications': 'Send schedule reminder notification',
		'theReminderLetterWasSentSuccessfully': 'Schedule reminder email sent successfully.',
		'openReschedule': 'Allow "<%=temp1%>" for schedule rearrangement?',
		'statisticalReports': 'Statistics',
		'scheduleStatisticsReport': 'Shift Statistics',
		'failedToReportForm': 'Failed to export the report.',
		'partOfTheStaff2': 'Specific employees',
		'theNameOfTheReport': 'Report',
		'employee2': '<%=temp1%> <%=temp2%> employee in total.',
		'sectionImportSample1': 'Combine calendar and shift type, without labels(Period)',
		'sectionImportSample2': 'Combine calendar and shift, including labels(Period)',
		'sectionImportSample3': 'Calendar and shift not combined(Period)',
		'scheduleOrShift': 'Calendar and shift',
		'feteOrShift': 'Holiday or shift name',
		'unauthorized': 'Incorrect shift type during whole schedule, or unauthorized employee.',
		'containsError': 'Invalid data.',
		'staffIdRequired': 'Demand of staff ID.',
		'has': 'Contains',
		'fatal': 'Error Message',
		'shiftMemberOnly': 'Only scheduled members are allowed to import.',
		'shiftDeadlineExceeded': 'Exceed the schedule change deadline.',
		'notShiftingStaff': 'Incorrect shift type on this date.',
		'unauthorizedSection': 'Not period staff during whole schedule, or unauthorized employee.',
		'calendarMissed': 'Holiday type not found.',
		'shiftMissed': 'No such shift found.',
		'calendarAndShiftMissed': 'Neither holiday nor shift found.',
		'tagMissed': 'Shift label not found.',
		'tagNoMapping': 'Label without corresponding shift found.',
		'jobFrom': 'Work beginning time',
		'jobEnd': 'Work finishing time',
		'restFrom': 'Break beginning time',
		'restEnd': 'Break finishing time',
		'noFixShift': 'Fixed shift type staff is prohibited.',
		'noWorkShift': 'Rotating shift type staff is prohibited.',
		'unauthorizedType': 'Incorrect shift type staff, or unauthorized employee.',
		'staffMissing': 'Employee number not exists.',
		'dateMalformed': 'Wrong time format.',
		'workPartial': 'Incomplete working time.',
		'restPartial': 'Incomplete breaking time.',
		'repetitiveShift': 'Duplicate scheduling data.',
		'defyBanRule': 'Violation of work hour rules (prohibited).',
	},
	'hp.m3.m310410_cycle_dup': {
		'failedToLoadEmployeeProfile': 'Failed to load employee data.',
		'employeesScheduledForAllTimeSlots': 'All employees with rotating shifts (by period) in the schedule.',
		'employeesScheduledForAllShiftsIn': 'All employees scheduled for shifts within the shift',
		'specificEmployees': 'Specific employees',
		'startAndEndTime': 'Date',
		'startEndTime': 'Start time',
		'startEndTimeYet': 'End time',
		'dayNth': 'The Xth day',
		'classesAndLabels': 'Shift and label',
		'customizeWorkingHoursAndLabels': 'Custom work hours and tags.',
		'pleaseSelectAClass': 'Shift',
		'customizeWorkingHours': 'Custom work hours.',
		'breaks': 'Rest start/end time',
		'copyTheCalendar': 'Copy calendar.',
		'failedToMountCalendarData': 'Failed to load calendar data.',
		'calendarPreview': 'Calendar preview.',
		'schedulingPatterns': 'Type',
		'roundRobinClassOrder': 'Cycle class order',
		'employees': 'Employees',
	},
	'hp.m3.m310410_audit': {
		'rejectionOfSchedules': 'Reject the Shift',
		'determineTheRejection': 'Confirm',
		'mandatoryReasonForRejectionMaximumWords': 'Rejection reason is required. Up to 300 characters.',
		'theSystemIsAbnormalAndThe': 'System error. Data write failure.',
		'reviewTheSchedule': 'Shift Schedule',
		'rejectionOfTheScheduleIsCompleted': 'Rejection of schedule completed.',
		'approvalSuccessful': 'Approval successful.',
		'theScheduleHasBeenApprovedBy': '<%=temp1%> schedules have been signed off by others, so you no longer need to handle them.',
		'reviewTheReasonForTheRejection': 'Rejection reason',
	},
	'h2.am.Shifting': {
		'leave': 'Leave.',
		'leavePeriod': 'Leave:',
		'cancellationTime': 'Leave resumption:',
		'customShiftFailureTheBreakOverlaps': 'Custom shift failed: Rest time overlaps with multiple shift work times.',
		'customizeYourClass': 'Customize the shift',
		'workingHours': 'Work start/end time',
		'customClassFailed': 'Custom shift failed:',
		'confirm': 'Confirm',
		'timeSlotScheduling': 'Rotating shifts (by period)',
		'noEditingPermissions': 'No editing permissions.',
		'tempHours': '<%=temp1%> hour<%=s%>',
		'tempDays': '<%=temp1%> day<%=s%>',
		'violationOfWorkingHourRules': 'Violation of work hour rules.',
		'scheduleError': 'Schedule error.',
		'ifThereIsNoInformationThat': 'No data matching the search criteria. Please relax the criteria and search again.',
		'ifThereIsNoDataThat': 'No data matching the search criteria. Click the button below to directly select scheduling employees.',
		'selectTheEmployee': 'Select employees.',
		'failedToCreateATag': 'Failed to create tag.',
		'otherErrors': 'Other errors.',
		'enterAnEmployeeKeywordQuery': 'Keywords\t',
		'editTheEmployee': 'Edit employee',
		'fieldSettings': 'Columns settings',
		'notYetInService': 'Failed to report to duty',
		'regularShifts': 'Fixed shift.',
		'dimission': 'Resigned',
		'stay': 'Leave without pay',
		'theRevisionPeriodHasPassed': 'The deadline for modifications has passed.',
		'thereIsNoNeedToSchedule': 'No scheduling required.',
	},
	'h2.am.ShiftingSidePanel': {
		'theResultOfTheWorkRule': 'Work hour rules check result.',
		'examine': 'Check',
		'lastCheckTime': 'Last check time.',
		'youHavenTCheckedYourSchedule': "You haven't checked the schedule yet.",
		'complyWithTimeRulesChecks': 'Complies with work hour rules check.',
		'forbid': 'Prohibition',
		'remind': 'Reminder',
		'manHourStatistics': 'Work hour statistics.',
		'beforeStorage': 'Before saving.',
		'afterStorage': 'After saving.',
		'difference': 'Difference',
		'shouldBeArranged': 'Should be scheduled.',
		'scheduled': 'Scheduled.',
		'leaveAndOvertimeDetails': 'Details',
		'scheduleCheckResults': 'Schedule check result.',
	},
	'h2.am.ShiftingConstants': {
		'nameStaff': 'Name/Staff ID',
		'remainingSpecialHolidayHours': 'Remaining annual leave (hours)',
		'remainingCompensatoryTimeOffHours': 'Remaining compensatory time (hours)',
		'actualCreditCardSwipingManHours': 'Actual clocked-in hours',
		'hoursShouldBeScheduled': 'Hours to be scheduled',
		'differentialWork': 'Difference in work hours.',
		'linedShouldBeArranged': 'Scheduled - To be scheduled.',
		'workingDaysShouldBeScheduled': 'Workdays to be scheduled.',
		'nationalHolidaysShouldBeScheduled': 'National holidays to be scheduled.',
		'restDaysShouldBeScheduled': 'Rest days to be scheduled.',
		'holidaysShouldBeScheduled': 'Regular holidays to be scheduled.',
		'shiftsShouldBeEmptied': 'Empty shifts to be scheduled.',
	},
	'hp.m4.m410210': {
		'shiftSchedules': 'Shift Pre-scheduling >',
		'rehearsingIsNoLongerAllowed': 'Prearrangement not allowed.',
		'unableToFindASavetableSchedule': 'Unable to save the schedule.',
		'storageSuccessful': 'Save successfully.',
		'savedAndSubmittedTheScheduleSuccessfully': 'Save and submit schedule successfully.',
		'rehearsableAvailable': 'Allow pre-scheduling',
		'unableToPreRehearse': 'Pre-scheduling is not available',
		'scheduledTime': 'Pre-scheduling period',
	},
	'hp.m3.m310410_inspection.index': {
		'jobCheck': 'Check position',
		'postManpowerCheck': 'Check Position Manpower',
		'classGroups': 'Shift Groups',
	},
	'hp.m3.m310410_inspection.group_config_dialog': {
		'selectAGroupClass': 'Shift',
	},
	'hp.m3.m310410_inspection.inspect_config': {
		'selectedClass': 'Shifts selected',
		'theFileFormatIsIncorrect': 'File format error',
	},
	'hp.m3.m310410_inspection.inspect_dialog': {
		'thereIsNoInformationAfterSelecting': 'There is no info. After selecting the shift, click + to set the manpower for the position in the shift.',
		'addedAClassGroup': 'Add new shift group',
		'classGroupSetting': 'Setting shift group',
		'postStaffingSample': 'Post Staffing import format',
		'postStaffingFail': 'Invalid post staffing',
		'tagState': 'Label status',
		'noEdit': 'Do not modify the import format. After importing, all current contents will be overwritten. If you are sure the correctness of the importing data, click the "Confirm" button for the configuration to be saved.',
		'notPlus': 'Not a positive integer.',
		'exceeded': 'Maximum exceeded.',
	},
	'hp.m3.m310410_inspection.view_dialog': {
		'noInformationTryToResetThe': 'No data. Please reset the staffing for the position.',
		'manpowerShouldBeArrangedForThe': 'Setting Staffing for the Position',
		'noteMeansThatTheDifferenceIs': "Note: '-' means the difference is equal to 0, '/' means the difference cannot be calculated",
	},
	'h2.am.ShiftingFieldSetting': {
		'pleaseSelectTheItemsYouNeed': "Please check the items you need, then drag '<%=temp1%>' to reorder.",
		'staffNameNameStaffEnglishName': 'Staff ID, name, name/staff ID, English name, select one required',
		'illustrate': 'Description',
	},
	'h2.am.ShiftingDialog': {
		'remainingSpecialHolidayHours': 'Remaining annual leave hours',
		'remainingCompensatoryHours': 'Remaining compensatory leave hours',
		'validStartDates': 'Start date for leave',
		'closedEndDays': 'End date for leave',
		'specialSabbaticalYear': 'Annual leave year',
	},
	'h2.am.ShiftingContext': {
		'realTimeScheduleStatistics': 'Real-time Shift Schedule Statistics',
	},
	'components.Pdf': {
		'download':	'  Download',
		'page': 'Page <%=temp1%>',
		'total': 'Total <%=temp1%>',
	},
	'sp.sa.am.emp.skd.autoInsertShift': {
		'code11': ' No specific working hours set.',
		'code12': ' Working hours overlap.',
		'code13': ' Rest time overlaps with the working hours of multiple shifts.',
		'code14': ' Rest time overlaps.',
		'code15': ' The end time of the working hours is earlier than the start time.',
		'code16': ' The end time of the rest period is earlier than the start time.',
		'code17': ' There is an error in the calendar data.',
	},
	'hp.m5.m510010.wf101': {
		'basicInfo': 'Basic Info.',
		'tripInfo': 'Trip Info.',
		'reasonAttachment': 'Reason / Attachment',
		'transStloc': 'Departure',
		'transDtloc': 'Destination',
		'number': 'Number',
		'km': 'km',
		'addTrip': 'Add',
		'delTrip': 'Delete',
		'transKm': 'Distance',
		'requiredTrans': 'The departure, destination, and distance are required fields.',
		'requiredRail': 'The departure and destination are required fields.',
		'verifyDeactivation': '<%=f%> "<%=n%>" is deactivated.',
		'verifyDeletion': '<%=f%> "<%=n%>" is deleted.',
		'sameTransportation': 'The departure and destination of the same mode of transportation cannot be the same.',
	},
	'104service.redirection': {
		490: 'Anomalous account status (locked, closed, unverified...). Please contact the system administrator.',
		491: 'Non-employees cannot use.',
		492: `Can't use without email.`,
		493: 'Service parameters not set, please contact 104 Corporation.',
		494: 'Unable to get service token, please contact 104 Corporation.',
		495: 'Service error, please contact 104 Corporation.',
		496: `Can't use with deactivated status.`,
		489: 'Both Chinese and English names contain only symbols, unable to use the 104 service. Please contact the system administrator.',
	},
	'sso.verify': {
		'verificationFailed': 'SSO Verification Failed',
		'linkExpired': 'This link has expired. Please request a new one.',
		'verificationSuccessful': 'SSO Verification Successful',
	}
};
